import React from 'react';
import { useHistory } from 'react-router-dom';
import { StaticRoomsProps } from 'types';
import styles from '../../styles.module.scss';

const StaticRooms: React.FC<StaticRoomsProps> = ({ literacyCheck }) => {
  const history = useHistory();

  return (
    <>
      <g
        className={`${styles.pointer} prefix__static-item`}
        onClick={() => literacyCheck('/next-room')}
      >
        <g transform="translate(230 440)">
          <polygon
            points="132.66 232.26 123.15 232.91 76.05 171.15 84.4 171.06 132.66 232.26"
            fill="#55a32a"
          />
          <path
            d="M104.08,164c5.24,6,4.66,11.63-21.33,11.53-28.87.87-36.42-4.93-40.72-11.33-4.14-6.15,3.81-10.69,23.64-10.77C88.94,153.6,99,158.14,104.08,164Z"
            fill="#55a32a"
          />
          <path
            d="M86.7,171c-28.16.72-35.63-4.89-39.93-11.08a4.65,4.65,0,0,1-1-3.8c-4.71,1.93-6,4.77-3.75,8.07,4.3,6.4,11.85,12.2,40.72,11.33,18.82.08,24.32-2.83,23.93-6.73C103.31,170.19,97.09,171.05,86.7,171Z"
            fill="#55a32a"
          />
          <path
            d="M153.77,231.23c1.66,2-8.25,3.78-21.6,4.74-13.71,1-25.63.66-27.11-1.41s7.94-5,21.46-5.84C139.7,227.88,152.13,229.29,153.77,231.23Z"
            fill="#55a32a"
          />
          <path
            d="M112.47,174.29c.87,1-11,2-27,2.24-16.47.23-30.78-.43-31.51-1.5S66.2,173,82.53,172.8C98.38,172.62,111.61,173.29,112.47,174.29Z"
            fill="#55a32a"
          />
          <polygon
            points="53.92 175.03 84.28 181.73 92.5 181.57 112.44 174.47 53.92 175.03"
            fill="#55a32a"
          />
          <path
            d="M62,176.19l-5.42.92s28.52,2,56.42-.42a49.29,49.29,0,0,1-5.67-.81S79.61,176.94,62,176.19Z"
            fill="#55a32a"
          />
          <path
            d="M50.23,154.34S43,158.24,46,164.41c3.42,7,18,10.8,18,10.8l-7.09-.35s-17.72-5.5-18.2-11.57a9.33,9.33,0,0,1,4.4-8.55Z"
            fill="#55a32a"
          />
          <path
            d="M81.6,154.6s12.48,3.83,18.61,9.73c6.87,6.6-.8,10.53-.8,10.53l5.93-.51s7.87-5.46-.22-11.12a67.66,67.66,0,0,0-16.25-8.17Z"
            fill="#55a32a"
          />
          <path
            d="M70.42,155.21a50,50,0,0,1,13.2,9.89c6,6.74,3.52,10.69,3.52,10.69l7.11-.27s1.09-6-5.28-11.8a58.23,58.23,0,0,0-11.47-8.29Z"
            fill="#55a32a"
          />
          <path
            d="M65,155.76s-1.9,3.9,2.1,10c4.5,6.9,13.2,10.76,13.2,10.76l-7.57,0S62,170.41,59.37,164.42c-2.53-5.76-1.28-8.5-1.28-8.5Z"
            fill="#55a32a"
          />
          <path
            d="M87.83,153.41s-5.61-.57-2.56-1.65,15.44,1.34,13.59,2.52c-1.49.95-11.09,1.2-14,.48A17,17,0,0,1,87.83,153.41Z"
            fill="#55a32a"
          />
          <path
            d="M45.8,153.43s4.65-1.08-1.34-1.9c-7.85-1.07-12,1.92-8,2.8s12.84,1.27,14.84.55C47.73,153.82,45.8,153.43,45.8,153.43Z"
            fill="#55a32a"
          />
          <path
            d="M95,154.77c.77.89-10.67,1.57-25.93,1.51-15.68-.06-29.24-.87-29.88-1.8S51,152.89,66.55,153C81.68,153.09,94.27,153.88,95,154.77Z"
            fill="#55a32a"
          />
          <path
            d="M72.89,148.43c.26.32-4,.53-9.52.47s-10.36-.37-10.6-.69,4.12-.53,9.7-.47S72.64,148.11,72.89,148.43Z"
            fill="#55a32a"
          />
          <path
            d="M39.22,154.48s3.72.23,8.9-2.37c4.58-2.3,4.65-3.9,4.65-3.9l20.12.22s.64,1,7.66,3S95,154.77,95,154.77Z"
            fill="#55a32a"
          />
          <path
            d="M42.29,154.1s5.17-.52.08-1.7-11,.86-5.15,2.52c3.49,1,7.63,1.21,14.36.9A69.37,69.37,0,0,0,42.29,154.1Z"
            fill="#55a32a"
          />
          <path
            d="M93.22,154.39s-5.58-.57-2.57-1.65,11.26,1,8.38,2.48c-1.74.91-5.21,1.09-11.94.75C88.88,155,93.22,154.39,93.22,154.39Z"
            fill="#55a32a"
          />
          <line x1="62.16" y1="148.77" x2="66.62" y2="154.17" fill="#55a32a" />
          <path
            d="M69.91,153.73c-2.16,0-6.38-.29-8.31-.23s-1,4,3.16,4.16,8.82.2,8.93-.38S72.17,153.78,69.91,153.73Z"
            fill="#55a32a"
          />
          <path
            d="M66.36,156.57c-2.76-.13-4.1-1.9-4.12-3.08H61.6c-1.93.06-1,4,3.16,4.16s8.82.2,8.93-.38a1.48,1.48,0,0,0-.17-.66A69.52,69.52,0,0,1,66.36,156.57Z"
            fill="#55a32a"
          />
          <path d="M56.69,148.73a8,8,0,0,1-3.86,7.41" fill="#55a32a" />
          <path d="M68.93,148.88s7.53,5.41,15.25,7.24" fill="#55a32a" />
          <path
            d="M72.89,148.43a70.84,70.84,0,0,0,17.31,5.39c9.72,1.67,6.75-.51,5.21-.66s-1.69.4-1.69.4"
            fill="#55a32a"
          />
          <path
            d="M72.89,148.43c.26.32-4,.53-9.52.47s-10.36-.37-10.6-.69,4.12-.53,9.7-.47S72.64,148.11,72.89,148.43Z"
            fill="#55a32a"
          />
          <path
            d="M69.63,146.38c1,1.22-2.23,2.17-7.22,2.12s-9.89-1.11-10.81-2.35S54,144,59,144.07,68.66,145.17,69.63,146.38Z"
            fill="#55a32a"
          />
          <path
            d="M64.71,147.46c-5-.06-9.82-1.11-10.74-2.33a.56.56,0,0,1-.06-.7c-1.9.37-2.85,1-2.31,1.72.92,1.24,5.78,2.29,10.81,2.35,4,0,6.83-.56,7.32-1.42A24.93,24.93,0,0,1,64.71,147.46Z"
            fill="#55a32a"
          />
          <path
            d="M67.89,142.9c4.79.57-1.51,2.55-6.82,2-5-.52-9.48-1.45-10.38-2.66s7.56-2.33,7.56-2.33S58.26,141.75,67.89,142.9Z"
            fill="#55a32a"
          />
          <path
            d="M65,143.16c4.81.57-1.8,2.44-7.24,2.13-7.19-.41-9.54-1.46-10.43-2.67s8.35-2.25,8.35-2.25S55.31,142,65,143.16Z"
            fill="#55a32a"
          />
          <path
            d="M57.72,141.39c-3.52-.49-8.32.34-7.22,1.56s6,1.62,8.06,1.51,2.61-.6,2.08-1.15c-.38.54-5.29,1-6.58.07-2.49-1.72,7.06-1.07,7.06-1.07Z"
            fill="#55a32a"
          />
          <path
            d="M53.46,148.47s-.81.7-4.76,3.26c-2.74,1.77-5.9,3-8.65,2.78s-3.91-1.73-.87-1.69,2,.41,2,.41"
            fill="#55a32a"
          />
          <path
            d="M52.77,153.28c-1.3,0-4.73-.1-5.86,0s-2.07,3.29,1.23,3.89a35.46,35.46,0,0,0,8.26.32C56.3,156.86,54.13,153.33,52.77,153.28Z"
            fill="#55a32a"
          />
          <path
            d="M51,156.41c2.11,1,4.3,1.37,5.46,1s1-2.44-.82-3.17a6.76,6.76,0,0,0-4.14-.75C49.48,153.6,47.28,154.55,51,156.41Z"
            fill="#55a32a"
          />
          <path
            d="M55.29,153.72c.44.35-.13,2.3-2.25,2s-2.12-1.54-.18-1.24"
            fill="#55a32a"
          />
          <path
            d="M79.58,153.46c1.19,0,4.36-.05,5.52,0s6.78,3.21,4.6,3.77a27.54,27.54,0,0,1-7.34.27C81.57,157,78.34,153.49,79.58,153.46Z"
            fill="#55a32a"
          />
          <path
            d="M85.9,156.54c-.44,1-2,1.32-3.74.92s-4.65-2.41-4-3.11.66-.88,2.85-.71S86.7,154.77,85.9,156.54Z"
            fill="#55a32a"
          />
          <path
            d="M77.81,153.86c.1.34,3.59,2.27,5.13,2s-.26-1.48-1.68-1.21"
            fill="#55a32a"
          />
          <path
            d="M69.14,178.14s19.58.42,34.16-.75C90.35,179.49,69.14,178.14,69.14,178.14Z"
            fill="#55a32a"
          />
          <path
            d="M64.51,157.51s-3.2,3.87,2.67,10c5,5.2,7.63,5.68,7.63,5.68s-6.46-6.17-8.44-8.75C63.52,160.69,64.51,157.51,64.51,157.51Z"
            fill="#55a32a"
          />
          <path
            d="M47.16,156.8s-6,4.13-.36,10.33c4.77,5.28,13.16,6.72,13.16,6.72S49.69,170.45,46.2,164C44.16,160.24,47.16,156.8,47.16,156.8Z"
            fill="#55a32a"
          />
          <path
            d="M74,157.28s9,3.82,12.5,9.81c3,5.12,1.25,5.64,1.25,5.64a75.05,75.05,0,0,0-5.09-8.64C79.79,160.43,74,157.28,74,157.28Z"
            fill="#55a32a"
          />
          <path
            d="M88.69,157.3s11,3.76,14.79,9.65c3.27,5-2.23,6.57-2.23,6.57s4.39-3.4-1.68-9.52C96,160.4,88.69,157.3,88.69,157.3Z"
            fill="#55a32a"
          />
          <path
            d="M62.06,157a10.11,10.11,0,0,0,3.11.72c1.3.07,5.63.16,6.84,0a4.58,4.58,0,0,0,1.68-.43,14.27,14.27,0,0,1-3.38.19C67.12,157.51,62.06,157,62.06,157Z"
            fill="#55a32a"
          />
          <path
            d="M46.16,156.41c.29.42.7.72,3.2.92a50.54,50.54,0,0,0,5.43.24,5.53,5.53,0,0,0,2.05-.24,34.3,34.3,0,0,1-4.57,0C50,157.14,46.16,156.41,46.16,156.41Z"
            fill="#55a32a"
          />
          <path
            d="M81.67,157.32a3.48,3.48,0,0,0,1.22.33,56.14,56.14,0,0,0,5.9-.13c.75-.13.47-.63.47-.63s-.29.54-3.42.58A27.61,27.61,0,0,1,81.67,157.32Z"
            fill="#55a32a"
          />
          <polygon
            points="127.72 180.8 36.46 187.2 43 196.19 141.49 190.33 127.72 180.8"
            fill="#55a32a"
          />
          <polygon
            points="98.59 183.4 38.46 187.42 41.54 191.86 42.37 188.25 98.59 183.4"
            fill="#55a32a"
          />
          <polygon
            points="55.28 193.63 62.21 205.31 162 202.85 149.26 187.43 55.28 193.63"
            fill="#55a32a"
          />
          <polygon
            points="89.42 192.08 58.79 194.17 61.25 198.23 61.5 194.54 89.42 192.08"
            fill="#55a32a"
          />
          <polygon
            points="106.73 190.98 145.98 188.37 152.25 194.71 143.46 189.37 106.73 190.98"
            fill="#55a32a"
          />
          <polygon
            points="111.76 182.58 125.78 181.5 129.11 183.95 123.96 182.21 111.76 182.58"
            fill="#55a32a"
          />
          <g>
            <path
              d="M90.9,197.94l-1.12-.88c-.37-.28-.73-.56-1.09-.82l-1-.73-.81-.58-.57-.41-.23-.16c-.13-.11-.12-.19,0-.25a2.59,2.59,0,0,1,.55-.14l.7-.07.69-.05,1.23-.09,1.14-.06a5.26,5.26,0,0,1,.92.05A1.32,1.32,0,0,1,92,194c.23.16.45.33.66.49l.65.5c1.08.83,2.09,1.67,3,2.52a22,22,0,0,1,2.35,2.46c0,.07,0,.15-.08.23a1,1,0,0,1-.49.17l-.4,0-.45,0-1.19.09-1.44.05a5.62,5.62,0,0,1-.9,0,8.32,8.32,0,0,1-.86-.13c-1.6-.31-3.41-.67-5.41-1.1s-4-.87-6.13-1.34c.46.3,1,.6,1.47.91l1.47.88,1.2.7.62.38c.24.19.09.34-.44.46-.31.06-.71.12-1.19.19s-1,.12-1.54.17l-.41,0c-.15,0-.32,0-.52,0a3.72,3.72,0,0,1-.77,0,1.55,1.55,0,0,1-.6-.22c-1.41-.79-2.69-1.58-3.86-2.39s-2.31-1.66-3.44-2.57L71.14,196a1.19,1.19,0,0,1-.45-.19c-.14-.12-.11-.24.09-.35s.28-.13.49-.22.45-.19.71-.28l.8-.28a6.66,6.66,0,0,1,.74-.22,2.28,2.28,0,0,1,.51-.09,4.22,4.22,0,0,1,1.12.09l4.2.9,4.23.94,4,.89Z"
              fill="#55a32a"
            />
            <path
              d="M113.45,196.65c-.42.09-1,.19-1.6.3s-1.34.21-2.1.32l-2.37.3c-.83.1-1.64.19-2.43.26a14,14,0,0,0,2,.21,17,17,0,0,0,2.15,0c.52,0,1.09-.12,1.73-.22a14.19,14.19,0,0,0,1.63-.35,4.05,4.05,0,0,1,.54-.12,1.41,1.41,0,0,1,.42,0l.44.13a4.89,4.89,0,0,1,.46.19l.4.18.18.09.12.09c.15.12.13.23-.06.35A6.3,6.3,0,0,1,113,199a29,29,0,0,1-3.44.47,25.65,25.65,0,0,1-3.06.07,24,24,0,0,1-3-.27,17.15,17.15,0,0,1-2.64-.59,5.82,5.82,0,0,1-1.87-.89c-.46-.35-.66-.69-.61-1a1.38,1.38,0,0,1,.76-.89,6.78,6.78,0,0,1,1.88-.69,17.67,17.67,0,0,1,2.72-.4,25.08,25.08,0,0,1,3.75,0,22.32,22.32,0,0,1,3,.36,15,15,0,0,1,2.11.58,5.13,5.13,0,0,1,1.16.57q.15.1.12.21C113.82,196.52,113.69,196.59,113.45,196.65Zm-8-.62a5.84,5.84,0,0,0-1.69.34c-.43.18-.63.37-.59.59l2.77-.29c1-.11,1.82-.22,2.57-.35A5.7,5.7,0,0,0,107,196,9.87,9.87,0,0,0,105.45,196Z"
              fill="#55a32a"
            />
            <path
              d="M121.89,193.65a.51.51,0,0,1,.31-.26,3.17,3.17,0,0,1,.8-.13c.33,0,.82,0,1.49-.07s1.31,0,1.93,0a1.86,1.86,0,0,1,.94.16c.1.07.12.15.07.23a7.5,7.5,0,0,1-.82,1.16,9.62,9.62,0,0,1-1.16,1.13c1,.2,1.91.38,2.91.56s2,.35,3,.52a1.55,1.55,0,0,1,.59.17c.08.06,0,.13-.28.21-.63.16-1.32.3-2.08.42a5.94,5.94,0,0,1-.68.08,6.8,6.8,0,0,1-1.54-.05q-2-.22-4-.54c-.27.17-.55.33-.85.48s-.61.31-.94.47a3.17,3.17,0,0,1-1,.26c-.26,0-.58,0-1,0l-1.18-.06c-.39,0-.76-.06-1.14-.11a1.9,1.9,0,0,1-.7-.19c-.09-.06-.05-.15.13-.26.41-.23.81-.46,1.18-.69s.74-.46,1.09-.69c-1-.22-2.06-.45-3-.7s-1.91-.5-2.83-.79a2.07,2.07,0,0,1-.55-.21c-.15-.12.1-.24.75-.39.3-.07.63-.14,1-.2l1-.19.47-.07.37,0a3,3,0,0,1,.68,0l.67.16,1.65.43,1.7.42A7.57,7.57,0,0,0,121.89,193.65Z"
              fill="#55a32a"
            />
            <path
              d="M128.06,193.81a1,1,0,0,1-.26-.24c0-.06,0-.12.08-.16a1.26,1.26,0,0,1,.43-.12l.85-.11-.34-.25-.44-.33-.46-.36a.67.67,0,0,1-.23-.29c0-.08.07-.16.27-.22a6.38,6.38,0,0,1,1-.2c.46-.06,1.12-.12,2-.19a4.12,4.12,0,0,1,1,0,1.64,1.64,0,0,1,.66.27l.2.16.34.29c.13.11.27.23.42.34l.41.34,1,0,1,0a5,5,0,0,1,.93,0,1.69,1.69,0,0,1,.58.24l.28.23.28.28c.09.12.07.21-.05.27a2.71,2.71,0,0,1-.77.15l-.79.1-.64.06,1,.66,1.15.71,1,.63.57.37c.15.1.19.19.12.25a1.35,1.35,0,0,1-.65.18c-.66.09-1.35.17-2.06.23a3.86,3.86,0,0,1-.91,0,2.21,2.21,0,0,1-.75-.25c-.78-.41-1.51-.81-2.2-1.21s-1.38-.8-2.08-1.23l-.77,0a6.09,6.09,0,0,1-1,0,1.78,1.78,0,0,1-.69-.24l-.31-.19Z"
              fill="#55a32a"
            />
          </g>
          <polygon
            points="145.6 209.63 135.48 198.04 45.97 203.06 60.27 214.52 145.6 209.63"
            fill="#55a32a"
          />
          <polygon
            points="85.19 209.53 130.42 208.12 138.5 219.38 99.15 222.25 85.19 209.53"
            fill="#55a32a"
          />
          <polygon
            points="101.84 209.56 88.45 209.94 94.87 215.59 92.82 210.85 101.84 209.56"
            fill="#55a32a"
          />
          <polygon
            points="117.64 209.25 128.79 208.85 132.41 212.82 126.54 210.02 117.64 209.25"
            fill="#55a32a"
          />
          <polygon
            points="97.23 218.14 100.3 221.4 109.58 220.99 101.61 220.33 97.23 218.14"
            fill="#55a32a"
          />
          <path
            d="M120.91,229.28l2.49,2.8s-16.64.24-18.15,1.34C104.89,233.08,110.67,229.62,120.91,229.28Z"
            fill="#55a32a"
          />
          <polygon
            points="70.76 178.32 84.67 181.44 89.13 181.41 87.76 178.55 70.76 178.32"
            fill="#55a32a"
          />
          <path
            d="M62,176.19l6.53,1.44s10.68.3,17.13.2a5.51,5.51,0,0,1-2-1.64Z"
            fill="#55a32a"
          />
          <path
            d="M59.28,175.83s7,.92,23.53.68c16.06-.23,25.55-1.26,27.85-1.8C93.08,176,59.28,175.83,59.28,175.83Z"
            fill="#55a32a"
          />
          <path
            d="M97.46,175.77c-6.16,0-7.64.17-7.12.31s-.38,1.45,5.16,1.3S100.4,175.77,97.46,175.77Z"
            fill="#55a32a"
          />
          <g style={{ mixBlendMode: 'soft-light' }}>
            <image
              width="144"
              height="91"
              transform="translate(0 119.99)"
              href="data:image/png;base64,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"
            />
          </g>
          <polygon
            points="60.45 202.87 48.49 203.55 53.56 207.27 51.76 203.97 60.45 202.87"
            fill="#55a32a"
          />
          <polygon
            points="56.17 209.16 61.45 213.81 84.39 212.57 63.82 212.45 56.17 209.16"
            fill="#55a32a"
          />
          <polygon
            points="110.83 200.11 134.19 198.83 137.18 202.81 132.1 199.95 110.83 200.11"
            fill="#55a32a"
          />
          <g>
            <path
              d="M92.87,184.7a4.42,4.42,0,0,0-2.71-.58c-1.23,0-2,.33-1.74.68a4.37,4.37,0,0,0,2.72.59C92.37,185.36,93.15,185.05,92.87,184.7Z"
              fill="#55a32a"
              opacity="0.45"
              style={{ mixBlendMode: 'multiply' }}
            />
            <path
              d="M92.38,184.63a4.37,4.37,0,0,0-2.71-.58c-1.24,0-2,.33-1.75.68a4.4,4.4,0,0,0,2.73.58C91.88,185.29,92.65,185,92.38,184.63Z"
              fill="#55a32a"
            />
            <path
              d="M91.3,184.18a1.23,1.23,0,0,1,.58.32c.28.35-.5.66-1.73.68a7.72,7.72,0,0,1-1.65-.13,7.06,7.06,0,0,0,2.15.26c1.23,0,2-.33,1.73-.68A2.07,2.07,0,0,0,91.3,184.18Z"
              fill="#55a32a"
            />
          </g>
          <g>
            <path
              d="M98.55,192.43a4.39,4.39,0,0,0-2.77-.59c-1.25,0-2,.36-1.76.73a4.43,4.43,0,0,0,2.78.59C98.06,193.13,98.84,192.8,98.55,192.43Z"
              fill="#55a32a"
              opacity="0.45"
              style={{ mixBlendMode: 'multiply' }}
            />
            <path
              d="M98.05,192.36a4.4,4.4,0,0,0-2.78-.6c-1.25,0-2,.36-1.76.73a4.36,4.36,0,0,0,2.79.6C97.55,193.05,98.34,192.72,98.05,192.36Z"
              fill="#55a32a"
            />
            <path
              d="M96.94,191.89a1.31,1.31,0,0,1,.6.34c.29.36-.5.69-1.75.73a8,8,0,0,1-1.68-.14,7,7,0,0,0,2.19.27c1.25,0,2-.37,1.75-.73A2.1,2.1,0,0,0,96.94,191.89Z"
              fill="#55a32a"
            />
          </g>
          <g>
            <path
              d="M69.63,191.53c-.86-.3-1.68-.6-2.46-.91s-1.55-.62-2.29-1a6.51,6.51,0,0,1,.21,1.05,5.42,5.42,0,0,1,0,1.07.34.34,0,0,1,0,.18.3.3,0,0,1-.14.13.88.88,0,0,1-.28.1,2.29,2.29,0,0,1-.48.09c-.63.1-1.24.16-1.83.21s-.85,0-1.22,0a3.76,3.76,0,0,1-1-.17c-.92-.31-1.79-.61-2.61-.92s-1.61-.63-2.36-.95-1.48-.64-2.2-1l-2.15-1-.11-.06-.07-.05c-.08-.06-.08-.12,0-.16a1.19,1.19,0,0,1,.41-.12c.36-.07.75-.12,1.15-.17l1.2-.13a5.5,5.5,0,0,1,.92,0,2.61,2.61,0,0,1,.75.2l3.16,1.39c1,.46,2.16.93,3.33,1.4a8.71,8.71,0,0,0-.44-1.52,12.72,12.72,0,0,0-.74-1.55.18.18,0,0,1,.09-.27,2.59,2.59,0,0,1,.72-.16l.38,0,.43,0,.48,0,.51,0a6.19,6.19,0,0,1,.84.05,3.13,3.13,0,0,1,.77.24l2.83,1.21c1,.41,2,.82,3,1.24a7.78,7.78,0,0,0-.36-1.46c-.17-.48-.35-1-.55-1.49q-.08-.15.12-.24a3.1,3.1,0,0,1,.77-.12l1,0c.4,0,.78,0,1.16,0a6.13,6.13,0,0,1,.85,0,1,1,0,0,1,.43.15A.61.61,0,0,1,74,187a7.92,7.92,0,0,1,.69,2,7.46,7.46,0,0,1,.1,2.12.41.41,0,0,1-.23.33,1.94,1.94,0,0,1-.67.17l-.42,0-.42,0-.68,0-.68,0a8.16,8.16,0,0,1-1.17,0A4.78,4.78,0,0,1,69.63,191.53Z"
              fill="#55a32a"
            />
            <path
              d="M75.32,186.85a1.11,1.11,0,0,1-.22-.25c0-.07.09-.13.35-.17l.59-.08.7-.07.73-.07.63-.05a1.84,1.84,0,0,1,.51,0,.89.89,0,0,1,.26.12l.27.23.45.38.56.46c.2.17.4.33.59.47a7.56,7.56,0,0,1,1.38-.37,17.1,17.1,0,0,1,1.78-.21l1.08,0c.41,0,.83,0,1.26,0a7.26,7.26,0,0,1,1.25.22,2.69,2.69,0,0,1,1,.46c.15.11.32.25.5.4l.57.5c.2.19.4.37.59.57s.36.4.53.59a.24.24,0,0,1,.06.22c0,.07-.23.12-.61.15l-.88,0-1.1,0a1.83,1.83,0,0,1-1.08-.24c-.06,0-.23-.21-.52-.49a13.32,13.32,0,0,0-1.33-1.11,1.37,1.37,0,0,0-.53-.23,2.56,2.56,0,0,0-.75-.05,7.77,7.77,0,0,0-2,.41l1.28.93c.41.28.78.52,1.11.71l.13.07.09.06c.1.08.1.14,0,.19a3.29,3.29,0,0,1-.85.14l-.34,0-.39,0-.37,0-.35,0a4.47,4.47,0,0,1-1,0,2.1,2.1,0,0,1-.59-.22c-.22-.13-.47-.28-.76-.47s-.6-.37-.92-.59-.65-.44-1-.68-.66-.48-1-.72-.59-.47-.85-.71Z"
              fill="#55a32a"
            />
            <path
              d="M101.24,189.55a3.71,3.71,0,0,1-.86,0,1.2,1.2,0,0,1-.41-.2,7.53,7.53,0,0,1-1.18.37,12.91,12.91,0,0,1-1.63.22,19.34,19.34,0,0,1-2,0,15.75,15.75,0,0,1-1.78-.18,8.42,8.42,0,0,1-1.46-.36,3.28,3.28,0,0,1-1-.51c-.37-.27-.53-.53-.48-.8a1.14,1.14,0,0,1,.58-.71,5.26,5.26,0,0,1,1.42-.55,12.64,12.64,0,0,1,2.06-.31,19.72,19.72,0,0,1,2,0c-.08-.08-.09-.14,0-.17a1,1,0,0,1,.38-.07c.24,0,.57,0,1,0s.82,0,1.2,0h.5l.42,0,.33.1a2.38,2.38,0,0,1,.3.18c.51.37,1,.77,1.51,1.2a16.16,16.16,0,0,1,1.32,1.24c.11.12.12.22,0,.28a1.49,1.49,0,0,1-.65.16l-.41.05-.47,0-.37,0Zm-2.33-1.17-.59-.5c-.19-.17-.4-.34-.61-.5l-.72,0-.81,0a4.67,4.67,0,0,0-1,.17,1.68,1.68,0,0,0-.57.27.41.41,0,0,0-.16.32.4.4,0,0,0,.18.28,2.19,2.19,0,0,0,1,.35,7.31,7.31,0,0,0,1.58,0,6.88,6.88,0,0,0,1-.15A2.66,2.66,0,0,0,98.91,188.38Z"
              fill="#55a32a"
            />
            <path
              d="M102,186.65a.59.59,0,0,1-.18-.17s0-.08.07-.11a1.05,1.05,0,0,1,.32-.09l.64-.07-.24-.18-.31-.23-.32-.26a.45.45,0,0,1-.16-.21c0-.06.06-.11.21-.16a6.1,6.1,0,0,1,.75-.13c.35,0,.85-.09,1.49-.13a2.67,2.67,0,0,1,.77,0,1.19,1.19,0,0,1,.47.19l.14.12.23.2.3.25.29.25.75,0c.25,0,.51,0,.78,0a2.77,2.77,0,0,1,.69,0,1,1,0,0,1,.42.17l.2.16.19.2c0,.09,0,.15-.06.19a2.44,2.44,0,0,1-.59.11l-.59.06-.48,0c.2.14.44.3.72.47l.81.52.71.44.39.26c.11.08.13.14.08.19a1.47,1.47,0,0,1-.49.12c-.5.06-1,.11-1.55.15a3.83,3.83,0,0,1-.68,0,1.67,1.67,0,0,1-.54-.19c-.55-.29-1.07-.57-1.56-.86s-1-.57-1.47-.88l-.58,0a4.07,4.07,0,0,1-.72,0,1.34,1.34,0,0,1-.51-.17l-.22-.14A.83.83,0,0,1,102,186.65Z"
              fill="#55a32a"
            />
            <path
              d="M108.5,184.12c0-.15.23-.25.67-.28s.71,0,1.21,0,1,0,1.43.07a5.33,5.33,0,0,1,.67.08,1.06,1.06,0,0,1,.32.11.29.29,0,0,1,.12.24,1.42,1.42,0,0,1-.12.68,2.07,2.07,0,0,1-.52.66,1,1,0,0,1-.29.19,1.52,1.52,0,0,1-.45.08h-.39c-.21,0-.42,0-.62,0a5.68,5.68,0,0,1-.59,0,1.83,1.83,0,0,1-.81-.21.35.35,0,0,1-.11-.1,1.34,1.34,0,0,1-.11-.14l-.09-.12a.56.56,0,0,0,0-.08,3.17,3.17,0,0,1-.26-.58A1.2,1.2,0,0,1,108.5,184.12Z"
              fill="#55a32a"
            />
            <path
              d="M124.29,186.84c.2.14.26.27.19.4a1.09,1.09,0,0,1-.54.36,6.2,6.2,0,0,1-1.17.29,16.78,16.78,0,0,1-1.69.2c-.58,0-1.11.07-1.6.08s-1,0-1.46,0a1.81,1.81,0,0,1-.85-.16.41.41,0,0,1-.12-.14.44.44,0,0,1,0-.2.74.74,0,0,0,0-.21c0-.09.1-.15.25-.16s.3,0,.61,0,.62,0,.92,0,.56,0,.77,0a4.32,4.32,0,0,0,.71-.09c.16,0,.2-.08.12-.13a1.12,1.12,0,0,0-.49-.1c-.26,0-.58,0-1-.06l-1.22-.06c-.44,0-.87-.06-1.29-.12a8.13,8.13,0,0,1-1.19-.22,2.71,2.71,0,0,1-.87-.37c-.21-.15-.27-.3-.17-.44a1.29,1.29,0,0,1,.62-.38,6.14,6.14,0,0,1,1.2-.3,14.26,14.26,0,0,1,1.61-.19c.49,0,1-.06,1.55-.07s1,0,1.53,0a3.54,3.54,0,0,1,.63.06,1.1,1.1,0,0,1,.44.17,1.83,1.83,0,0,1,.32.3,1.38,1.38,0,0,1,.21.3.14.14,0,0,1,0,.16,1.19,1.19,0,0,1-.48.09c-.41,0-.83,0-1.27,0a2.49,2.49,0,0,1-.62,0,.87.87,0,0,1-.38-.18l-.06,0a6.77,6.77,0,0,0-.7,0,5.69,5.69,0,0,0-.82.1q-.3.08-.15.18a1.43,1.43,0,0,0,.52.09l1,.05,1.33.06c.48,0,1,.05,1.41.1a10.78,10.78,0,0,1,1.27.22A2.71,2.71,0,0,1,124.29,186.84Z"
              fill="#55a32a"
            />
            <path
              d="M110.78,185.41a1.29,1.29,0,0,1-.25.29c-.09.08-.19.17-.15.25s.08-.08.19-.11a.55.55,0,0,0,.24.09.89.89,0,0,1,.37-.18.57.57,0,0,1-.26.25h-.13l-.13-.06s-.06,0-.14,0a.24.24,0,0,1-.15,0l-.09,0c-.22-.06,0-.2.06-.27a.61.61,0,0,1,.16-.16C110.57,185.51,110.75,185.45,110.78,185.41Z"
              fill="#55a32a"
            />
            <path
              d="M102.69,186.64a1.36,1.36,0,0,1-.35.09l.72,0-.58.12c.75,0,1.47,0,2.18-.07a14.42,14.42,0,0,1-1.8.23l.4.06-.12,0h.47c-.28.06-.59.1-.92.14h-.12a.43.43,0,0,1-.24-.07A2.43,2.43,0,0,1,102,187c-.08-.06-.2-.14-.22-.2s.09-.06.22-.07l.32,0Z"
              fill="#55a32a"
            />
            <path
              d="M106.41,187c.58,0,1.06-.09,1.64-.09a5.36,5.36,0,0,1-1.08.2,3.13,3.13,0,0,0-1,.23l1.94-.17a.3.3,0,0,1-.15.07.31.31,0,0,0,.17,0l-.06,0,1.23-.06.07,0h0a3.24,3.24,0,0,0-1.13-.31c-.27,0-.56,0-.81,0l-.41,0A2.71,2.71,0,0,1,106.41,187Z"
              fill="#55a32a"
            />
          </g>
          <path
            d="M104.79,213.54a.2.2,0,0,1,0-.32,2.19,2.19,0,0,1,.62-.23c.47-.12.94-.23,1.4-.32s1-.17,1.47-.24l1.69-.18c.61-.05,1.3-.09,2.07-.13,1-.05,1.94-.08,3-.08s2,0,2.88.13a14.51,14.51,0,0,1,2.36.39,2.7,2.7,0,0,1,1.43.76.39.39,0,0,1,.1.45,1.19,1.19,0,0,1-.42.42,5.76,5.76,0,0,1-.76.42l-.94.46a12.21,12.21,0,0,0-1.13.69,2.94,2.94,0,0,0-.87.89.63.63,0,0,1-.34.3,3,3,0,0,1-.81.12c-.51,0-1,0-1.58,0s-1.1-.06-1.64-.13a1.63,1.63,0,0,1-.92-.3.23.23,0,0,1,0-.29,2.76,2.76,0,0,1,.55-.79,5.16,5.16,0,0,1,.89-.72,7.72,7.72,0,0,1,1.22-.63,14.5,14.5,0,0,1,1.45-.51c-.44,0-.88,0-1.34,0l-1.38.05c-1.06.06-2.07.15-3,.29a22.3,22.3,0,0,0-2.57.49l-.38.08a2.2,2.2,0,0,1-.36,0,2.7,2.7,0,0,1-1.06-.15,5.19,5.19,0,0,1-1-.46A2.51,2.51,0,0,1,104.79,213.54Zm11,4.06c.63,0,1.18-.06,1.64-.06a8,8,0,0,1,1.17.07,3,3,0,0,1,.84.24,1.88,1.88,0,0,1,.58.46.45.45,0,0,1,.12.32c0,.1-.12.2-.33.28a4.45,4.45,0,0,1-.93.23c-.42.06-1,.12-1.7.16s-1.18,0-1.64,0a7.76,7.76,0,0,1-1.16-.07,2.4,2.4,0,0,1-.78-.24,1.5,1.5,0,0,1-.52-.41c-.22-.29-.13-.51.27-.68A8.82,8.82,0,0,1,115.81,217.6Z"
            fill="#55a32a"
          />
          <g>
            <path
              d="M106.41,201.36a4.4,4.4,0,0,0-2.85-.61c-1.27.05-2.07.4-1.77.78a4.38,4.38,0,0,0,2.85.61C105.92,202.1,106.71,201.74,106.41,201.36Z"
              fill="#55a32a"
              opacity="0.45"
              style={{ mixBlendMode: 'multiply' }}
            />
            <path
              d="M105.89,201.28a4.48,4.48,0,0,0-2.84-.61c-1.28.05-2.07.4-1.78.79a4.46,4.46,0,0,0,2.86.61C105.4,202,106.19,201.67,105.89,201.28Z"
              fill="#55a32a"
            />
            <path
              d="M104.75,200.8a1.31,1.31,0,0,1,.62.35c.3.38-.49.73-1.77.78a7.72,7.72,0,0,1-1.71-.13,6.74,6.74,0,0,0,2.24.27c1.27,0,2.06-.4,1.76-.79A2.14,2.14,0,0,0,104.75,200.8Z"
              fill="#55a32a"
            />
          </g>
          <g>
            <path
              d="M114.19,210.73a4.48,4.48,0,0,0-2.92-.62c-1.3.06-2.1.43-1.79.84s1.63.69,2.93.63S114.5,211.14,114.19,210.73Z"
              fill="#55a32a"
              opacity="0.45"
              style={{ mixBlendMode: 'multiply' }}
            />
            <path
              d="M113.66,210.65a4.47,4.47,0,0,0-2.92-.62c-1.3.06-2.1.44-1.79.84s1.63.69,2.93.63S114,211.06,113.66,210.65Z"
              fill="#55a32a"
            />
            <path
              d="M112.48,210.15a1.43,1.43,0,0,1,.64.36c.32.41-.47.79-1.77.85a7.49,7.49,0,0,1-1.75-.12,6.75,6.75,0,0,0,2.28.26c1.3-.06,2.1-.44,1.78-.85A2.17,2.17,0,0,0,112.48,210.15Z"
              fill="#55a32a"
            />
          </g>
          <g>
            <path
              d="M63.56,204.73a.18.18,0,0,1,.11-.26,3,3,0,0,1,.78-.16c2.6-.29,5.39-.52,8.38-.67l2.11-.07c.78,0,1.53,0,2.25,0a12.37,12.37,0,0,1,1.9.21,1.82,1.82,0,0,1,1.09.47.27.27,0,0,1,0,.24.76.76,0,0,1-.19.35,2.19,2.19,0,0,1-.49.4,4.13,4.13,0,0,1-.89.42L78,206l-.67.22.87-.06.88,0a12.91,12.91,0,0,1,2.77.08,2.24,2.24,0,0,1,1.39.65,2.48,2.48,0,0,1,.55,1.77.36.36,0,0,1-.25.29,2.84,2.84,0,0,1-.7.14l-1.11.09-1.18.08a2.87,2.87,0,0,1-.8,0,.73.73,0,0,1-.45-.2.74.74,0,0,1-.09-.21c0-.11-.1-.25-.17-.41s-.15-.33-.24-.51a3.38,3.38,0,0,0-.35-.52l-2.12.09-1.46.09-1.47.11c.1.1.22.22.36.34l.39.37.35.33c.1.1.18.17.21.21q.24.3-.66.42l-1.2.13-1.26.09a4.13,4.13,0,0,1-.89,0,1.16,1.16,0,0,1-.61-.24c-.44-.35-.83-.68-1.17-1s-.65-.59-.94-.87-.56-.57-.81-.85-.5-.58-.76-.9l-.34,0c-.21,0-.42.06-.63.07a2.72,2.72,0,0,1-.6,0,1.3,1.3,0,0,1-.46-.18,2.34,2.34,0,0,1-.61-.51.6.6,0,0,1-.09-.13Zm7.29.39c.4.43.82.85,1.27,1.28.35-.11.69-.22,1-.35s.62-.27.89-.41a7.65,7.65,0,0,0,.72-.42,3.36,3.36,0,0,0,.51-.4l-.41,0-.41,0-1.66.1Z"
              fill="#55a32a"
            />
            <path
              d="M92.09,204.41l.57.05a.57.57,0,0,1,.33.16l0,0a.83.83,0,0,1,0,.12,16.45,16.45,0,0,1,3.52.41,4.07,4.07,0,0,1,2,1c.25.29.29.56.1.8a2.26,2.26,0,0,1-1,.65,10.37,10.37,0,0,1-1.82.47,22.4,22.4,0,0,1-2.28.25c-1.09.06-2.11.07-3.07,0a18.92,18.92,0,0,1-2.58-.24,9.16,9.16,0,0,1-1.94-.52,3,3,0,0,1-1.2-.79.66.66,0,0,1-.08-.88,2.52,2.52,0,0,1,1.09-.74,10,10,0,0,1,1.91-.52,16.53,16.53,0,0,1,2.43-.28c.28,0,.6,0,1,0Zm.48,1.49-.54,0a3.18,3.18,0,0,1-.37-.06.85.85,0,0,1-.28-.1.87.87,0,0,1-.22-.17,5.47,5.47,0,0,0-1.85.41c-.42.21-.51.45-.28.72a1.08,1.08,0,0,0,.47.29,3.56,3.56,0,0,0,.78.19,7.27,7.27,0,0,0,1,.09,11.35,11.35,0,0,0,2.07-.11,4.41,4.41,0,0,0,.81-.19,1,1,0,0,0,.46-.26.2.2,0,0,0,0-.31,1.34,1.34,0,0,0-.73-.33A6.79,6.79,0,0,0,92.57,205.9Z"
              fill="#55a32a"
            />
            <path
              d="M106.52,203.66l.56.06a.51.51,0,0,1,.32.15.1.1,0,0,1,0,0,.87.87,0,0,1,0,.12,15.39,15.39,0,0,1,3.45.41,4,4,0,0,1,2,1c.26.28.31.55.14.79a2.23,2.23,0,0,1-1,.64,9.72,9.72,0,0,1-1.76.45,21,21,0,0,1-2.21.25c-1.06,0-2.05.07-3,0a21.61,21.61,0,0,1-2.52-.24,10.12,10.12,0,0,1-1.93-.51,3.28,3.28,0,0,1-1.2-.78.65.65,0,0,1-.12-.87,2.29,2.29,0,0,1,1-.72,9.26,9.26,0,0,1,1.85-.52,16.67,16.67,0,0,1,2.35-.27c.27,0,.58,0,.92,0Zm.54,1.46c-.22,0-.39,0-.53,0a2,2,0,0,1-.36-.05.77.77,0,0,1-.28-.1.87.87,0,0,1-.22-.17,4.86,4.86,0,0,0-1.79.41c-.4.21-.47.44-.24.71a1.22,1.22,0,0,0,.47.28,4.56,4.56,0,0,0,.77.19,7.12,7.12,0,0,0,1,.09c.34,0,.69,0,1.05,0a9.14,9.14,0,0,0,1-.1,5.35,5.35,0,0,0,.78-.18,1,1,0,0,0,.44-.26.21.21,0,0,0,0-.31,1.42,1.42,0,0,0-.73-.33A8.48,8.48,0,0,0,107.06,205.12Z"
              fill="#55a32a"
            />
            <path
              d="M123.17,203.27a4.5,4.5,0,0,1,1.32-.48,10.43,10.43,0,0,1,1.78-.22c.46,0,.92,0,1.38,0a10.8,10.8,0,0,1,1.31.12,6.1,6.1,0,0,1,1.12.28,2,2,0,0,1,.77.46c.12.13.26.28.4.46s.3.36.46.56l.45.64q.21.33.39.66a.23.23,0,0,1,0,.25c-.05.07-.27.12-.67.15l-.93,0H129.8a1.47,1.47,0,0,1-1.05-.28,5.85,5.85,0,0,1-.41-.56,11.25,11.25,0,0,0-1.06-1.25,1.13,1.13,0,0,0-.41-.27,1.44,1.44,0,0,0-.62-.08,5.45,5.45,0,0,0-1.75.37l.28.27.29.3.63.69c.22.25.42.48.58.68s.12.23,0,.3a1.67,1.67,0,0,1-.71.13l-.52,0-.72,0-.68,0a2.39,2.39,0,0,1-.76-.08,1.1,1.1,0,0,1-.46-.23c-.3-.3-.58-.6-.85-.88a10.68,10.68,0,0,0-1-.88,1.37,1.37,0,0,0-1-.33,5.77,5.77,0,0,0-.9.12,6.06,6.06,0,0,0-.71.22c.31.32.63.62,1,.92s.68.6,1.07.9l.11.08.08.08c.08.08.05.15-.07.2a3.63,3.63,0,0,1-.93.14l-.37,0-.41,0-.41,0h-.36a4.38,4.38,0,0,1-1.07-.05,1.63,1.63,0,0,1-.55-.25c-.47-.37-.93-.75-1.36-1.13a14.49,14.49,0,0,1-1.19-1.15l-.25-.26-.22-.27a.67.67,0,0,1-.15-.29q0-.12.42-.18l.63-.07.76-.07.78-.06.68,0a1.85,1.85,0,0,1,.52,0,.49.49,0,0,1,.25.13l.07.09.06.1a5.41,5.41,0,0,1,1.09-.3,8.46,8.46,0,0,1,1.34-.17,15.48,15.48,0,0,1,1.93,0A7.08,7.08,0,0,1,123.17,203.27Z"
              fill="#55a32a"
            />
          </g>
        </g>
        <g transform="translate(230 440)">
          <rect
            x="135.54"
            y="95.7"
            width="6.68"
            height="143.14"
            fill="#4a1984"
          />
          <path
            d="M163.36,75.75c0,17.62-4.46,33.14-25.18,31.9C115.7,108.89,113,93.37,113,75.75s8.8-31.27,25.18-31.9C158,44,163.36,58.13,163.36,75.75Z"
            fill="#f1ba0e"
          />
          <path
            d="M144.13,95.49C121.65,96.72,119,81.2,119,63.59a45.57,45.57,0,0,1,1.33-11.21c-4.79,5.76-7.28,14-7.28,23.37,0,17.62,2.7,33.14,25.18,31.9,14.91.89,21.4-6.89,23.87-17.89C158.21,93.75,152.49,96,144.13,95.49Z"
            fill="#f1a10e"
          />
          <path
            d="M157.26,239.61c0,3.93-7.84,6-17.31,6s-17-2.08-17-6,7.52-8.21,17-8.21S157.26,235.69,157.26,239.61Z"
            fill="#4a1984"
          />
          <ellipse
            cx="139.65"
            cy="105.44"
            rx="23.25"
            ry="5.06"
            fill="#4a1984"
          />
          <polygon
            points="116.4 105.44 135.66 123.98 142.07 123.98 162.74 105.96 116.4 105.44"
            fill="#4a1984"
          />
          <path
            d="M121.88,108.74l-4.54,2.2a95.17,95.17,0,0,0,44.3,1.1c-4.21-2.22-4.07-2.42-4.07-2.42S134.87,111.38,121.88,108.74Z"
            fill="#4a1984"
          />
          <path
            d="M124.86,47a62.43,62.43,0,0,0-8.93,29.46c-1,19.15,8,29.75,8,29.75l-5.17-1.17s-10.49-15.1-7.83-31.8,8-24.92,8-24.92Z"
            fill="#4a1984"
          />
          <path
            d="M150.88,47.34a62.43,62.43,0,0,1,8.92,29.45c1,19.15-8,29.75-8,29.75l5.16-1.17s10.49-15.09,7.83-31.8-8-24.91-8-24.91Z"
            fill="#4a1984"
          />
          <path
            d="M141,49.39s4,11.72,4.45,29.46c.5,19.14-4,29.75-4,29.75l5.79-.44s4.87-16.56,3.54-33.27-4-24.92-4-24.92Z"
            fill="#4a1984"
          />
          <path
            d="M136.14,51.15s-4,11.72-4.45,29.45c-.51,19.15,4,29.75,4,29.75l-5.79-.44S125,93.35,126.34,76.65s4-24.92,4-24.92Z"
            fill="#4a1984"
          />
          <path
            d="M157.13,43.45s-4.46-1.68-1-5.2,12.65,4,10.07,7.77c-2.05,3-10.62,3.95-12.65,1.76A29,29,0,0,1,157.13,43.45Z"
            fill="#3b177c"
          />
          <path
            d="M121.8,44.33s4.41-3.39,0-5.79c-5.75-3.13-10.64,6.12-8,8.69s9.55,3.62,11.58,1.43A28.28,28.28,0,0,0,121.8,44.33Z"
            fill="#3b177c"
          />
          <ellipse cx="139.18" cy="47.63" rx="23.25" ry="5.06" fill="#4a1984" />
          <ellipse cx="139.18" cy="27.84" rx="8.52" ry="1.85" fill="#4a1984" />
          <path
            d="M115.93,47.63s2.85.64,8.51-7.38c5.17-7.31,6.21-12.41,6.21-12.41h17s-.15,3.23,4.55,9.38a62.91,62.91,0,0,0,10.17,10.41Z"
            fill="#4a1984"
          />
          <path
            d="M118.59,46.46s4.47-1.69,1-5.21-9.25,2.84-5.5,7.74c2.23,2.9,5.4,3.51,11,2.52A18.51,18.51,0,0,0,118.59,46.46Z"
            fill="#4a1984"
          />
          <path
            d="M161.12,46.46s-4.46-1.69-1-5.21,9.26,2.84,5.5,7.74c-2.23,2.9-5.4,3.51-11,2.52A18.51,18.51,0,0,1,161.12,46.46Z"
            fill="#4a1984"
          />
          <line
            x1="138.24"
            y1="29.31"
            x2="138.47"
            y2="46.24"
            fill="none"
            stroke="#15125e"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            d="M141.53,44.81c-1.79-.11-5.17-.77-6.81-.55s-3.29,12.09,0,12.64,7.16.55,7.63-1.21S143.4,44.92,141.53,44.81Z"
            fill="#4a1984"
          />
          <path
            d="M136.71,53.6c-2.19-.36-2.19-5.76-1.46-9.38l-.53,0c-1.65.22-3.29,12.09,0,12.64s7.16.55,7.63-1.21a14.11,14.11,0,0,0,.29-2A15.85,15.85,0,0,1,136.71,53.6Z"
            fill="#3b177c"
          />
          <path
            d="M133.62,29.38s-2.37,14.44-7.71,23.07"
            fill="none"
            stroke="#15125e"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            d="M144,29.46s2.74,17,8.06,22.57"
            fill="none"
            stroke="#15125e"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            d="M147.7,27.84s3.92,11.73,11.2,16.86,6.34-1.76,5.09-2.2-1.8,1.32-1.8,1.32"
            fill="none"
            stroke="#15125e"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <ellipse
            cx="139.18"
            cy="27.84"
            rx="8.52"
            ry="1.85"
            fill="none"
            stroke="#15125e"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <ellipse cx="138.63" cy="21.25" rx="7.67" ry="7.18" fill="#4a1984" />
          <path
            d="M141.29,25a7.44,7.44,0,0,1-7.67-7.18,6.51,6.51,0,0,1,.41-2.3A7,7,0,0,0,131,21.25a7.43,7.43,0,0,0,7.67,7.18,7.65,7.65,0,0,0,7.27-4.88A8,8,0,0,1,141.29,25Z"
            fill="#2c1272"
          />
          <path
            d="M147.24,9.67c3.83,1.69-3.13,8.65-7.36,7-3.92-1.5-7.2-4.39-7.2-8.36S140.82,0,140.82,0,139.57,6.3,147.24,9.67Z"
            fill="#2c1272"
          />
          <path
            d="M144.5,10.7c3.84,1.68-3.26,8.26-7.75,7.47-5.87-1-7.2-4.38-7.2-8.35s8.69-8.06,8.69-8.06S136.83,7.33,144.5,10.7Z"
            fill="#4a1984"
          />
          <path
            d="M139.33,5.13c-2.73-1.47-7.43,1.61-7.27,5.64s4.14,5.06,5.94,4.62a3.63,3.63,0,0,0,2.59-4c-.71,1.83-5.23,3.49-5.76.59-1-5.64,6.85-4,6.85-4Z"
            fill="#2c1272"
          />
          <path
            d="M131.08,28.65S130,30.9,125.15,39c-3.26,5.51-6.52,9.4-8.57,8.68s-2.17-5.16.23-5.11,1.35,1.21,1.35,1.21"
            fill="none"
            stroke="#15125e"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            d="M127.56,43.76a23.57,23.57,0,0,0-4.75,0c-1,.22-3.53,10-1.24,11.72a7.74,7.74,0,0,0,6.46.88C128.3,54.59,128.65,43.87,127.56,43.76Z"
            fill="#4a1984"
          />
          <path
            d="M124.31,53.27c1.09,3.09,2.66,4.07,3.83,2.86s2.29-7.36,1.24-9.56-1.18-2.75-2.94-2.26S122.35,47.74,124.31,53.27Z"
            fill="#3b177c"
          />
          <path
            d="M129.36,45.06c.15,1.07-1.49,7-3,6s-.82-4.62.59-3.74"
            fill="none"
            stroke="#15125e"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            d="M150,43.78a23.58,23.58,0,0,1,4.75,0c1,.22,3.53,10,1.24,11.73a7.74,7.74,0,0,1-6.46.88C149.21,54.61,148.86,43.89,150,43.78Z"
            fill="#4a1984"
          />
          <path
            d="M153.2,53.29c-1.1,3.09-2.66,4.07-3.84,2.86s-2.29-7.37-1.23-9.56,1.17-2.75,2.93-2.26S155.15,47.76,153.2,53.29Z"
            fill="#3b177c"
          />
          <path
            d="M148.15,45.08c-.16,1.07,1.49,7,3,6.05s.82-4.62-.58-3.74"
            fill="none"
            stroke="#15125e"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            d="M126.19,114.09S141,116,153.27,113.5C141.68,118.49,126.19,114.09,126.19,114.09Z"
            fill="#bf22b4"
          />
          <path
            d="M134.6,56.46s-4.94,11.45-3.87,28.91c.88,14.4,2.64,15.77,2.64,15.77S131.94,84,131.9,76.68A79.42,79.42,0,0,1,134.6,56.46Z"
            fill="#bf22b4"
          />
          <path
            d="M121,54.48S114,66.59,115.11,84.05c.88,14.4,6.46,18.46,6.46,18.46s-6-9.34-5.28-27.15A68,68,0,0,1,121,54.48Z"
            fill="#bf22b4"
          />
          <path
            d="M142.59,55.69s4.94,11.45,3.87,28.91c-.88,14.4-2.64,15.77-2.64,15.77s1.43-17.13,1.47-24.46A79.42,79.42,0,0,0,142.59,55.69Z"
            fill="#bf22b4"
          />
          <path
            d="M155.05,55.6s6.69,11.43,5.62,28.89c-.88,14.4-6.46,18.46-6.46,18.46s6-9.34,5.28-27.15A64.45,64.45,0,0,0,155.05,55.6Z"
            fill="#bf22b4"
          />
          <path
            d="M132.92,54.88C133.7,56.13,134,56.79,135,57s4.54.44,5.64,0a4,4,0,0,0,1.68-1.32s-.28.44-2.94.59S132.92,54.88,132.92,54.88Z"
            fill="#bf22b4"
          />
          <path
            d="M120.39,53.35c0,1.24.16,2.12,2,2.71a10.93,10.93,0,0,0,4.23.66,2.36,2.36,0,0,0,1.8-.74,7.74,7.74,0,0,1-3.68,0A18.38,18.38,0,0,1,120.39,53.35Z"
            fill="#bf22b4"
          />
          <path
            d="M149,55.73c.29.6.33.78.8,1a14.24,14.24,0,0,0,5.13-.44c.74-.42.86-2,.86-2s-.65,1.69-3.35,1.82S149,55.73,149,55.73Z"
            fill="#bf22b4"
          />
          <polygon
            points="170.76 123.73 98.21 134.94 98.91 156.04 174.99 149.12 170.76 123.73"
            fill="#2f27cf"
          />
          <polygon
            points="145.68 128.97 99.5 135.56 99.73 146.11 101.84 137.76 145.68 128.97"
            fill="#2aa7cf"
          />
          <polygon
            points="108.42 151.1 107.95 177.47 182.15 180.99 183.56 142.3 108.42 151.1"
            fill="#2ad2eb"
          />
          <polygon
            points="133.62 149.78 110.61 152.56 110.45 161.94 112.33 153.59 133.62 149.78"
            fill="#84e1eb"
          />
          <polygon
            points="147.24 148.31 180.11 144.5 180.43 160.77 177.29 146.85 147.24 148.31"
            fill="#84e1eb"
          />
          <polygon
            points="156.55 127.57 168.65 125.49 169.59 132.08 166.65 127.24 156.55 127.57"
            fill="#2aa7cf"
          />
          <g>
            <path
              d="M131.49,163.53l-.33-2.09c-.12-.69-.23-1.35-.35-2l-.33-1.75c-.1-.54-.2-1-.28-1.42s-.15-.74-.19-1-.08-.38-.08-.41a.58.58,0,0,1,.16-.57,1.4,1.4,0,0,1,.47-.29l.55-.12.53-.08,1-.11.86,0a1.09,1.09,0,0,1,.66.17.77.77,0,0,1,.33.57c.08.4.16.79.22,1.19l.2,1.22c.32,2,.59,4,.8,6.07s.32,4,.34,5.81a.93.93,0,0,1-.18.51.83.83,0,0,1-.45.34,1.23,1.23,0,0,1-.32.07l-.34.05q-.42.06-.9.09a7.53,7.53,0,0,1-1.07,0,1.54,1.54,0,0,1-.63-.16,2.17,2.17,0,0,1-.54-.38q-1.47-1.22-3.29-2.9t-3.67-3.51c.18.7.37,1.42.58,2.17s.41,1.44.59,2.09l.49,1.67q.21.7.24.9a.85.85,0,0,1-.54,1,6.79,6.79,0,0,1-.94.32,8.51,8.51,0,0,1-1.16.25l-.31,0a2.17,2.17,0,0,1-.38,0,.91.91,0,0,1-.52-.14.93.93,0,0,1-.32-.53c-.59-1.86-1.09-3.75-1.51-5.65s-.81-3.93-1.16-6.08l-1.26-1.36a.9.9,0,0,1-.22-.47,1,1,0,0,1,.24-.8l.45-.47c.2-.2.41-.39.64-.59l.71-.59a5.25,5.25,0,0,1,.64-.46.82.82,0,0,1,1.15.13c.83.76,1.68,1.55,2.55,2.38s1.72,1.65,2.55,2.46l2.37,2.36C130.24,162.23,130.91,162.92,131.49,163.53Z"
              fill="#8650df"
            />
            <path
              d="M148.84,162.32a14.46,14.46,0,0,1-1.38.58c-.54.19-1.13.38-1.75.56s-1.28.35-2,.51-1.33.31-1.95.43a3.51,3.51,0,0,0,1.35.63,4.18,4.18,0,0,0,1.62.08,8,8,0,0,0,2.85-1.06,2,2,0,0,1,.47-.23.35.35,0,0,1,.3.09,1.4,1.4,0,0,1,.25.33,3.39,3.39,0,0,1,.23.47c.07.16.13.31.19.47a.79.79,0,0,1,.08.23l0,.21a1,1,0,0,1-.25.8,5,5,0,0,1-1.83,1.31,10,10,0,0,1-2.83.8,6.58,6.58,0,0,1-2.3-.08,6.13,6.13,0,0,1-2.07-.86,5.79,5.79,0,0,1-1.6-1.56,5.2,5.2,0,0,1-.86-2.21,5.36,5.36,0,0,1,.13-2.4,5.62,5.62,0,0,1,1.06-2,6.13,6.13,0,0,1,1.79-1.47,6.77,6.77,0,0,1,2.26-.75,6.25,6.25,0,0,1,2.84.17,5.53,5.53,0,0,1,2,1.09,5.43,5.43,0,0,1,1.24,1.52,4.67,4.67,0,0,1,.53,1.42.93.93,0,0,1,0,.5A.86.86,0,0,1,148.84,162.32Zm-5.6-2.08a2.64,2.64,0,0,0-1.46.68,2.33,2.33,0,0,0-.78,1.31q1-.19,2.22-.45a15.42,15.42,0,0,0,2.13-.62,1.79,1.79,0,0,0-1-.8A2.28,2.28,0,0,0,143.24,160.24Z"
              fill="#8650df"
            />
            <path
              d="M157.18,155.84a1.47,1.47,0,0,1,.41-.6,1.34,1.34,0,0,1,.7-.26,8.87,8.87,0,0,1,1.2-.06A10.45,10.45,0,0,1,161,155c.37,0,.59.18.63.45a.9.9,0,0,1-.11.56c-.43.92-.9,1.83-1.4,2.72s-1.06,1.77-1.65,2.62c.6.53,1.23,1.05,1.87,1.56s1.32,1,2,1.47a.67.67,0,0,1,.33.45c0,.14-.09.3-.35.48a12.11,12.11,0,0,1-1.88.81,4.16,4.16,0,0,1-.58.15,1.81,1.81,0,0,1-1.15-.25,25,25,0,0,1-2.67-1.59c-.32.36-.63.71-1,1s-.66.68-1,1a1.86,1.86,0,0,1-.9.51,2.17,2.17,0,0,1-.74,0c-.3-.07-.58-.14-.86-.23a3.93,3.93,0,0,1-.78-.36.83.83,0,0,1-.42-.48.86.86,0,0,1,.27-.6c.45-.5.89-1,1.31-1.51s.85-1,1.26-1.55a25.35,25.35,0,0,1-1.86-1.88,21.54,21.54,0,0,1-1.65-2.08,1.23,1.23,0,0,1-.28-.55c-.05-.28.22-.57.8-.86a7,7,0,0,1,.87-.42l.91-.35.41-.14a2,2,0,0,1,.31-.08.68.68,0,0,1,.51.09,3.11,3.11,0,0,1,.42.41c.32.4.65.78,1,1.17s.68.76,1,1.13C156.22,157.76,156.72,156.81,157.18,155.84Z"
              fill="#8650df"
            />
            <path
              d="M161.86,156.69a2.75,2.75,0,0,1,0-.6.66.66,0,0,1,.17-.39.94.94,0,0,1,.42-.25l.74-.21-.1-.62c-.05-.28-.09-.56-.13-.84s-.07-.58-.11-.91a2.46,2.46,0,0,1,0-.73.86.86,0,0,1,.36-.52,2.69,2.69,0,0,1,.91-.4,14,14,0,0,1,1.7-.34,1,1,0,0,1,.8.15,1.16,1.16,0,0,1,.33.71c0,.08,0,.21,0,.41s0,.45.07.73.06.58.1.88.06.59.09.86l.82,0,.86,0a1.08,1.08,0,0,1,.71.19,1,1,0,0,1,.29.62c0,.15,0,.35.06.59s0,.48,0,.69a1,1,0,0,1-.24.65,1.51,1.51,0,0,1-.72.32c-.21.06-.44.12-.68.17l-.56.1c.1.48.21,1,.35,1.67s.26,1.24.4,1.82.25,1.11.35,1.58.16.78.19.92a1,1,0,0,1-.08.63,1.15,1.15,0,0,1-.63.36,12.27,12.27,0,0,1-1.78.38,1,1,0,0,1-.7-.09,1.12,1.12,0,0,1-.41-.68c-.33-1-.63-2-.89-3s-.53-2-.79-3.12l-.62,0a1.58,1.58,0,0,1-.76-.11,1,1,0,0,1-.38-.64c0-.16-.08-.32-.11-.48S161.88,156.81,161.86,156.69Z"
              fill="#8650df"
            />
          </g>
          <polygon
            points="164.77 194.62 164.77 167.36 98.09 171.32 102.78 196.38 164.77 194.62"
            fill="#f35c06"
          />
          <polygon
            points="121.57 188.47 154.44 189.78 153.5 214.41 124.86 215.72 121.57 188.47"
            fill="#058bff"
          />
          <polygon
            points="133.07 190.12 123.6 189.64 125.21 201.99 126.15 191.98 133.07 190.12"
            fill="#84e1eb"
          />
          <polygon
            points="144.46 190.99 152.8 191.21 153.03 200.12 150.45 193.52 144.46 190.99"
            fill="#84e1eb"
          />
          <polygon
            points="125.56 207.37 126.03 214.19 132.49 214.41 127.44 212.21 125.56 207.37"
            fill="#84e1eb"
          />
          <path
            d="M135.89,231.77l.24,5.57s-11-1.61-12.53.22C123.53,236.9,128.93,231.19,135.89,231.77Z"
            fill="#2c1272"
          />
          <polygon
            points="127.32 114.6 136.13 123.25 139.57 123.4 140.24 115.92 127.32 114.6"
            fill="#2c1272"
          />
          <path
            d="M121.88,108.74l4.15,4a113.1,113.1,0,0,0,13,1.2,14.85,14.85,0,0,1-.59-4.39Z"
            fill="#2c1272"
          />
          <path
            d="M120,107.72s4.78,2.63,17.61,2.63,21.21-2.41,23.48-3.81C146,109.47,120,107.72,120,107.72Z"
            fill="#bf22b4"
          />
          <path
            d="M149.65,108.94c-4.91-.22-6.19.17-5.86.55s-1.21,3.85,3.25,3.69S152,109.05,149.65,108.94Z"
            fill="#bf22b4"
          />
          <g style={{ mixBlendMode: 'soft-light' }}>
            <image
              width="130"
              height="126"
              transform="translate(72 14.99)"
              href="data:image/png;base64,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"
            />
          </g>
          <polygon
            points="107.83 172.09 99.56 172.58 101.38 180.88 101.55 173.74 107.83 172.09"
            fill="#f3a229"
          />
          <polygon
            points="102.31 185.06 103.84 195.06 119.57 194.73 105.95 192.53 102.31 185.06"
            fill="#f3a229"
          />
          <polygon
            points="144.81 170.11 163.25 169.12 162.89 178.57 160.9 171.54 144.81 170.11"
            fill="#f3a229"
          />
          <g>
            <ellipse
              cx="138.74"
              cy="131.96"
              rx="1.73"
              ry="1.62"
              fill="#6500f5"
              opacity="0.45"
              style={{ mixBlendMode: 'multiply' }}
            />
            <ellipse cx="138.41" cy="131.74" rx="1.73" ry="1.62" fill="#fff" />
            <path
              d="M139.58,130.56a1.5,1.5,0,0,1,.25.83,1.67,1.67,0,0,1-1.72,1.62,1.83,1.83,0,0,1-1.17-.43,1.76,1.76,0,0,0,1.47.78,1.68,1.68,0,0,0,1.73-1.62A1.55,1.55,0,0,0,139.58,130.56Z"
              fill="#cde6ff"
            />
          </g>
          <g>
            <ellipse
              cx="138.47"
              cy="151.24"
              rx="1.73"
              ry="1.62"
              fill="#6500f5"
              opacity="0.45"
              style={{ mixBlendMode: 'multiply' }}
            />
            <ellipse cx="138.14" cy="151.03" rx="1.73" ry="1.62" fill="#fff" />
            <path
              d="M139.31,149.84a1.54,1.54,0,0,1,.26.84,1.68,1.68,0,0,1-1.73,1.61,1.77,1.77,0,0,1-1.17-.43,1.74,1.74,0,0,0,1.47.78,1.67,1.67,0,0,0,1.73-1.61A1.59,1.59,0,0,0,139.31,149.84Z"
              fill="#cde6ff"
            />
          </g>
          <g>
            <path
              d="M119.54,147.15c-.47-.76-.91-1.53-1.31-2.31s-.8-1.57-1.17-2.39q-.15,1.25-.36,2.49c-.15.82-.32,1.67-.51,2.53a3.08,3.08,0,0,1-.12.42,1.68,1.68,0,0,1-.16.3,1,1,0,0,1-.25.21,1.49,1.49,0,0,1-.38.18,7.52,7.52,0,0,1-1.39.36,2.59,2.59,0,0,1-.88,0,1,1,0,0,1-.65-.46c-.5-.76-1-1.53-1.4-2.31s-.84-1.57-1.22-2.36-.74-1.6-1.1-2.41l-1.06-2.46,0-.14a.24.24,0,0,1,0-.12.46.46,0,0,1,.07-.39.89.89,0,0,1,.35-.26,6.67,6.67,0,0,1,.88-.34,8.09,8.09,0,0,1,.91-.23,1.2,1.2,0,0,1,.65.07,1.07,1.07,0,0,1,.44.52c.53,1.15,1.06,2.32,1.58,3.49s1.08,2.33,1.69,3.5c.18-1.19.32-2.4.42-3.61s.18-2.46.22-3.74a1.06,1.06,0,0,1,.2-.64,1.13,1.13,0,0,1,.59-.34l.29-.07.33,0,.36,0a2.28,2.28,0,0,1,.37,0,1.22,1.22,0,0,1,.58.15,1.47,1.47,0,0,1,.44.64l1.43,3.07c.48,1,1,2.08,1.55,3.14q.28-1.76.48-3.51c.13-1.18.25-2.39.37-3.64a.87.87,0,0,1,.21-.56,1,1,0,0,1,.62-.26,5.74,5.74,0,0,1,.77-.05c.3,0,.58,0,.86,0a1.51,1.51,0,0,1,.6.16.56.56,0,0,1,.23.4,1.53,1.53,0,0,1,0,.38c-.11,1.64-.3,3.29-.56,4.93s-.6,3.33-1,5.07a1.78,1.78,0,0,1-.34.77,1.14,1.14,0,0,1-.56.36l-.33.08-.32,0a4.43,4.43,0,0,1-.51.06l-.5,0a1.61,1.61,0,0,1-.83-.14A1.64,1.64,0,0,1,119.54,147.15Z"
              fill="#2aa7cf"
            />
            <path
              d="M126.09,136.28a3.64,3.64,0,0,1,0-.63c0-.17.13-.3.35-.39l.47-.15.56-.14.58-.13.5-.09a.38.38,0,0,1,.36.07.67.67,0,0,1,.12.32c0,.1.05.29.08.57s.08.6.13,1,.1.76.16,1.17.12.81.18,1.17a4.38,4.38,0,0,1,1.23-.81,5,5,0,0,1,1.44-.42,5.21,5.21,0,0,1,.83-.05,2.47,2.47,0,0,1,.92.18,2,2,0,0,1,.82.59,2.46,2.46,0,0,1,.49,1.19c.05.29.09.63.14,1s.1.81.14,1.26.09.93.12,1.42,0,1,.06,1.46a1.55,1.55,0,0,1-.08.53c-.06.17-.24.28-.54.32l-.68.06c-.29,0-.57,0-.83,0a.67.67,0,0,1-.67-.63c0-.12-.06-.53-.11-1.23s-.17-1.62-.37-2.77a1.11,1.11,0,0,0-.26-.6.59.59,0,0,0-.53-.16,3.65,3.65,0,0,0-1.75.87c.15.83.3,1.6.44,2.32s.29,1.31.43,1.79a1.54,1.54,0,0,1,.05.17.94.94,0,0,1,0,.16.53.53,0,0,1-.11.45,1.52,1.52,0,0,1-.71.28l-.26.06-.3,0-.29,0-.27,0a1,1,0,0,1-.73-.13,1.06,1.06,0,0,1-.31-.55c-.09-.33-.2-.71-.32-1.17s-.23-.94-.35-1.48-.24-1.11-.35-1.69-.23-1.19-.33-1.81-.19-1.18-.26-1.76S126.16,136.83,126.09,136.28Z"
              fill="#2aa7cf"
            />
            <path
              d="M143.93,144.45c-.32,0-.53,0-.62-.15a1,1,0,0,1-.19-.52,4.72,4.72,0,0,1-1.12.83,4.54,4.54,0,0,1-2.88.4,3.57,3.57,0,0,1-1.24-.54,3.26,3.26,0,0,1-.89-1,3.71,3.71,0,0,1-.46-1.31,4.39,4.39,0,0,1,.1-2,5.17,5.17,0,0,1,2.24-3,4.54,4.54,0,0,1,1.75-.65,4.15,4.15,0,0,1,1.57.07.71.71,0,0,1,.06-.43.51.51,0,0,1,.33-.16,7.31,7.31,0,0,1,.79,0,6.63,6.63,0,0,1,.92,0,2.13,2.13,0,0,1,.39.06.67.67,0,0,1,.28.14.57.57,0,0,1,.2.27,1.89,1.89,0,0,1,.12.46c.16,1,.3,2,.43,3.06s.2,2.13.24,3.14a1.26,1.26,0,0,1-.14.71,1,1,0,0,1-.59.34,1.59,1.59,0,0,1-.33.08l-.38.06-.31,0A1.23,1.23,0,0,1,143.93,144.45Zm-1.06-3q-.08-.62-.15-1.26c-.05-.44-.1-.87-.16-1.29a3.05,3.05,0,0,0-.54-.08,2.72,2.72,0,0,0-.63,0,2,2,0,0,0-.89.36,2.38,2.38,0,0,0-.59.64,2.43,2.43,0,0,0-.31.75,2,2,0,0,0,0,.72,1.28,1.28,0,0,0,.54.91,1.65,1.65,0,0,0,1.18.19,2.42,2.42,0,0,0,.83-.29A2.71,2.71,0,0,0,142.87,141.45Z"
              fill="#2aa7cf"
            />
            <path
              d="M146.29,137.36a1.82,1.82,0,0,1,0-.44.52.52,0,0,1,.13-.28.68.68,0,0,1,.3-.19c.13,0,.31-.1.54-.15l-.08-.45-.09-.62q0-.3-.09-.66a1.82,1.82,0,0,1,0-.53.66.66,0,0,1,.26-.39,2,2,0,0,1,.67-.29,9.49,9.49,0,0,1,1.24-.25.69.69,0,0,1,.58.1.83.83,0,0,1,.25.52,2.86,2.86,0,0,1,0,.3c0,.15,0,.32.05.53s.05.42.08.64,0,.43.07.63l.6,0c.2,0,.41,0,.62,0a.81.81,0,0,1,.52.13.74.74,0,0,1,.22.46,3.52,3.52,0,0,1,0,.43c0,.18,0,.35,0,.5a.71.71,0,0,1-.17.48,1.14,1.14,0,0,1-.53.23,5.16,5.16,0,0,1-.5.13l-.4.07c.07.36.16.76.26,1.22s.2.9.3,1.33.19.81.26,1.15.12.57.14.67a.61.61,0,0,1,0,.46.77.77,0,0,1-.46.26,8.4,8.4,0,0,1-1.3.29.75.75,0,0,1-.51-.06.84.84,0,0,1-.3-.49c-.25-.75-.47-1.49-.67-2.22s-.39-1.49-.58-2.28l-.46,0a1.06,1.06,0,0,1-.55-.08.68.68,0,0,1-.28-.46l-.09-.35C146.33,137.55,146.31,137.45,146.29,137.36Z"
              fill="#2aa7cf"
            />
            <path
              d="M153,131.36a.86.86,0,0,1,.72-.69,3.63,3.63,0,0,1,1,0,4.75,4.75,0,0,1,1.08.26,1.5,1.5,0,0,1,.48.24.52.52,0,0,1,.18.31,1.51,1.51,0,0,1-.06.6,11.48,11.48,0,0,1-.55,1.73,9.83,9.83,0,0,1-.84,1.65,2.16,2.16,0,0,1-.36.46.7.7,0,0,1-.4.18h-.32a3.88,3.88,0,0,1-.48,0,1.59,1.59,0,0,1-.44-.12.74.74,0,0,1-.51-.57,1.94,1.94,0,0,1,0-.27,2,2,0,0,1,0-.35c0-.11,0-.22,0-.32s0-.17,0-.2c0-.54.1-1,.17-1.47A12.08,12.08,0,0,1,153,131.36Z"
              fill="#2aa7cf"
            />
            <path
              d="M163.64,139.19a1.71,1.71,0,0,1-.13,1,2.49,2.49,0,0,1-.67.87,4,4,0,0,1-1.13.66,6.41,6.41,0,0,1-1.48.39,7.88,7.88,0,0,1-1.31.1,5.24,5.24,0,0,1-1.14-.12c-.33-.06-.52-.21-.56-.46a1.36,1.36,0,0,1,0-.35,4.45,4.45,0,0,1,.11-.52c.06-.19.1-.36.14-.51s.18-.37.3-.39a1.74,1.74,0,0,1,.47.06,2.57,2.57,0,0,0,.72.11,4,4,0,0,0,.62,0,2.07,2.07,0,0,0,.63-.18.3.3,0,0,0,.19-.34c0-.12-.13-.21-.33-.28a5.3,5.3,0,0,0-.71-.2l-.92-.23a4.57,4.57,0,0,1-.95-.37,2.77,2.77,0,0,1-.78-.63,2,2,0,0,1-.44-1,1.7,1.7,0,0,1,.16-1.11,2.85,2.85,0,0,1,.74-.94,5,5,0,0,1,1.15-.7,5.67,5.67,0,0,1,1.41-.39,9,9,0,0,1,1.28-.09,6.66,6.66,0,0,1,1.23.1,1,1,0,0,1,.47.19.74.74,0,0,1,.22.47,4.5,4.5,0,0,1,.06.78c0,.3,0,.56,0,.77a1,1,0,0,1-.15.41.68.68,0,0,1-.46.21,5.21,5.21,0,0,1-1.05.05.81.81,0,0,1-.47-.12.94.94,0,0,1-.17-.48l0-.11a2.67,2.67,0,0,0-.57,0,2.43,2.43,0,0,0-.73.22.39.39,0,0,0-.23.44c0,.11.13.21.34.28s.48.13.79.19.66.12,1,.21a4.82,4.82,0,0,1,1.05.36,2.67,2.67,0,0,1,.86.62A1.86,1.86,0,0,1,163.64,139.19Z"
              fill="#2aa7cf"
            />
            <path
              d="M153.91,134.75a6.48,6.48,0,0,1-.39.73,1.67,1.67,0,0,0-.28.61.75.75,0,0,1,.22-.26.5.5,0,0,0,.13.25,1.11,1.11,0,0,1,.41-.43,2.39,2.39,0,0,1-.36.6.1.1,0,0,1-.07,0,0,0,0,0,1,0,0,.28.28,0,0,1-.07-.13.14.14,0,0,1-.13.08c-.07,0-.11,0-.11-.07l-.08,0c-.14-.15.13-.49.22-.67a4,4,0,0,1,.23-.39C153.67,135,153.86,134.86,153.91,134.75Z"
              fill="#2aa7cf"
            />
            <path
              d="M146.83,137.37a1.15,1.15,0,0,1-.33.21,3.62,3.62,0,0,0,.57,0,3.6,3.6,0,0,0-.52.26,5.84,5.84,0,0,0,1.72,0,4.94,4.94,0,0,1-1.53.46l.27.16-.11.09.36.06a3.59,3.59,0,0,1-.8.27.14.14,0,0,1-.09,0,.23.23,0,0,1-.15-.19c0-.17-.07-.34-.1-.51a1.69,1.69,0,0,1,0-.5c0-.12.1-.14.21-.16l.27-.06A1.17,1.17,0,0,0,146.83,137.37Z"
              fill="#2aa7cf"
            />
            <path
              d="M149.49,138.42c.44.09.89-.17,1.33-.12a2.62,2.62,0,0,1-1,.43,1.87,1.87,0,0,0-.91.51l1.62-.31a.4.4,0,0,1-.17.17.17.17,0,0,0,.14,0,.2.2,0,0,0-.07.09l1-.09s.06,0,.06,0a0,0,0,0,0,0,0c-.14-.24-.34-.83-.67-.85a3.08,3.08,0,0,0-.67.09l-.34.07A1.17,1.17,0,0,1,149.49,138.42Z"
              fill="#2aa7cf"
            />
          </g>
          <path
            d="M133.05,198.76a1,1,0,0,1,.19-.64,1.41,1.41,0,0,1,.55-.42,9.81,9.81,0,0,1,1.15-.54,7,7,0,0,1,1.15-.34,9.29,9.29,0,0,1,1.28-.2,15.56,15.56,0,0,1,3.66.06,7,7,0,0,1,2,.55,4,4,0,0,1,1.45,1.07,2.65,2.65,0,0,1,.59,1.74,2.16,2.16,0,0,1-.19,1,3.42,3.42,0,0,1-.53.83,9.64,9.64,0,0,1-.78.8c-.29.26-.6.55-.92.86s-.77.81-1.17,1.29a8.61,8.61,0,0,0-1.1,1.75,1.57,1.57,0,0,1-.4.58,1.08,1.08,0,0,1-.63.16,5.24,5.24,0,0,1-1.11-.12,4,4,0,0,1-1.08-.44.82.82,0,0,1-.47-.7,1.36,1.36,0,0,1,.15-.6,10.41,10.41,0,0,1,.8-1.56,10.83,10.83,0,0,1,1-1.4,9.46,9.46,0,0,1,1.2-1.17,9,9,0,0,1,1.3-.91,5.59,5.59,0,0,0-.94-.17c-.32,0-.66,0-1,0a10.32,10.32,0,0,0-2.28.29,8.68,8.68,0,0,0-2.06.76l-.29.11a.74.74,0,0,1-.28.06.73.73,0,0,1-.65-.43,4,4,0,0,1-.44-1.05A5,5,0,0,1,133.05,198.76Zm5.49,9.5a9.64,9.64,0,0,1,1.17.06,1.84,1.84,0,0,1,.78.28,1.2,1.2,0,0,1,.45.58,3,3,0,0,1,.16,1,2,2,0,0,1-.1.66,1.06,1.06,0,0,1-.38.54,2.21,2.21,0,0,1-.77.35,5.29,5.29,0,0,1-1.26.14,7.58,7.58,0,0,1-1.16-.07,2,2,0,0,1-.76-.28,1.19,1.19,0,0,1-.42-.56,3,3,0,0,1-.13-.89,1.58,1.58,0,0,1,.54-1.34A3.12,3.12,0,0,1,138.54,208.26Z"
            fill="#fff"
          />
          <g>
            <ellipse
              cx="139.12"
              cy="172.56"
              rx="1.73"
              ry="1.62"
              fill="#6500f5"
              opacity="0.45"
              style={{ mixBlendMode: 'multiply' }}
            />
            <ellipse cx="138.79" cy="172.35" rx="1.73" ry="1.62" fill="#fff" />
            <path
              d="M140,171.16a1.54,1.54,0,0,1,.26.84,1.67,1.67,0,0,1-1.73,1.61,1.73,1.73,0,0,1-1.16-.43,1.73,1.73,0,0,0,1.47.78,1.67,1.67,0,0,0,1.72-1.61A1.55,1.55,0,0,0,140,171.16Z"
              fill="#cde6ff"
            />
          </g>
          <g>
            <ellipse
              cx="139.43"
              cy="193.81"
              rx="1.73"
              ry="1.62"
              fill="#6500f5"
              opacity="0.45"
              style={{ mixBlendMode: 'multiply' }}
            />
            <ellipse cx="139.1" cy="193.6" rx="1.73" ry="1.62" fill="#fff" />
            <path
              d="M140.27,192.41a1.53,1.53,0,0,1,.25.84,1.67,1.67,0,0,1-1.72,1.61,1.75,1.75,0,0,1-1.17-.43,1.73,1.73,0,0,0,1.47.78,1.68,1.68,0,0,0,1.73-1.61A1.59,1.59,0,0,0,140.27,192.41Z"
              fill="#cde6ff"
            />
          </g>
          <g>
            <path
              d="M109.11,176.35a.89.89,0,0,1,.19-.54,1.12,1.12,0,0,1,.6-.28,32.6,32.6,0,0,1,6-.74c.44,0,.94,0,1.48,0a6.79,6.79,0,0,1,1.54.26,3.32,3.32,0,0,1,1.21.63,1.45,1.45,0,0,1,.53,1.11,2.29,2.29,0,0,1-.09.54,3.77,3.77,0,0,1-.3.73,4.84,4.84,0,0,1-.54.83,5.19,5.19,0,0,1-.8.83c-.23.19-.43.36-.62.5s-.37.29-.56.42l.62,0,.63,0a2.92,2.92,0,0,1,1.86.41,1.91,1.91,0,0,1,.64,1.53,11.43,11.43,0,0,1-.09,1.77,15.08,15.08,0,0,1-.39,2.05,1.06,1.06,0,0,1-.31.58,1,1,0,0,1-.54.23c-.26,0-.52.08-.81.1s-.56.05-.84.06a.74.74,0,0,1-.52-.16.64.64,0,0,1-.21-.46,4.44,4.44,0,0,1,0-.45c0-.25,0-.54.08-.89s0-.71.07-1.1a10.74,10.74,0,0,0,0-1.13c-.47,0-1,0-1.49,0l-1,.06-1,.1c0,.22,0,.47.08.75s.07.55.1.81,0,.51.08.73,0,.37,0,.46a.76.76,0,0,1-.64.82,7.88,7.88,0,0,1-.87.16c-.3,0-.59.06-.88.07a1,1,0,0,1-.59-.13.77.77,0,0,1-.29-.56c-.14-.78-.26-1.5-.35-2.16s-.18-1.3-.24-1.92-.13-1.25-.17-1.87-.08-1.29-.11-2l-.25.06a1.44,1.44,0,0,1-.45.09.52.52,0,0,1-.39-.12.83.83,0,0,1-.23-.42,5,5,0,0,1-.19-1.13v-.29C109.1,176.54,109.11,176.44,109.11,176.35Zm4.76,1.46c.07.95.17,1.9.28,2.84A9.51,9.51,0,0,0,115,180a8.63,8.63,0,0,0,.8-.8q.36-.42.69-.84a8.5,8.5,0,0,0,.53-.81h-.58c-.35,0-.74,0-1.18.09S114.35,177.74,113.87,177.81Z"
              fill="#ffdc05"
            />
            <path
              d="M128.92,178.11a1.61,1.61,0,0,1,.37.17.39.39,0,0,1,.15.36.47.47,0,0,1,0,.12c0,.05,0,.14,0,.27a3.93,3.93,0,0,1,2.27,1.21,3.8,3.8,0,0,1,.54,4.08,3.94,3.94,0,0,1-1.06,1.3,5.09,5.09,0,0,1-1.52.83,6,6,0,0,1-1.72.32,8,8,0,0,1-2.14-.19,4.65,4.65,0,0,1-1.67-.75,3.56,3.56,0,0,1-1.08-1.29,4.18,4.18,0,0,1-.44-1.79,4,4,0,0,1,.38-1.91,4.61,4.61,0,0,1,1.12-1.49,5.42,5.42,0,0,1,1.6-1,5.63,5.63,0,0,1,1.84-.4l.68,0A7.06,7.06,0,0,1,128.92,178.11Zm-.43,3.28-.36-.12a.72.72,0,0,1-.24-.14.57.57,0,0,1-.14-.24,1.15,1.15,0,0,1-.06-.41,2.44,2.44,0,0,0-1.51.74,2,2,0,0,0-.56,1.52,1.39,1.39,0,0,0,.63,1.15,1.91,1.91,0,0,0,.63.29,2.69,2.69,0,0,0,.76.07,2.81,2.81,0,0,0,.75-.13,2,2,0,0,0,.66-.33,1.72,1.72,0,0,0,.46-.51,1.29,1.29,0,0,0,.15-.68,1.09,1.09,0,0,0-.34-.79A1.72,1.72,0,0,0,128.49,181.39Z"
              fill="#ffdc05"
            />
            <path
              d="M139.62,177.73a1.71,1.71,0,0,1,.38.17.44.44,0,0,1,.15.36.57.57,0,0,1,0,.12,2,2,0,0,1,0,.27,3.93,3.93,0,0,1,2.27,1.21,3.59,3.59,0,0,1,.9,2.33,3.36,3.36,0,0,1-.36,1.75,3.82,3.82,0,0,1-1.06,1.3,5,5,0,0,1-1.52.83,6,6,0,0,1-1.72.32,7.65,7.65,0,0,1-2.14-.19,4.6,4.6,0,0,1-1.66-.75,3.49,3.49,0,0,1-1.09-1.29,4.33,4.33,0,0,1-.44-1.79,4.09,4.09,0,0,1,.38-1.91,4.72,4.72,0,0,1,1.12-1.49,5.55,5.55,0,0,1,1.6-1,5.68,5.68,0,0,1,1.84-.4l.68,0A7.06,7.06,0,0,1,139.62,177.73Zm-.43,3.28a2.5,2.5,0,0,1-.36-.12.59.59,0,0,1-.23-.14.49.49,0,0,1-.15-.24,1.89,1.89,0,0,1-.06-.41,2.47,2.47,0,0,0-1.51.74,2,2,0,0,0-.56,1.53,1.44,1.44,0,0,0,.18.66,1.38,1.38,0,0,0,.45.48,2,2,0,0,0,.64.29,2.62,2.62,0,0,0,.75.07,2.75,2.75,0,0,0,.75-.13,2.24,2.24,0,0,0,.66-.32,1.89,1.89,0,0,0,.46-.52,1.29,1.29,0,0,0,.15-.68,1.09,1.09,0,0,0-.34-.79A1.77,1.77,0,0,0,139.19,181Z"
              fill="#ffdc05"
            />
            <path
              d="M152.06,178.33a4,4,0,0,1,1.28-1,3.75,3.75,0,0,1,1.46-.34,3.67,3.67,0,0,1,1,.09,2.46,2.46,0,0,1,.91.39,2.13,2.13,0,0,1,.67.73,2.45,2.45,0,0,1,.28,1.11c0,.3,0,.66,0,1.07s0,.85,0,1.32,0,1-.06,1.47-.08,1-.13,1.51a1.54,1.54,0,0,1-.15.54.64.64,0,0,1-.6.27,6.32,6.32,0,0,1-.71,0c-.3,0-.59,0-.85-.09a.68.68,0,0,1-.61-.73c0-.14,0-.56,0-1.28s0-1.69,0-2.9a1.61,1.61,0,0,0-.14-.65.39.39,0,0,0-.41-.23,2.63,2.63,0,0,0-1.53.67c0,.2,0,.41.05.63l0,.71c0,.48,0,1,0,1.58s0,1.1,0,1.57a1,1,0,0,1-.16.65.73.73,0,0,1-.6.23h-.4l-.55,0a4.38,4.38,0,0,1-.52,0,.69.69,0,0,1-.51-.24,1.13,1.13,0,0,1-.2-.57c0-.69-.07-1.36-.1-2s-.08-1.34-.17-2.05a1.52,1.52,0,0,0-.18-.61.4.4,0,0,0-.38-.22,1.74,1.74,0,0,0-.73.2,3.75,3.75,0,0,0-.66.43c0,.72.1,1.43.16,2.13s.15,1.39.25,2.08l0,.19a1,1,0,0,1,0,.17.54.54,0,0,1-.17.45,1.63,1.63,0,0,1-.77.21l-.28,0h-.89a1.1,1.1,0,0,1-.75-.21,1.2,1.2,0,0,1-.25-.6c-.13-.86-.24-1.72-.34-2.6s-.16-1.75-.19-2.65l0-.61c0-.21,0-.42,0-.62a3.92,3.92,0,0,1,.06-.66c0-.18.17-.3.41-.36a4.24,4.24,0,0,1,.5-.11l.6-.08.61-.06.53,0c.18,0,.3,0,.36.11a.51.51,0,0,1,.11.32v.2c0,.07,0,.15,0,.24a4.12,4.12,0,0,1,1-.59,3.49,3.49,0,0,1,1.09-.25,4.25,4.25,0,0,1,1.44.17A2.22,2.22,0,0,1,152.06,178.33Z"
              fill="#ffdc05"
            />
          </g>
        </g>
      </g>
      <g
        className={`${styles.pointer} prefix__static-item`}
        onClick={() => history.push('/digital-map')}
      >
        <g transform="translate(545 295)">
          <g>
            <rect
              x="114.2"
              y="22.41"
              width="2.77"
              height="47.31"
              rx="1.39"
              fill="#282117"
            />
            <path
              d="M114.08,21.53s1.84-3.72,9.63-5.79,20.17,7,24.53,5.74,6.3-7.33,6.3-7.33,1.15,9.4-5.27,16.88c8,.64,10.66-6.69,10.66-6.69s0,16.25-15.47,21.51c-15.18,5.15-22.47-7.49-30.61,0C113.51,29.12,114.08,21.53,114.08,21.53Z"
              fill="#baf908"
            />
            <g>
              <rect
                x="128.07"
                y="20.36"
                width="7.19"
                height="3.17"
                fill="#18adb1"
              />
              <rect
                x="121"
                y="23.46"
                width="7.19"
                height="3.17"
                transform="translate(25.32 104.39) rotate(-50)"
                fill="#18adb1"
              />
              <rect
                x="118.92"
                y="30.61"
                width="7.19"
                height="3.17"
                transform="translate(112.08 158.43) rotate(-100)"
                fill="#18adb1"
              />
              <rect
                x="123.54"
                y="36.42"
                width="7.19"
                height="3.17"
                transform="translate(218.23 134.49) rotate(-150)"
                fill="#18adb1"
              />
              <rect
                x="130.91"
                y="37.05"
                width="7.19"
                height="3.17"
                transform="matrix(-0.94, 0.34, -0.34, -0.94, 274.11, 28.93)"
                fill="#18adb1"
              />
              <rect
                x="135.87"
                y="31.57"
                width="7.19"
                height="3.17"
                transform="translate(218.32 -86.56) rotate(110)"
                fill="#18adb1"
              />
              <rect
                x="134.81"
                y="23.98"
                width="7.19"
                height="3.17"
                transform="translate(81.07 -102.97) rotate(55.49)"
                fill="#18adb1"
              />
              <path
                d="M131.11,21.83a8.78,8.78,0,1,0,8.77,8.77A8.78,8.78,0,0,0,131.11,21.83Zm0,14.13a5.36,5.36,0,1,1,5.35-5.36A5.36,5.36,0,0,1,131.11,36Z"
                fill="#18adb1"
              />
            </g>
            <path
              d="M159.93,24.34s-2.64,7.33-10.66,6.69c6.42-7.48,5.27-16.88,5.27-16.88s-1.95,6-6.3,7.33c-2,.58-5.62-1-9.74-2.67,2.14,5.86,3.24,14.29.88,21.14a29.27,29.27,0,0,1-3.55,7.14,22.74,22.74,0,0,0,8.63-1.24C159.93,40.59,159.93,24.34,159.93,24.34Z"
              fill="#baf908"
              style={{ mixBlendMode: 'multiply' }}
            />
            <ellipse
              cx="186.44"
              cy="245.88"
              rx="185.75"
              ry="97.26"
              fill="#2fc2f3"
            />
            <path
              d="M79.87,197.48c-11.74,1.57-37.22,16.4-39.13,27.14s12.74,10,11.47,18-2.46,16.53,8,22.46,21.29,11.8,27.66,17.46,8.25,2.42,19.42,6.59,15.56,12.32,12.73,18.76-5.31,11.93-2.8,15.87,130.38,12.08,151.5,1.32S247,298,245.83,296.32s4.5-5.62,19.8-10.67,18.48-8.3,40.46-21,16.25-22.48,19.44-31.61,20.87-2.47,25.48-11.69,3.9-10.49-3.77-15.77-22.55-22.51-35.09-23.3-20-11.78-27.9-13.07-39.77-7.84-56.08-8.76-130.19,4.24-148.3,37"
              fill="#19a7d7"
            />
            <ellipse
              cx="182.78"
              cy="234.85"
              rx="125.23"
              ry="65.57"
              fill="#6bc60a"
            />
            <path
              d="M181.29,158.14c47.92,0,88.11,19.18,126.71,26.38a64.28,64.28,0,0,1,27.1,12.95C346.51,207.16,358.68,213.9,367,223c-19.64-42.69-93-74.41-180.59-74.41C105.1,148.61,36,176,10.83,214.1c12-10.82,26-23.22,44.33-28.95C74.78,179,94.86,170.68,117.23,166,137.63,161.7,158.47,158.14,181.29,158.14Z"
              fill="#855212"
            />
            <path
              d="M71.91,207.77a8.58,8.58,0,0,1-6.93-8c0-3.43-3.13-16.64,11.12-24.46,9.1-5,12.33,13.3,10.34,20.78S74.67,208.21,71.91,207.77Z"
              fill="#dce6ff"
            />
            <path
              d="M89.89,192.69c-4.45-.79-7.8-4.51-8-7.64s-4.1-15.36,11.38-21.76c9.88-4.08,14.14,12.78,12.23,19.5S93,193.23,89.89,192.69Z"
              fill="#dce6ff"
            />
            <path
              d="M127.89,178.17c-5.84-1.09-10.44-5.09-10.86-8.29s-6.34-15.86,13.33-21.31c12.55-3.48,19.21,13.91,17.18,20.61S131.91,178.93,127.89,178.17Z"
              fill="#dce6ff"
            />
            <ellipse
              cx="114.32"
              cy="218.58"
              rx="48.26"
              ry="22.7"
              fill="#55a32a"
            />
            <path
              d="M145.13,210.46c1.58.29,1.41-3.05,1.12-4.62C144.76,206.74,142.85,210,145.13,210.46Z"
              fill="#6c9b23"
            />
            <path
              d="M138.42,219.47l-9-107H100.51l-9,107a6.11,6.11,0,0,0-.07.86c0,6.37,10.54,11.53,23.54,11.53s23.54-5.16,23.54-11.53A6.11,6.11,0,0,0,138.42,219.47Z"
              fill="#fffad1"
            />
            <path
              d="M117.23,112.42,122.4,231.2c9.4-1.51,16.19-5.84,16.19-10.95a5,5,0,0,0-.08-.87l-9-107Z"
              fill="#ebd6ff"
            />
            <g>
              <path
                d="M142.88,117.66c-.09-.15-.18-.3-.29-.45a37.39,37.39,0,0,1-12.83-13.08C124.56,95.2,120,76.82,120,76.82h-10s-5.62,17.91-11.5,26.67a99.12,99.12,0,0,1-11.49,14.25l-.7,1.61s-1.6,2.89.2,4.72a4,4,0,0,0,3.8,1.26A4.32,4.32,0,0,0,92.73,128a5.35,5.35,0,0,0,3.46,0l.06,0A4,4,0,0,0,99,129.91a7.35,7.35,0,0,0,3.69-.35,4.6,4.6,0,0,0,6.1.77A8.54,8.54,0,0,0,113,131.6c2.24.12,3.14-.8,3.35-1.06h.1a4.07,4.07,0,0,0,3.24,1,5,5,0,0,0,3.6-1.34,4.51,4.51,0,0,0,3.09.7,3.84,3.84,0,0,0,3-1.69,8.68,8.68,0,0,0,4.6.29c2.39-.57,2.39-2.26,2.39-2.26a5.05,5.05,0,0,0,3.2-.49,1.85,1.85,0,0,0,1.1-2.11,2.87,2.87,0,0,0,2.79-.77c1.2-1.27,0-2.89,0-2.89s1.1.21,1.4-.42C145.1,120.07,143.63,118.44,142.88,117.66Z"
                fill="#4842d5"
              />
              <path
                d="M126.39,130.89a3.84,3.84,0,0,0,3-1.69,8.68,8.68,0,0,0,4.6.29c2.39-.57,2.39-2.26,2.39-2.26a5.05,5.05,0,0,0,3.2-.49,1.85,1.85,0,0,0,1.1-2.11,2.87,2.87,0,0,0,2.79-.77c1.2-1.27,0-2.89,0-2.89s1.1.21,1.4-.42c.23-.48-1.24-2.11-2-2.89-.09-.15-.18-.3-.29-.45,0,0-4.57-5.11-10.91-13.08S120,76.82,120,76.82h-5.1l8,53.74a2.79,2.79,0,0,0,.43-.37A4.51,4.51,0,0,0,126.39,130.89Z"
                fill="#392ec6"
              />
              <ellipse
                cx="114.94"
                cy="76.82"
                rx="5.01"
                ry="1.86"
                fill="#ae133e"
              />
            </g>
            <path
              d="M101.27,139.56l-2.63-.12a1.73,1.73,0,0,1-1.75-1.85l.14-1.4a2,2,0,0,1,2.11-1.66l2.62.12a1.75,1.75,0,0,1,1.76,1.85l-.14,1.39A2,2,0,0,1,101.27,139.56Z"
              fill="#ffffea"
            />
            <path
              d="M122.16,166.71l-4.14.07c-1.69,0-3-.92-3-2.11l.06-1.71c0-1.19,1.45-2.18,3.13-2.2l4.14-.07c1.69,0,3,.91,3,2.1l-.06,1.71C125.24,165.69,123.84,166.68,122.16,166.71Z"
              fill="#ffffea"
            />
            <path
              d="M99.44,201.34l-3.15-.17c-1.28-.07-2.24-.86-2.15-1.77l.14-1.29c.1-.9,1.22-1.58,2.5-1.51l3.16.17c1.28.07,2.24.86,2.14,1.76l-.14,1.29C101.85,200.73,100.73,201.4,99.44,201.34Z"
              fill="#ffffea"
            />
            <path
              d="M114.61,218.81l-3.15-.17c-1.29-.06-2.25-.85-2.15-1.76l.14-1.29c.1-.91,1.22-1.58,2.5-1.51l3.16.17c1.28.07,2.24.85,2.14,1.76l-.14,1.29C117,218.21,115.89,218.88,114.61,218.81Z"
              fill="#ffffea"
            />
            <path
              d="M102.76,215.38l-5-.27c-2-.11-3.55-1.35-3.4-2.78l.23-2.05c.15-1.43,1.92-2.5,4-2.39l5,.27c2,.11,3.54,1.35,3.39,2.78l-.22,2.05C106.56,214.42,104.79,215.49,102.76,215.38Z"
              fill="#ffffea"
            />
            <path
              d="M104.5,226l-3.15-.17c-1.29-.07-2.25-.85-2.15-1.76l.14-1.29c.1-.91,1.22-1.58,2.5-1.52l3.15.17c1.29.07,2.25.86,2.15,1.77l-.14,1.29C106.9,225.35,105.78,226,104.5,226Z"
              fill="#ffffea"
            />
            <path
              d="M123.59,178l-3.16.09c-1.28,0-2.37-.66-2.42-1.57l-.08-1.3c-.05-.9.95-1.67,2.23-1.7l3.16-.1c1.29,0,2.37.67,2.43,1.57l.07,1.3C125.88,177.23,124.88,178,123.59,178Z"
              fill="#ffffea"
            />
            <path
              d="M124.33,197.39l-4.83.14c-2,.06-3.62-1-3.7-2.4l-.12-2c-.08-1.39,1.44-2.56,3.41-2.61l4.82-.15c2-.06,3.63,1,3.71,2.4l.12,2C127.82,196.16,126.29,197.33,124.33,197.39Z"
              fill="#ffffea"
            />
            <path
              d="M137.89,202l-3.16.09c-1.28,0-2.37-.66-2.42-1.57l-.08-1.3c0-.9.94-1.67,2.23-1.71l3.16-.09c1.29,0,2.37.67,2.43,1.57l.07,1.3C140.18,201.17,139.18,201.94,137.89,202Z"
              fill="#ffffea"
            />
            <path
              d="M134.4,172.18l-3.16.09c-1.29,0-2.38-.66-2.43-1.57l-.08-1.29c0-.91,1-1.67,2.23-1.71l3.16-.1c1.29,0,2.37.67,2.43,1.58l.08,1.29C136.68,171.38,135.68,172.14,134.4,172.18Z"
              fill="#ffffea"
            />
            <path
              d="M125.6,218.89l-3.52.1c-1.19,0-2.19-.61-2.24-1.45l-.09-1.55c0-.84.87-1.54,2-1.58l3.52-.1c1.19,0,2.19.61,2.24,1.45l.09,1.55C127.7,218.15,126.78,218.85,125.6,218.89Z"
              fill="#ffffea"
            />
            <path
              d="M114.07,124.28s.14,1.81,2.79,2.13a3.24,3.24,0,0,0,3.47-2,3,3,0,0,1-3.45,3C113.4,127.2,114.07,124.28,114.07,124.28Z"
              fill="#392ec6"
            />
            <path
              d="M109.83,120.27s.14,1.81,2.78,2.13a3.23,3.23,0,0,0,3.47-2.05,3,3,0,0,1-3.45,3C109.15,123.19,109.83,120.27,109.83,120.27Z"
              fill="#392ec6"
            />
            <path
              d="M90,117.08s-.51,1.78,2,2.54a3.91,3.91,0,0,0,4.08-1.37,3.7,3.7,0,0,1-4.41,2.34C88.33,119.79,90,117.08,90,117.08Z"
              fill="#392ec6"
            />
            <path
              d="M97.56,113.52s-.51,1.78,2,2.55a3.93,3.93,0,0,0,4.08-1.37A3.69,3.69,0,0,1,99.18,117C95.88,116.23,97.56,113.52,97.56,113.52Z"
              fill="#392ec6"
            />
            <path
              d="M106.73,108.84s0,1.81,2.64,2.21a3.36,3.36,0,0,0,3.6-1.93,3.12,3.12,0,0,1-3.64,2.92C105.86,111.73,106.73,108.84,106.73,108.84Z"
              fill="#392ec6"
            />
            <path
              d="M131.52,110.34s0,1.81-2.64,2.21a3.36,3.36,0,0,1-3.6-1.93,3.12,3.12,0,0,0,3.64,2.92C132.39,113.23,131.52,110.34,131.52,110.34Z"
              fill="#4842d5"
            />
            <path
              d="M130.49,119.41s.37,1.79-2.14,2.46a3.78,3.78,0,0,1-4-1.52,3.52,3.52,0,0,0,4.22,2.5C132,122.18,130.49,119.41,130.49,119.41Z"
              fill="#4842d5"
            />
            <path
              d="M138.61,115.09s.37,1.8-2.14,2.47a3.78,3.78,0,0,1-4-1.53,3.54,3.54,0,0,0,4.22,2.51C140.09,117.86,138.61,115.09,138.61,115.09Z"
              fill="#4842d5"
            />
            <path
              d="M100,124.12s-.32,1.8,2.21,2.43a3.71,3.71,0,0,0,3.92-1.58,3.47,3.47,0,0,1-4.15,2.56C98.61,126.91,100,124.12,100,124.12Z"
              fill="#392ec6"
            />
            <path
              d="M115.49,214.29a1.19,1.19,0,0,1,.16.73l-.14,1.3c-.1.9-1.21,1.58-2.5,1.51l-3.15-.17a2.6,2.6,0,0,1-.39,0,2.36,2.36,0,0,0,2,1l3.15.17c1.28.07,2.4-.6,2.5-1.51l.14-1.29C117.34,215.2,116.58,214.48,115.49,214.29Z"
              fill="#ebd6ff"
            />
            <path
              d="M100.24,196.7a1.19,1.19,0,0,1,.16.73l-.14,1.3c-.1.9-1.22,1.58-2.5,1.51l-3.15-.17a2.44,2.44,0,0,1-.39,0,2.39,2.39,0,0,0,2,1l3.15.17c1.28.06,2.4-.61,2.5-1.52l.14-1.29C102.09,197.61,101.32,196.89,100.24,196.7Z"
              fill="#ebd6ff"
            />
            <path
              d="M104,208.05a2,2,0,0,1,.25,1.16l-.22,2c-.16,1.43-1.93,2.5-4,2.39l-5-.27a6.18,6.18,0,0,1-.62-.07,3.81,3.81,0,0,0,3.14,1.63l5,.27c2,.11,3.8-1,4-2.39l.22-2C107,209.49,105.74,208.35,104,208.05Z"
              fill="#ebd6ff"
            />
            <path
              d="M105.3,221.47a1.19,1.19,0,0,1,.16.73l-.14,1.3c-.1.9-1.22,1.58-2.5,1.51l-3.16-.17a2.32,2.32,0,0,1-.38-.05,2.37,2.37,0,0,0,2,1l3.16.17c1.28.06,2.4-.61,2.5-1.52l.14-1.29C107.14,222.38,106.38,221.66,105.3,221.47Z"
              fill="#ebd6ff"
            />
            <path
              d="M122.09,143l-4.67.08c-1.89,0-3.39-1-3.34-2.38l.07-1.92c0-1.34,1.63-2.46,3.53-2.49l4.67-.08c1.9,0,3.39,1,3.34,2.37l-.07,1.93C125.57,141.81,124,142.93,122.09,143Z"
              fill="#ffffea"
            />
            <path
              d="M130.7,151.5l-3.76.46c-1.53.19-2.83-.54-2.9-1.63l-.1-1.56c-.08-1.08,1.1-2.12,2.63-2.3l3.76-.46c1.53-.19,2.82.54,2.9,1.63l.1,1.56C133.4,150.28,132.23,151.31,130.7,151.5Z"
              fill="#ffffea"
            />
            <path
              d="M109.53,78.17c.57-5.45,1.68-11.08,9-12.58,5.81-1.2,12,1.42,11,5.59-.57,2.59-4.67,4.59-4.67,4.59s3.37-6.74-1.7-6.79c-9.49-.1-3,9.1-3,9.1S113.92,80.7,109.53,78.17Z"
              fill="#4842d5"
            />
            <path
              d="M115.33,79.51a14.45,14.45,0,0,1,0-6.54c.85-3.39,5-3.59,5-3.59s-1.62-.2-1.55,2.19,1.78,7,1.78,7Z"
              fill="#392ec6"
            />
            <g>
              <path
                d="M106.11,190.82,101.6,190c-1.75-.31-3-3.82-2.85-8l1-28.17a24,24,0,0,1,2.43-10.25h0c2.25-4.05,5.29-3.94,7.24.26h0c1.72,3.69,2.6,9.12,2.38,14.8L111,180.84C110.81,186.69,108.57,191.25,106.11,190.82Z"
                fill="#ffbe3a"
              />
              <path
                d="M99.8,153.86a24,24,0,0,1,2.43-10.25h0c2.25-4.05,5.29-3.94,7.24.26h0a25.88,25.88,0,0,1,1.94,6.81l.44,8.25L111,180.84v.07L99.72,156.09Z"
                fill="#fff"
                opacity="0.26"
              />
              <path
                d="M106.11,190.82,101.6,190c-1.75-.31-3-3.82-2.85-8l1-28.17a24,24,0,0,1,2.43-10.25h0c2.25-4.05,5.29-3.94,7.24.26h0c1.72,3.69,2.6,9.12,2.38,14.8L111,180.84C110.81,186.69,108.57,191.25,106.11,190.82Z"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
              />
            </g>
            <path
              d="M370.17,231.5c-3.81,52-85.45,93.47-185.61,93.47C91.3,325,14.09,289,.83,242.08c-.09,1.26-.14,2.52-.14,3.8,0,53.71,83.16,97.26,185.75,97.26s185.75-43.55,185.75-97.26A52.52,52.52,0,0,0,370.17,231.5Z"
              fill="#19a7d7"
            />
            <path
              d="M304.37,272.58c-1.15-.79-7.3,3.52-14,7.06-7.16,3.8-14.88,6.95-16.14,9-2.41,4,13.18-1.07,15.81-1.67s2.64.62,4,3.52,9-1.49,13-1.85,3.5,3.65,5,4.2,4.24,1.26,6.16-1.54,5.31-1.68,9.76-7.33-4.67-1.14-8.07,0-2.33-5.46-3.18-6-13.42,7.09-14.78,4.14S309.68,276.18,304.37,272.58Z"
              fill="#eff2f3"
            />
            <path
              d="M54.76,271.25c-2.24,2.83,3.66,12.35,12.74,17.92s21.64,7.3,23.89,5.08-9-7.4-19-13.42C63.71,275.55,56.62,268.89,54.76,271.25Z"
              fill="#eff2f3"
            />
            <path
              d="M53.24,277.38C51,280.22,56.91,289.74,66,295.3s21.65,7.3,23.9,5.08-9-7.4-19-13.42C62.2,281.68,55.1,275,53.24,277.38Z"
              fill="#eff2f3"
            />
            <path
              d="M299.51,212.07a8.58,8.58,0,0,0,6.93-8c0-3.44,3.13-16.65-11.12-24.46-9.1-5-12.33,13.29-10.34,20.78S296.75,212.51,299.51,212.07Z"
              fill="#dce6ff"
            />
            <path
              d="M281.83,202.33a8.59,8.59,0,0,0,6.93-8c0-3.44,3.13-16.65-11.12-24.46-9.1-5-12.33,13.29-10.34,20.77S279.08,202.77,281.83,202.33Z"
              fill="#dce6ff"
            />
            <path
              d="M251.37,181.31c4-.63,8.51-17.43,8.54-20.87s-5.34-7.39-15.29-9.82-14.19,14.46-12.2,21.94S248.61,181.75,251.37,181.31Z"
              fill="#dce6ff"
            />
            <ellipse
              cx="234.9"
              cy="220.79"
              rx="48.26"
              ry="22.7"
              fill="#55a32a"
            />
            <path
              d="M228.82,233.13c2.23,1.72,35.92,18,48.35,44.81-62.06,32.44-137.6,25.28-179.92,4.8,9.86-29.4,44.33-46,63.21-51.11C187.59,224.29,228.82,233.13,228.82,233.13Z"
              fill="#d9b880"
            />
            <path
              d="M160.9,168.8a1.65,1.65,0,0,0-2.32.16,8.46,8.46,0,0,0-4.7-2.13l-.09,1.54c-1.24-.28-2.32-1.08-3.57-1.31-2.41-.46-5.31,1.12-7.13-.52a2.65,2.65,0,0,1-2.43,1.69,5.88,5.88,0,0,0-2.7,4.36,2,2,0,0,1-.44,1.32,1.58,1.58,0,0,1-.87.28l-4.25.51a1.58,1.58,0,0,0-1.29.6c-.39.73.52,1.52.53,2.35s-.78,1.35-1.54,1.52-1.57.1-2.31.34-1.43,1-1.2,1.74c.46,1.47-.19,3.12-.27,4.65a2.87,2.87,0,0,0,.19,1.46c.38.71,1.35,1,1.53,1.83s-.62,1.57-.72,2.42c-.14,1.26,1.25,2.08,2.43,2.56a4.41,4.41,0,0,0,4.8,1.57c1.15-.37,2.26-1.25,3.42-.93,1.82.51,2.22,3.58,4.1,3.61.76,0,1.65-.48,2.19.05a1.82,1.82,0,0,1,.36,1.08,5.13,5.13,0,0,0,5,4.26,1.72,1.72,0,0,0,.81-.18,2.09,2.09,0,0,0,.55-.56l1.61-2.18a1.82,1.82,0,0,0,2.47.55,2.74,2.74,0,0,0,1.19-2.42,3.46,3.46,0,0,1,2.83-3.44,3.57,3.57,0,0,1,1.79.53l6.91,3.44a1,1,0,0,0,1.55-.32,21.81,21.81,0,0,0,3.21-6.48,10.25,10.25,0,0,0,7.9,4.65,9.16,9.16,0,0,0,6.8-1.92,6.09,6.09,0,0,0,1.93-6.54,7.79,7.79,0,0,0-1.43-10.24c1.29-.93,1.17-2.86.76-4.39a22.39,22.39,0,0,0-11.92-14.19,4.44,4.44,0,0,0-2.83-.56,1.76,1.76,0,0,0-1.36,2.19C171.49,161.36,161.25,168.5,160.9,168.8Z"
              fill="#527e23"
            />
            <path
              d="M189.06,166.34a25.17,25.17,0,0,0-6.23-21.11,4.9,4.9,0,0,0-2.58-1.71,1.92,1.92,0,0,0-2.29,1.57c-.81-6.77-9.43-11.25-15.44-8-2.72-1.18-5.57-2.38-8.54-2.26s-6.09,2-6.65,4.89a7.05,7.05,0,0,0-8.16,10c-4.77,1.81-6.4,8.93-2.87,12.62-2.33-.7-4.9,1.08-5.62,3.4a8,8,0,0,0,1.51,6.86,7.51,7.51,0,0,1,1.67,2.86c.28,1.45-.56,2.85-.89,4.29-1,4.61,3.39,8.66,7.77,10.44C158.41,197.36,185.61,186.08,189.06,166.34Z"
              fill="#527e23"
            />
            <ellipse
              cx="190.07"
              cy="110.34"
              rx="22.85"
              ry="8.51"
              fill="#feaf26"
            />
            <path
              d="M228.64,232.09,212.91,110.34H167.22s-2.52,17.39-2.63,20.31c-1.13.89-2.93,5.74-1.16,8.9-1.3,1-1,7.81-1,7.81l-1.07,8.29a19.66,19.66,0,0,0-1.1,7.08c-1.25,1.49-1.54,6.25-1.06,9.6a15.14,15.14,0,0,0-1.26,9.69c-.74.72-1.78,4.16-1,7.84-1.72,2.67-1.11,8.54-1.11,8.54a12.87,12.87,0,0,0-1,7.76c-.75.88-1.75,6.23-1.26,9.69-.92,1.19-2.28,5.47-.93,7.18-1.35,1.8-1.17,9.05-1.17,9.05a5.54,5.54,0,0,0-.18,1.4c0,8,17.36,14.44,38.77,14.44s38.78-6.46,38.78-14.44A6,6,0,0,0,228.64,232.09Z"
              fill="#fffad1"
            />
            <path
              d="M228.82,233.48a6,6,0,0,0-.18-1.39L212.91,110.34H167.22l-1.82,14a65.59,65.59,0,0,0,28.08,4l3.63,119.33C217.68,247.92,228.82,239.07,228.82,233.48Z"
              fill="#ebd6ff"
            />
            <path
              d="M175.42,246.86s-1.68-44.93,15.84-44.55,14.65,44.88,14.65,44.88S190,249.69,175.42,246.86Z"
              fill="#a122ff"
            />
            <path
              d="M222.07,108.58h0v0a6.66,6.66,0,0,0-.75-1.34A191,191,0,0,1,207.4,88c-7-11.1-11.7-26.32-11.7-26.32,0-1.16-2.51-2.51-5.63-2.51s-5.67.95-5.67,2.11c0,0-4.33,17.79-10.55,27.26a168.2,168.2,0,0,1-15.43,19.26l-.08.14,0,0h0a5,5,0,0,0-.6,2.32c0,6.66,14.49,12,32.36,12s32.35-5.39,32.35-12A4.72,4.72,0,0,0,222.07,108.58Z"
              fill="#4842d5"
            />
            <path
              d="M211.91,140.81s2.75,19.26-3,25.72c-7.27,14.06.32,30,14.2,29.65,18.06-6.84,21.1-45.54,20-54.13C242.7,137.27,211.91,140.81,211.91,140.81Z"
              fill="#fffad1"
            />
            <path
              d="M222.42,110.34a4.72,4.72,0,0,0-.35-1.76h0v0a6.66,6.66,0,0,0-.75-1.34A191,191,0,0,1,207.4,87.48c-5.28-9.06-11.67-26.17-11.67-26.17a1,1,0,0,0-.3-.67,7.76,7.76,0,0,1-5.36,1.69c3.9,26.14,7.05,47.41,8.85,59.6C212.49,120.5,222.42,115.85,222.42,110.34Z"
              fill="#392ec6"
            />
            <path
              d="M243.08,142.05c-.38-4.78-31.17-1.24-31.17-1.24a80.29,80.29,0,0,1,.66,10.6c4.39,1.39,13.57,3.85,20.19,2.64-3.94,29.83-13.81,38.19-20,38.69a15.54,15.54,0,0,0,10.39,3.44C241.18,189.34,244.22,150.64,243.08,142.05Z"
              fill="#ebd6ff"
            />
            <path
              d="M158.05,108.61s-2.19,3.51-1.38,5.41c1.24,2.9,4.32,1.62,4.32,1.62a4.83,4.83,0,0,0,3.17,4.39c3.23,1.27,5-.49,5-.49a4.57,4.57,0,0,0,3.42,3.33,5.37,5.37,0,0,0,4.8-1.44,5.15,5.15,0,0,0,4,3,5,5,0,0,0,4.68-2.1,4.48,4.48,0,0,0,4,2.55c3.51,0,4-2.55,4-2.55a6.19,6.19,0,0,0,4.69,2.09,4.65,4.65,0,0,0,3.8-2.93,5.12,5.12,0,0,0,4.74,1.36,3.91,3.91,0,0,0,3.36-3.1,7.28,7.28,0,0,0,4.12.44,3.34,3.34,0,0,0,2.67-3.4s2.78.49,4.23-1.22.75-5.2.75-5.2-25.13,7.86-40.65,6.53S158.05,108.61,158.05,108.61Z"
              fill="#4842d5"
            />
            <path
              d="M198.93,124.37a4.7,4.7,0,0,0,3.62-2.91,5.12,5.12,0,0,0,4.74,1.36,3.91,3.91,0,0,0,3.36-3.1,7.28,7.28,0,0,0,4.12.44,3.34,3.34,0,0,0,2.67-3.4s2.78.49,4.23-1.22.75-5.9.75-5.9a191.88,191.88,0,0,1-24.49,5.56Z"
              fill="#392ec6"
            />
            <path
              d="M249.69,140.81h0a4.74,4.74,0,0,0-.53-1l-12-9.61-6-22.76c0-.83-1.79-1.49-4-1.49s-4,.66-4,1.49a179.6,179.6,0,0,1-10,20.77c-6.49,11.73-8.38,12-8.38,12l0,.09,0,0h0a3.44,3.44,0,0,0-.42,1.63c0,4.7,10.21,8.5,22.82,8.5s22.82-3.8,22.82-8.5A3.39,3.39,0,0,0,249.69,140.81Z"
              fill="#4842d5"
            />
            <path
              d="M249.94,142.05a3.39,3.39,0,0,0-.25-1.24h0a4.74,4.74,0,0,0-.53-1s-1.71-1.5-8.66-12.59a85.09,85.09,0,0,1-9.39-19.78v0a7.81,7.81,0,0,1-3.45.54c.42,4.55,4.49,30.75,6.28,42.2C243.21,149.08,249.94,145.86,249.94,142.05Z"
              fill="#392ec6"
            />
            <path
              d="M189.23,117.72s1.17,3.62,4.77,3.79,4.21-4.85,4.21-4.85-1.24,3-4,3A7.65,7.65,0,0,1,189.23,117.72Z"
              fill="#392ec6"
            />
            <path
              d="M160,108.34s-.58,3.69,2.71,5.14,5.78-2.07,5.78-2.07a6,6,0,0,1-4.91.47A6.19,6.19,0,0,1,160,108.34Z"
              fill="#392ec6"
            />
            <path
              d="M179.25,82s-.58,3.69,2.71,5.15,5.78-2.08,5.78-2.08a6,6,0,0,1-4.9.47A6.17,6.17,0,0,1,179.25,82Z"
              fill="#392ec6"
            />
            <path
              d="M186.65,61.44s-.58,3.69,2.71,5.14,5.78-2.08,5.78-2.08a6,6,0,0,1-4.91.48A6.19,6.19,0,0,1,186.65,61.44Z"
              fill="#392ec6"
            />
            <path
              d="M173.42,115.86s.3,3.73,3.85,4.36,5.12-3.39,5.12-3.39a6,6,0,0,1-4.66,1.63A6.14,6.14,0,0,1,173.42,115.86Z"
              fill="#392ec6"
            />
            <path
              d="M170.26,100.31s-.4,3.71,3,5,5.67-2.35,5.67-2.35a6,6,0,0,1-4.88.71A6.19,6.19,0,0,1,170.26,100.31Z"
              fill="#392ec6"
            />
            <path
              d="M186.65,80.49s.65,3.68,4.23,4,4.8-3.84,4.8-3.84a6,6,0,0,1-4.49,2A6.21,6.21,0,0,1,186.65,80.49Z"
              fill="#392ec6"
            />
            <path
              d="M184.4,70.39s.64,3.68,4.23,4,4.8-3.84,4.8-3.84a6,6,0,0,1-4.5,2A6.17,6.17,0,0,1,184.4,70.39Z"
              fill="#392ec6"
            />
            <path
              d="M199.59,112.6s1.54,3.47,5.13,3.27,3.7-5.26,3.7-5.26-.93,3.15-3.65,3.44A7.68,7.68,0,0,1,199.59,112.6Z"
              fill="#4842d5"
            />
            <path
              d="M204,103.92s1.6,3.44,5.19,3.16,3.59-5.33,3.59-5.33-.87,3.17-3.58,3.51A7.67,7.67,0,0,1,204,103.92Z"
              fill="#4842d5"
            />
            <path
              d="M197.93,95.07s1.6,3.44,5.19,3.16,3.59-5.33,3.59-5.33-.86,3.17-3.58,3.51A7.67,7.67,0,0,1,197.93,95.07Z"
              fill="#4842d5"
            />
            <path
              d="M210.65,110.71s1.6,3.44,5.19,3.17,3.59-5.34,3.59-5.34-.86,3.17-3.58,3.51A7.67,7.67,0,0,1,210.65,110.71Z"
              fill="#4842d5"
            />
            <path
              d="M178,187.87s-1.16,4.3,0,6.32c3.09,2,9.45,1.07,9.45,1.07s1-3.9,0-6.33C184.43,187.22,178,187.87,178,187.87Z"
              fill="#ffffea"
            />
            <path
              d="M183.35,172.48s-1.46,5.38,0,7.92c3.87,2.53,11.85,1.34,11.85,1.34s1.27-4.89,0-7.93C191.4,171.66,183.35,172.48,183.35,172.48Z"
              fill="#ffffea"
            />
            <path
              d="M216.48,180.75s-2.22,5.12-1.14,7.84c3.47,3.06,11.53,3,11.53,3s2-4.66,1.14-7.85C224.56,181.09,216.48,180.75,216.48,180.75Z"
              fill="#ec8c26"
            />
            <path
              d="M214.28,162.43s-2.21,5.12-1.13,7.84c3.46,3.06,11.53,3,11.53,3s2-4.66,1.14-7.85C222.37,162.77,214.28,162.43,214.28,162.43Z"
              fill="#ffffea"
            />
            <path
              d="M170.86,157.66s-1.46,5.38,0,7.92c3.87,2.53,11.85,1.34,11.85,1.34s1.27-4.89,0-7.93C178.91,156.84,170.86,157.66,170.86,157.66Z"
              fill="#ffffea"
            />
            <path
              d="M187.56,139.94s-1.2,4.43,0,6.52c3.19,2.08,9.76,1.1,9.76,1.1s1.05-4,0-6.53C194.19,139.26,187.56,139.94,187.56,139.94Z"
              fill="#ffffea"
            />
            <path
              d="M171.38,131.69s-1.46,5.39,0,7.92c3.87,2.53,11.85,1.34,11.85,1.34s1.27-4.89,0-7.93C179.43,130.87,171.38,131.69,171.38,131.69Z"
              fill="#ffffea"
            />
            <path
              d="M163.32,206.31s-1.46,5.38,0,7.92c3.87,2.53,11.85,1.34,11.85,1.34s1.26-4.89,0-7.93C171.37,205.49,163.32,206.31,163.32,206.31Z"
              fill="#ffffea"
            />
            <path
              d="M203.85,199.78s-.38,3.85.91,5.41c2.94,1.29,8.26-.44,8.26-.44s.31-3.49-.91-5.43C209.26,198.29,203.85,199.78,203.85,199.78Z"
              fill="#ffffea"
            />
            <path
              d="M210.73,215.09s-.55,5.55,1.31,7.81c4.24,1.85,11.91-.65,11.91-.65s.44-5-1.32-7.82C218.53,212.94,210.73,215.09,210.73,215.09Z"
              fill="#ffffea"
            />
            <path
              d="M154.83,223s-2.5,5-1.56,7.76c3.29,3.25,11.35,3.65,11.35,3.65s2.21-4.55,1.56-7.78C162.88,223.8,154.83,223,154.83,223Z"
              fill="#ec8c26"
            />
            <path
              d="M175.42,246.86s-1.68-44.93,15.84-44.55,14.65,44.88,14.65,44.88S190,249.69,175.42,246.86Z"
              fill="#a122ff"
            />
            <path
              d="M175.42,246.86s-1.68-44.93,15.84-44.55,14.65,44.88,14.65,44.88S190,249.69,175.42,246.86Z"
              fill="#a122ff"
            />
            <path
              d="M187.46,188.93a6.39,6.39,0,0,0-1.09-.47,2.36,2.36,0,0,1,.1.53,12.09,12.09,0,0,1,0,2.09,2.84,2.84,0,0,1-2.71,2.59,16.67,16.67,0,0,1-5.74-.62,3.12,3.12,0,0,1-.42-.18,4.1,4.1,0,0,0,.43,1.32c3.09,2,9.45,1.07,9.45,1.07S188.47,191.36,187.46,188.93Z"
              fill="#ebd6ff"
            />
            <path
              d="M195.15,173.89a8.19,8.19,0,0,0-1.37-.59,3.61,3.61,0,0,1,.13.67,16.27,16.27,0,0,1,0,2.62,3.56,3.56,0,0,1-3.4,3.24,20.8,20.8,0,0,1-7.2-.77,3,3,0,0,1-.52-.23,4.93,4.93,0,0,0,.54,1.65c3.87,2.54,11.85,1.35,11.85,1.35S196.41,176.94,195.15,173.89Z"
              fill="#ebd6ff"
            />
            <path
              d="M182.66,158.73a7.44,7.44,0,0,0-1.37-.59,3.51,3.51,0,0,1,.13.66,16.27,16.27,0,0,1,0,2.62,3.56,3.56,0,0,1-3.4,3.25,21,21,0,0,1-7.2-.77,3,3,0,0,1-.52-.23,4.93,4.93,0,0,0,.54,1.65c3.87,2.53,11.85,1.34,11.85,1.34S183.92,161.77,182.66,158.73Z"
              fill="#ebd6ff"
            />
            <path
              d="M197.28,141.07a5.51,5.51,0,0,0-1.13-.49,2.45,2.45,0,0,1,.1.54,11.92,11.92,0,0,1,0,2.16,2.92,2.92,0,0,1-2.8,2.67,17,17,0,0,1-5.93-.63,3.3,3.3,0,0,1-.43-.19,3.83,3.83,0,0,0,.45,1.36c3.18,2.09,9.76,1.11,9.76,1.11S198.32,143.57,197.28,141.07Z"
              fill="#ebd6ff"
            />
            <path
              d="M183.18,133a8.56,8.56,0,0,0-1.37-.59,3.51,3.51,0,0,1,.13.66,16.38,16.38,0,0,1,0,2.63,3.56,3.56,0,0,1-3.4,3.24,20.8,20.8,0,0,1-7.2-.77,2.73,2.73,0,0,1-.52-.23,4.52,4.52,0,0,0,.54,1.65c3.86,2.53,11.85,1.34,11.85,1.34S184.44,136.06,183.18,133Z"
              fill="#ebd6ff"
            />
            <path
              d="M225.66,165.36a8.53,8.53,0,0,0-1.31-.71,3.82,3.82,0,0,1,.07.68,15.61,15.61,0,0,1-.25,2.61,3.58,3.58,0,0,1-3.67,2.94,21.15,21.15,0,0,1-7.11-1.39,4.82,4.82,0,0,1-.5-.27,4.93,4.93,0,0,0,.4,1.69c3.64,2.86,11.69,2.36,11.69,2.36S226.66,168.5,225.66,165.36Z"
              fill="#ebd6ff"
            />
            <path
              d="M227.85,183.45a7.75,7.75,0,0,0-1.31-.71,3,3,0,0,1,.07.67,15.51,15.51,0,0,1-.25,2.61,3.57,3.57,0,0,1-3.67,2.94,20.89,20.89,0,0,1-7.11-1.38,3.53,3.53,0,0,1-.5-.28,4.93,4.93,0,0,0,.4,1.69c3.64,2.86,11.69,2.36,11.69,2.36S228.85,186.59,227.85,183.45Z"
              fill="#ec8326"
            />
            <path
              d="M175.11,207.75a7.64,7.64,0,0,0-1.36-.59,3.5,3.5,0,0,1,.12.66,14.38,14.38,0,0,1,0,2.63,3.56,3.56,0,0,1-3.39,3.24,21.08,21.08,0,0,1-7.21-.77,3.43,3.43,0,0,1-.52-.23,4.93,4.93,0,0,0,.54,1.65c3.87,2.53,11.85,1.34,11.85,1.34S176.38,210.79,175.11,207.75Z"
              fill="#ebd6ff"
            />
            <path
              d="M166.24,226.78a7.92,7.92,0,0,0-1.21-.86,3.75,3.75,0,0,1,0,.67,14.61,14.61,0,0,1-.57,2.57,3.55,3.55,0,0,1-4,2.47,20.77,20.77,0,0,1-6.9-2.23,3.83,3.83,0,0,1-.46-.33,4.85,4.85,0,0,0,.19,1.73c3.27,3.27,11.32,3.74,11.32,3.74S166.85,230,166.24,226.78Z"
              fill="#ec8326"
            />
            <path
              d="M227.75,179l5.4-.22a4,4,0,0,0,3.79-3.9l.2-14.15a6.74,6.74,0,0,0-2.35-5.22h0a6.75,6.75,0,0,0-8.62-.15h0a9.55,9.55,0,0,0-3.59,7.32l-.16,11.13A5.12,5.12,0,0,0,227.75,179Z"
              fill="#ffbe3a"
            />
            <path
              d="M171.57,227.48c-1-3.71-4-6.51-6.83-9.09l-8.33-7.58c-1.52-1.38-3.13-2.81-5.13-3.29s-4.47.38-5.07,2.34c-2.45-4.48-9.52-4.7-13.2-1.17s-4.25,9.41-2.72,14.28c-2.26-3.23-7.14-3.93-10.63-2.09s-5.62,5.68-6.21,9.59c-2.85-.58-5.67,2-6.08,4.87s1.06,5.76,3.11,7.84a41,41,0,0,0,7,5.11c2.49,1.64,5,3.5,7.89,4.07a6.57,6.57,0,0,0,7.3-3.27c-2.73,8.85,14.73,1.14,19.74,1C158.67,250,175,246,167,236.52,170.73,235.34,172.56,231.18,171.57,227.48Z"
              fill="#527e23"
            />
            <path
              d="M285.74,228.63l-7.2-121h-23l-7.2,121c0,.33-.05.65-.05,1,0,7.21,8.4,13,18.77,13s18.76-5.84,18.76-13C285.79,229.28,285.77,229,285.74,228.63Z"
              fill="#fffad1"
            />
            <rect
              x="192.56"
              width="2.77"
              height="47.31"
              rx="1.39"
              fill="#282117"
            />
            <path
              d="M192.47,1.89s8.49,6.16,27.23,9a294.68,294.68,0,0,0,38.76,2.86S252,25,243,25.84c12.66,1.57,17.33-2.77,17.33-2.77S259,41.2,227.68,44.3c-18.53,1.84-35.52-9.21-35.52-9.21Z"
              fill="#f82517"
            />
            <path
              d="M213.33,30.76C198.28,23.89,195.66,12.16,196,3.89a28.4,28.4,0,0,1-3.49-2l-.31,33.2s17,11,35.52,9.21c12.37-1.22,20.06-4.79,24.84-8.67C243.62,38.35,230.25,38.48,213.33,30.76Z"
              fill="#d42517"
            />
            <ellipse
              cx="141.8"
              cy="283.92"
              rx="12.59"
              ry="5.83"
              fill="#d9a780"
            />
            <ellipse
              cx="134.03"
              cy="266.59"
              rx="11.24"
              ry="5.21"
              fill="#d9a780"
            />
            <ellipse
              cx="159.67"
              cy="260.72"
              rx="11.24"
              ry="5.21"
              fill="#d9a780"
            />
            <ellipse
              cx="167.46"
              cy="278.08"
              rx="9.71"
              ry="4.5"
              fill="#d9a780"
            />
            <ellipse
              cx="193.69"
              cy="284.61"
              rx="10.91"
              ry="5.06"
              fill="#d9a780"
            />
            <ellipse
              cx="187.64"
              cy="260.06"
              rx="10.91"
              ry="5.06"
              fill="#d9a780"
            />
            <ellipse
              cx="203.67"
              cy="268.42"
              rx="8.55"
              ry="3.96"
              fill="#d9a780"
            />
            <ellipse
              cx="215.45"
              cy="289.17"
              rx="8.55"
              ry="3.96"
              fill="#d9a780"
            />
            <ellipse
              cx="237.54"
              cy="274.28"
              rx="10.44"
              ry="5.27"
              fill="#d9a780"
            />
            <ellipse
              cx="246.62"
              cy="260.06"
              rx="9.08"
              ry="4.58"
              fill="#d9a780"
            />
            <ellipse
              cx="225.6"
              cy="254.39"
              rx="10.91"
              ry="5.5"
              fill="#d9a780"
            />
            <path
              d="M149.06,283.62c0,3.06-5.09,5.55-11.38,5.55s-11.37-2.49-11.37-5.55,5.44-7.5,11.72-7.5S149.06,280.55,149.06,283.62Z"
              fill="#b27e35"
            />
            <path
              d="M141.78,276.66a6.5,6.5,0,0,1,2.57,4.42c0,3.06-5.1,5.55-11.38,5.55a21.08,21.08,0,0,1-5.66-.74c1.78,1.93,5.75,3.28,10.37,3.28,6.29,0,11.38-2.49,11.38-5.55C149.06,281.2,146.11,277.93,141.78,276.66Z"
              fill="#946235"
            />
            <path
              d="M139.38,266.87c0,2.42-4,4.38-9,4.38s-9-2-9-4.38,4.29-5.91,9.24-5.91S139.38,264.46,139.38,266.87Z"
              fill="#b27e35"
            />
            <path
              d="M195.17,261c0,3.07-5.09,5.56-11.38,5.56s-11.37-2.49-11.37-5.56,5.44-7.49,11.73-7.49S195.17,258,195.17,261Z"
              fill="#b27e35"
            />
            <path
              d="M165.77,260.56c0,3.06-5.09,5.55-11.38,5.55S143,263.62,143,260.56s5.44-7.5,11.72-7.5S165.77,257.49,165.77,260.56Z"
              fill="#b27e35"
            />
            <path
              d="M209.72,269.7c0,2.14-3.57,3.88-8,3.88s-8-1.74-8-3.88,3.81-5.24,8.21-5.24S209.72,267.55,209.72,269.7Z"
              fill="#b27e35"
            />
            <path
              d="M253.05,260.74c0,2.15-3.56,3.88-8,3.88s-8-1.73-8-3.88,3.81-5.24,8.2-5.24S253.05,258.6,253.05,260.74Z"
              fill="#b27e35"
            />
            <path
              d="M172.13,278.76c0,2.15-3.56,3.88-7.95,3.88s-8-1.73-8-3.88,3.81-5.24,8.2-5.24S172.13,276.62,172.13,278.76Z"
              fill="#b27e35"
            />
            <path
              d="M232.42,254.8c0,2.9-4.83,5.26-10.79,5.26s-10.79-2.36-10.79-5.26,5.16-7.11,11.12-7.11S232.42,251.89,232.42,254.8Z"
              fill="#b27e35"
            />
            <path
              d="M201.18,285.58c0,3.06-5.09,5.55-11.37,5.55s-11.38-2.49-11.38-5.55,5.45-7.5,11.73-7.5S201.18,282.51,201.18,285.58Z"
              fill="#b27e35"
            />
            <path
              d="M220.17,290.43c0,2.14-3.56,3.88-8,3.88s-8-1.74-8-3.88,3.81-5.24,8.2-5.24S220.17,288.29,220.17,290.43Z"
              fill="#b27e35"
            />
            <path
              d="M242.87,275.53c0,2.9-4.83,5.26-10.79,5.26s-10.79-2.36-10.79-5.26,5.17-7.11,11.12-7.11S242.87,272.62,242.87,275.53Z"
              fill="#b27e35"
            />
            <path
              d="M143,228.73a8.77,8.77,0,0,0,4.76,0c.86-.28,1.05-4,.65-5.14s-1.29-3.29-.65-3.72,1.27-2.34,1.48-3.9-1.49-2.68-1.48-3.11-3.62-1.7-2.52-3a1.18,1.18,0,0,0,.11-1.12c-2.94-3.31-9-3.19-12.36,0-3.07,3-4,7.54-3.3,11.81h0c.08.52,2.35.84,2.35.84l.91.17s1.42,4.3,2.06,4.41.85-.54,3.65-.66S141.61,228.14,143,228.73Z"
              fill="#6c9b23"
            />
            <path
              d="M137.9,234.54c0-1.62-.32-2.95-1.6-3.51a6.79,6.79,0,0,1-2.76-2c-.1-.39-.19-.17-.57-1.13a3.67,3.67,0,0,0-2.08-2c-.64-.11-.85.18-.85-.66a18.24,18.24,0,0,1,.25-2.29s-1.07-3.69-3.38-4.57a10.14,10.14,0,0,0,0,1.67,8.61,8.61,0,0,0-3-1.67c-.91.88-.68,1.59-.68,1.59s-2.54-.79-3.74-.47c-.8,1.27-.62,1.82-.62,1.82a24.91,24.91,0,0,0-2.8.17,6.46,6.46,0,0,0,1.08,1.24,20.5,20.5,0,0,0-2.2,1.78,1.41,1.41,0,0,0-.4,1.39s-1.67.44-1.91,1.56c.59,2.45.8,3,.8,3s-.32,1.95.08,2.58,2.31.72,2.31.72a17.7,17.7,0,0,0,2.63,3.9c1.11,1,1.75.32,2.46.32s.32.08,2,1-.65,1.11,3.38,1.51,5.54.16,5.69-.4a13.49,13.49,0,0,1,1-1.91,14.12,14.12,0,0,0,2.31-.24,3.59,3.59,0,0,0,1.19-1.75C136.54,235.68,137.9,234.54,137.9,234.54Z"
              fill="#6c9b23"
            />
            <path
              d="M144.63,209.6c1.58-.35-.08-3.69-1.06-5.16C142.61,206,142.36,210.09,144.63,209.6Z"
              fill="#6c9b23"
            />
            <path
              d="M141.53,209.75c1.57.4,1.58-3.33,1.37-5.08C141.36,205.59,139.28,209.18,141.53,209.75Z"
              fill="#6c9b23"
            />
            <path
              d="M141.9,209.35c1.54-.45-.11-3.36-1.08-4.63C139.89,206.19,139.67,210,141.9,209.35Z"
              fill="#6c9b23"
            />
            <path
              d="M141.06,208.8c1.26-1-1.73-3.26-3.26-4.13C137.62,206.45,139.25,210.27,141.06,208.8Z"
              fill="#6c9b23"
            />
            <path
              d="M138.36,210.33c1.58-.34-.08-3.68-1.06-5.16C136.34,206.68,136.09,210.83,138.36,210.33Z"
              fill="#6c9b23"
            />
            <path
              d="M137.18,210.25c1.54-.45-.11-3.36-1.08-4.62C135.17,207.09,135,210.9,137.18,210.25Z"
              fill="#6c9b23"
            />
            <path
              d="M136.34,209.7c1.26-1-1.73-3.25-3.26-4.13C132.9,207.35,134.53,211.17,136.34,209.7Z"
              fill="#6c9b23"
            />
            <path
              d="M133.64,211.23c1.58-.34-.08-3.68-1.06-5.16C131.62,207.59,131.37,211.73,133.64,211.23Z"
              fill="#6c9b23"
            />
            <path
              d="M134.76,211.12c.59-1.5-2.72-2-4.32-2C131,210.76,133.91,213.27,134.76,211.12Z"
              fill="#6c9b23"
            />
            <path
              d="M133.81,211.44c0-1.62-3.63-.63-5.26.05C129.85,212.72,133.87,213.77,133.81,211.44Z"
              fill="#6c9b23"
            />
            <path
              d="M133.37,214.51c.7-1.46-3-2.19-4.73-2.32C129.25,213.87,132.37,216.61,133.37,214.51Z"
              fill="#6c9b23"
            />
            <path
              d="M133.52,215.5c.59-1.74-2.73-2.3-4.32-2.31C129.79,215.09,132.67,218,133.52,215.5Z"
              fill="#6c9b23"
            />
            <path
              d="M132.57,215.88c0-1.88-3.63-.73-5.27.06C128.6,217.37,132.62,218.59,132.57,215.88Z"
              fill="#6c9b23"
            />
            <path
              d="M132.13,219.45c.69-1.69-3-2.55-4.73-2.7C128,218.71,131.13,221.9,132.13,219.45Z"
              fill="#6c9b23"
            />
            <path
              d="M118.87,225.34c.59-1.74-2.73-2.3-4.32-2.31C115.14,224.93,118,227.85,118.87,225.34Z"
              fill="#6c9b23"
            />
            <path
              d="M117.92,225.71c0-1.87-3.63-.73-5.27.06C114,227.2,118,228.42,117.92,225.71Z"
              fill="#6c9b23"
            />
            <path
              d="M117.48,229.29c.69-1.7-3-2.55-4.73-2.7C113.36,228.55,116.48,231.73,117.48,229.29Z"
              fill="#6c9b23"
            />
            <path
              d="M139.66,235.93c-.32,1.81,3,1.86,4.61,1.63C143.4,235.77,140.11,233.32,139.66,235.93Z"
              fill="#6c9b23"
            />
            <path
              d="M140.53,235.42c.32,1.85,3.71.17,5.2-.85C144.23,233.35,140.07,232.75,140.53,235.42Z"
              fill="#6c9b23"
            />
            <path
              d="M140.43,230.57c-.43,1.79,3.32,2.08,5.08,2C144.61,230.68,141.05,228,140.43,230.57Z"
              fill="#6c9b23"
            />
            <path
              d="M145.82,222.75c.22,1.83,3.45.9,4.89.23C149.36,221.52,145.51,220.12,145.82,222.75Z"
              fill="#6c9b23"
            />
            <path
              d="M151.34,221.62c.84,1.68,3.59-.9,4.73-2.31C154.28,218.57,150.13,219.2,151.34,221.62Z"
              fill="#6c9b23"
            />
            <path
              d="M147.2,216.79c.11,1.83,3.78,1,5.44.41C151.24,215.69,147.05,214.15,147.2,216.79Z"
              fill="#6c9b23"
            />
            <path
              d="M150.79,214.13c.39-1.79-3.36-2-5.13-1.85C146.6,214.11,150.23,216.71,150.79,214.13Z"
              fill="#527e23"
            />
            <path
              d="M149,221.91c1.19-1.4-2-3.35-3.66-4C145.29,219.93,147.27,223.92,149,221.91Z"
              fill="#527e23"
            />
            <path
              d="M138.73,226.41c1.18-1.4-2-3.34-3.66-4C135,224.43,137,228.43,138.73,226.41Z"
              fill="#527e23"
            />
            <path
              d="M148.14,229.06c1.19-1.39-2-3.34-3.66-4C144.46,227.09,146.44,231.08,148.14,229.06Z"
              fill="#527e23"
            />
            <path
              d="M147,229c.44-1.78-3.31-2.09-5.07-2C142.83,228.89,146.39,231.58,147,229Z"
              fill="#527e23"
            />
            <path
              d="M138.46,232.48c1.18-1.4-2-3.35-3.66-4C134.77,230.5,136.75,234.49,138.46,232.48Z"
              fill="#527e23"
            />
            <path
              d="M137.63,239.63c1.18-1.39-2-3.34-3.66-4C133.94,237.65,135.92,241.65,137.63,239.63Z"
              fill="#527e23"
            />
            <path
              d="M136.5,239.59c.43-1.78-3.31-2.09-5.08-2C132.31,239.46,135.87,242.15,136.5,239.59Z"
              fill="#527e23"
            />
            <path
              d="M127.39,242.34c1.63.84,2.8-2.73,3.1-4.48C128.48,238.3,125,241.14,127.39,242.34Z"
              fill="#527e23"
            />
            <path
              d="M114.82,235.71c1.63.84,2.8-2.74,3.1-4.48C115.92,231.67,112.47,234.5,114.82,235.71Z"
              fill="#527e23"
            />
            <path
              d="M120.27,240.85c1.63.84,2.8-2.73,3.1-4.48C121.37,236.81,117.92,239.65,120.27,240.85Z"
              fill="#527e23"
            />
            <path
              d="M120.06,239.74c1.84,0,1.28-3.7.78-5.39C119.24,235.63,117.42,239.71,120.06,239.74Z"
              fill="#527e23"
            />
            <path
              d="M149.88,229.59c.21,1.82,3.44.9,4.88.23C153.41,228.35,149.56,227,149.88,229.59Z"
              fill="#6c9b23"
            />
            <path
              d="M147.14,236.44c.84,1.68,3.59-.91,4.73-2.32C150.08,233.39,145.93,234,147.14,236.44Z"
              fill="#6c9b23"
            />
            <path
              d="M147.76,226.38c.1,1.83,3.77,1,5.43.4C151.79,225.28,147.61,223.74,147.76,226.38Z"
              fill="#6c9b23"
            />
            <path
              d="M167.32,274a4,4,0,0,1,1.2,2.52c0,2.14-3.56,3.88-8,3.88a14.72,14.72,0,0,1-4-.54c1,1.62,4,2.8,7.64,2.8,4.39,0,7.95-1.73,7.95-3.88C172.13,277.12,170.2,274.93,167.32,274Z"
              fill="#946235"
            />
            <path
              d="M135.68,262.23a4.14,4.14,0,0,1,1,2.41c0,2.42-4,4.38-9,4.38a15.28,15.28,0,0,1-6-1.13c.94,1.93,4.49,3.36,8.73,3.36,5,0,9-2,9-4.38C139.38,265.38,137.94,263.47,135.68,262.23Z"
              fill="#946235"
            />
            <path
              d="M158.49,253.6c2,1.49,3.14,3.36,3.14,4.88,0,3.07-5.1,5.56-11.38,5.56a21.12,21.12,0,0,1-5.79-.78c1.95,1.7,5.67,2.85,9.93,2.85,6.29,0,11.38-2.49,11.38-5.55C165.77,258.14,162.82,254.87,158.49,253.6Z"
              fill="#946235"
            />
            <path
              d="M193.91,278.62c2,1.5,3.2,3.39,3.2,4.93,0,3.07-5.1,5.55-11.38,5.55a21.15,21.15,0,0,1-5.8-.77c2,1.67,5.65,2.8,9.88,2.8,6.28,0,11.37-2.49,11.37-5.55C201.18,283.16,198.23,279.9,193.91,278.62Z"
              fill="#946235"
            />
            <path
              d="M189.46,254.65a5.8,5.8,0,0,1,1.84,3.73c0,3.06-5.09,5.55-11.37,5.55a20.06,20.06,0,0,1-6.93-1.15c1.5,2.21,5.76,3.81,10.79,3.81,6.29,0,11.38-2.49,11.38-5.56C195.17,258.92,192.92,256.16,189.46,254.65Z"
              fill="#946235"
            />
            <path
              d="M204.78,264.88a4.45,4.45,0,0,1,1.72,3c0,2.14-3.56,3.88-7.95,3.88a14.66,14.66,0,0,1-4.09-.55c1.22,1.38,4,2.34,7.3,2.34,4.39,0,8-1.74,8-3.88C209.72,268,207.72,265.8,204.78,264.88Z"
              fill="#946235"
            />
            <path
              d="M215.35,285.65a4.94,4.94,0,0,1,2.32,3.51c0,2.14-3.56,3.88-7.95,3.88a14.44,14.44,0,0,1-4.35-.63,11.28,11.28,0,0,0,6.84,1.9c4.4,0,8-1.74,8-3.88C220.17,288.79,218.23,286.59,215.35,285.65Z"
              fill="#946235"
            />
            <path
              d="M236.3,269c1.88,1.42,3,3.2,3,4.66,0,2.91-4.83,5.27-10.79,5.27a19.93,19.93,0,0,1-5.82-.83c1.86,1.59,5.36,2.66,9.38,2.66,6,0,10.79-2.36,10.79-5.26C242.87,273.29,240.22,270.3,236.3,269Z"
              fill="#946235"
            />
            <path
              d="M245.41,255.5c2.32,1.07,3.82,2.95,3.82,4.39,0,2.14-3.56,3.88-7.95,3.88-.44,0-.86,0-1.28,0a13.64,13.64,0,0,0,5.1.9c4.39,0,8-1.73,8-3.88S249.77,255.53,245.41,255.5Z"
              fill="#946235"
            />
            <path
              d="M225.16,248.1c2,1.44,3.27,3.32,3.27,4.85,0,2.9-4.83,5.26-10.79,5.26a19.92,19.92,0,0,1-5.19-.65c1.9,1.5,5.3,2.5,9.18,2.5,6,0,10.79-2.36,10.79-5.26C232.42,252.44,229.46,249.23,225.16,248.1Z"
              fill="#946235"
            />
            <rect
              x="225.73"
              y="60.64"
              width="2.77"
              height="47.31"
              rx="1.39"
              fill="#282117"
            />
            <g>
              <path
                d="M118,224.18c-.36.42-1.1.76-1.41.49s-.07-1,.3-1.46a.65.65,0,0,1,1-.07A.66.66,0,0,1,118,224.18Z"
                fill="#e4f6fb"
              />
              <path
                d="M117.86,225.86c-.55-.07-1.24-.5-1.19-.9s.83-.64,1.39-.56a.64.64,0,0,1,.62.82A.65.65,0,0,1,117.86,225.86Z"
                fill="#e4f6fb"
              />
              <path
                d="M116.3,226.46c-.2-.52-.15-1.33.23-1.47s1,.42,1.15.94a.74.74,0,0,1-1.38.53Z"
                fill="#e4f6fb"
              />
              <path
                d="M115.22,224.83c.49-.26,1.3-.31,1.49.06s-.32,1-.81,1.25a.74.74,0,0,1-.68-1.31Z"
                fill="#e4f6fb"
              />
              <path
                d="M116.21,223.4c.45.32.87,1,.63,1.35s-1,.18-1.49-.14a.74.74,0,0,1,.86-1.21Z"
                fill="#e4f6fb"
              />
              <circle cx="116.64" cy="224.8" r="0.59" fill="#feaf26" />
            </g>
            <g>
              <path
                d="M129.36,233.93c-.3.34-.9.62-1.15.4s-.06-.85.24-1.2a.54.54,0,0,1,.85,0A.53.53,0,0,1,129.36,233.93Z"
                fill="#e4f6fb"
              />
              <path
                d="M129.28,235.3c-.45-.06-1-.41-1-.74s.68-.52,1.13-.45a.52.52,0,0,1,.51.67A.53.53,0,0,1,129.28,235.3Z"
                fill="#e4f6fb"
              />
              <path
                d="M128,235.8c-.17-.43-.13-1.09.18-1.21s.78.35.94.77a.6.6,0,0,1-1.12.44Z"
                fill="#e4f6fb"
              />
              <path
                d="M127.12,234.46c.4-.21,1.06-.25,1.22,0s-.26.81-.67,1a.6.6,0,1,1-.55-1.07Z"
                fill="#e4f6fb"
              />
              <path
                d="M127.93,233.29c.37.27.71.84.52,1.11s-.85.15-1.22-.12a.61.61,0,0,1,.7-1Z"
                fill="#e4f6fb"
              />
              <circle cx="128.28" cy="234.43" r="0.48" fill="#feaf26" />
            </g>
            <g>
              <path
                d="M135.78,211.45c-.55.63-1.63,1.13-2.09.73s-.11-1.54.44-2.16a1.09,1.09,0,0,1,1.65,1.43Z"
                fill="#e4f6fb"
              />
              <path
                d="M135.63,214c-.82-.11-1.84-.74-1.76-1.34s1.23-.94,2-.83a1,1,0,0,1,.93,1.22A1,1,0,0,1,135.63,214Z"
                fill="#e4f6fb"
              />
              <path
                d="M133.32,214.84c-.3-.77-.23-2,.33-2.19s1.42.63,1.71,1.41a1.09,1.09,0,0,1-2,.78Z"
                fill="#e4f6fb"
              />
              <path
                d="M131.71,212.42c.74-.39,1.93-.45,2.21.08s-.47,1.48-1.2,1.86a1,1,0,0,1-1.47-.48A1,1,0,0,1,131.71,212.42Z"
                fill="#e4f6fb"
              />
              <path
                d="M133.18,210.31c.67.47,1.28,1.5.94,2s-1.53.26-2.21-.21a1.1,1.1,0,0,1,1.27-1.79Z"
                fill="#e4f6fb"
              />
              <circle cx="133.82" cy="212.37" r="0.88" fill="#feaf26" />
            </g>
            <g>
              <path
                d="M143.54,219.51c-.3.35-.9.63-1.15.41s-.06-.86.24-1.2a.6.6,0,0,1,.91.79Z"
                fill="#e4f6fb"
              />
              <path
                d="M143.46,220.89c-.46-.06-1-.41-1-.74s.68-.52,1.14-.46a.61.61,0,0,1-.16,1.2Z"
                fill="#e4f6fb"
              />
              <path
                d="M142.18,221.38c-.16-.43-.13-1.09.19-1.21s.78.35.94.78a.6.6,0,0,1-1.13.43Z"
                fill="#e4f6fb"
              />
              <path
                d="M141.29,220c.41-.21,1.07-.24,1.22.05s-.25.82-.66,1a.54.54,0,0,1-.81-.26A.55.55,0,0,1,141.29,220Z"
                fill="#e4f6fb"
              />
              <path
                d="M142.1,218.88c.38.26.71.83.52,1.1s-.84.15-1.21-.11a.6.6,0,0,1,.69-1Z"
                fill="#e4f6fb"
              />
              <circle cx="142.46" cy="220.02" r="0.48" fill="#feaf26" />
            </g>
            <g>
              <path
                d="M146.53,207.92c-.37.42-1.1.76-1.41.49s-.07-1,.29-1.46a.66.66,0,0,1,1-.07A.65.65,0,0,1,146.53,207.92Z"
                fill="#e4f6fb"
              />
              <path
                d="M146.43,209.6c-.56-.07-1.25-.5-1.19-.9s.83-.64,1.38-.56a.74.74,0,0,1-.19,1.46Z"
                fill="#e4f6fb"
              />
              <path
                d="M144.87,210.2c-.2-.52-.16-1.33.22-1.47s1,.42,1.16.94a.66.66,0,0,1-.43,1A.65.65,0,0,1,144.87,210.2Z"
                fill="#e4f6fb"
              />
              <path
                d="M143.78,208.57c.5-.26,1.31-.31,1.49.06s-.31,1-.81,1.25a.74.74,0,0,1-.68-1.31Z"
                fill="#e4f6fb"
              />
              <path
                d="M144.77,207.14c.46.33.87,1,.64,1.35s-1,.18-1.49-.14a.74.74,0,0,1,.85-1.21Z"
                fill="#e4f6fb"
              />
              <circle cx="145.2" cy="208.54" r="0.59" fill="#feaf26" />
            </g>
            <g>
              <path
                d="M126.5,218.51c-.37.42-1.11.76-1.41.49s-.08-1,.29-1.46a.74.74,0,0,1,1.12,1Z"
                fill="#e4f6fb"
              />
              <path
                d="M126.39,220.19c-.55-.07-1.24-.5-1.18-.9s.82-.64,1.38-.56a.74.74,0,0,1-.2,1.46Z"
                fill="#e4f6fb"
              />
              <path
                d="M124.83,220.79c-.2-.52-.15-1.33.23-1.47s1,.42,1.15,1a.64.64,0,0,1-.42.94A.65.65,0,0,1,124.83,220.79Z"
                fill="#e4f6fb"
              />
              <path
                d="M123.75,219.16c.49-.26,1.3-.3,1.49.06s-.31,1-.81,1.25a.74.74,0,0,1-.68-1.31Z"
                fill="#e4f6fb"
              />
              <path
                d="M124.74,217.73c.46.33.87,1,.63,1.36s-1,.17-1.48-.15a.74.74,0,0,1,.85-1.21Z"
                fill="#e4f6fb"
              />
              <circle cx="125.17" cy="219.13" r="0.59" fill="#feaf26" />
            </g>
            <path
              d="M261.23,362.1s-21.8,6.1-75.68,6.1-73.9-6.1-73.9-6.1,5.7-21.45,9.79-21.73c1.35-9.44,7.06-20.43,10-22.15.74-5.61,3.08-13.73,5.89-13.07.37-7.67,4.68-10.41,4.68-10.41s8.71-3.23,43.08-3.23,45.81,3.23,45.81,3.23a30.7,30.7,0,0,1,3.86,9.75c2.52,1.45,6.67,13.46,6.67,13.46,1.64-1.16,8.54,8.69,8.64,19.33C256.72,343.14,261.23,362.1,261.23,362.1Z"
              fill="#9f6223"
            />
            <path
              d="M137.31,305.15l97.43-.66a22.54,22.54,0,0,0-1.53-5.08c-2.19,1.79-89.07,4.6-94.42-.58C137.47,299.82,137.31,305.15,137.31,305.15Z"
              fill="#854612"
            />
            <path
              d="M132.62,312.33s-1.63,4.16-1.2,5.89c43,7,110-.27,110-.27s-1.17-5.56-2.85-7.24C229,314.44,151,320.6,132.62,312.33Z"
              fill="#854612"
            />
            <path
              d="M268.84,107.51,273,241.91c7.5-1.71,12.91-6.61,12.91-12.4a8.06,8.06,0,0,0-.06-1l-7.2-121Z"
              fill="#ebd6ff"
            />
            <g>
              <path
                d="M289.3,113.43c-.08-.17-.15-.34-.24-.51,0,0-6.08-4.69-10.23-14.79S271,67.22,271,67.22h-8s-4.48,20.26-9.17,30.19a112.14,112.14,0,0,1-9.16,16.12.78.78,0,0,1-.05.14l0,0h0a7.06,7.06,0,0,0-.38,1.62h-.11s-1.27,3.26.16,5.33,3,1.44,3,1.44.48,2.31,2,3a3,3,0,0,0,2.75-.06l.06,0a3.57,3.57,0,0,0,2.21,2.18,4.31,4.31,0,0,0,2.95-.39,4.18,4.18,0,0,0,2.23,1.75,3.29,3.29,0,0,0,2.62-.88,5.7,5.7,0,0,0,3.35,1.44,2.64,2.64,0,0,0,2.66-1.2h.09a2.77,2.77,0,0,0,2.58,1.12,3.61,3.61,0,0,0,2.87-1.52,2.89,2.89,0,0,0,2.47.8,3.21,3.21,0,0,0,2.39-1.91,5.06,5.06,0,0,0,3.66.32,2.79,2.79,0,0,0,1.91-2.55,3,3,0,0,0,2.55-.56,2.51,2.51,0,0,0,.88-2.39,1.82,1.82,0,0,0,2.23-.87,3.56,3.56,0,0,0,0-3.27s.87.24,1.11-.48C291.06,116.16,289.89,114.31,289.3,113.43Z"
                fill="#4842d5"
              />
              <path
                d="M276.15,128.41a3.21,3.21,0,0,0,2.39-1.91,5.06,5.06,0,0,0,3.66.32,2.79,2.79,0,0,0,1.91-2.55,3,3,0,0,0,2.55-.56,2.51,2.51,0,0,0,.88-2.39,1.82,1.82,0,0,0,2.23-.87,3.56,3.56,0,0,0,0-3.27s.87.24,1.11-.48c.18-.54-1-2.39-1.58-3.27-.08-.17-.15-.34-.24-.51,0,0-3.64-5.77-8.69-14.79S271,67.22,271,67.22h-4.07l6.4,60.81a2.29,2.29,0,0,0,.34-.42A2.89,2.89,0,0,0,276.15,128.41Z"
                fill="#392ec6"
              />
              <ellipse cx="267.02" cy="67.22" rx="4" ry="2.1" fill="#ae133e" />
              <path
                d="M254.57,96.5s-1.46,7.83,16.8,3.27C269.46,85.64,270.2,86,270.2,86l-13.1.8Z"
                fill="#392ec6"
              />
            </g>
            <rect
              x="265.63"
              y="18.91"
              width="2.77"
              height="47.31"
              rx="1.39"
              fill="#282117"
            />
            <path
              d="M265.63,15.78s6.46-1.48,19.8,3.13,30.54-1.28,33.41-5c2.86,9.32-4.46,16.33-4.46,16.33s8-2.95,11.15-8.17C322,43.28,306,51.56,287.91,48.05s-22.28-4.48-22.28-4.48Z"
              fill="#98eeff"
            />
            <rect
              x="252.89"
              y="134.08"
              width="4.93"
              height="4.1"
              rx="1.47"
              transform="translate(11.12 -19.07) rotate(4.37)"
              fill="#ffffea"
            />
            <rect
              x="259.9"
              y="149.04"
              width="6.24"
              height="5.18"
              rx="1.86"
              transform="matrix(1, 0.08, -0.08, 1, 12.32, -19.61)"
              fill="#ffffea"
            />
            <rect
              x="251.75"
              y="161.51"
              width="7.56"
              height="6.28"
              rx="2.25"
              transform="translate(13.29 -19) rotate(4.37)"
              fill="#ffffea"
            />
            <rect
              x="258.54"
              y="194.77"
              width="6.24"
              height="5.18"
              rx="1.86"
              transform="translate(15.81 -19.37) rotate(4.37)"
              fill="#ffffea"
            />
            <rect
              x="250.48"
              y="202.84"
              width="6.24"
              height="5.18"
              rx="1.86"
              transform="translate(16.4 -18.73) rotate(4.37)"
              fill="#ffffea"
            />
            <rect
              x="262.58"
              y="222.62"
              width="6.24"
              height="5.18"
              rx="1.86"
              transform="translate(17.94 -19.6) rotate(4.37)"
              fill="#ffffea"
            />
            <rect
              x="250.7"
              y="215.67"
              width="9.86"
              height="8.2"
              rx="2.94"
              transform="translate(17.5 -18.85) rotate(4.37)"
              fill="#ffffea"
            />
            <rect
              x="254.51"
              y="230.7"
              width="6.24"
              height="5.18"
              rx="1.86"
              transform="translate(18.53 -18.96) rotate(4.37)"
              fill="#ffffea"
            />
            <rect
              x="269.43"
              y="176.62"
              width="6.24"
              height="5.18"
              rx="1.86"
              transform="translate(-7.28 11.59) rotate(-2.4)"
              fill="#ffffea"
            />
            <rect
              x="267.65"
              y="195.81"
              width="9.53"
              height="7.92"
              rx="2.84"
              transform="translate(-8.14 11.6) rotate(-2.4)"
              fill="#ffffea"
            />
            <rect
              x="280.83"
              y="203.71"
              width="6.24"
              height="5.18"
              rx="1.86"
              transform="translate(-8.41 12.09) rotate(-2.4)"
              fill="#ffffea"
            />
            <rect
              x="281.5"
              y="227.2"
              width="6.24"
              height="5.18"
              rx="1.86"
              transform="translate(-9.39 12.14) rotate(-2.4)"
              fill="#ffffea"
            />
            <rect
              x="274.05"
              y="151.06"
              width="6.24"
              height="5.18"
              rx="1.86"
              transform="translate(-6.2 11.76) rotate(-2.4)"
              fill="#ffffea"
            />
            <rect
              x="278.04"
              y="170"
              width="6.24"
              height="5.18"
              rx="1.86"
              transform="translate(-6.99 11.95) rotate(-2.4)"
              fill="#ffffea"
            />
            <rect
              x="270.88"
              y="222.85"
              width="6.24"
              height="5.18"
              rx="1.71"
              transform="translate(-9.22 11.69) rotate(-2.4)"
              fill="#ffffea"
            />
            <rect
              x="270.88"
              y="233.92"
              width="6.24"
              height="5.18"
              rx="1.71"
              transform="translate(-9.68 11.7) rotate(-2.4)"
              fill="#ffffea"
            />
            <path
              d="M272.6,168.41l4.08-.54c1.59-.21,2.72-2.6,2.58-5.45l-.94-19.18a13.19,13.19,0,0,0-2.2-7h0c-2-2.76-4.8-2.69-6.57.17h0a18,18,0,0,0-2.15,10.08l.74,15.1C268.34,165.59,270.38,168.7,272.6,168.41Z"
              fill="#ffbe3a"
            />
            <path
              d="M125.27,327.64s-4.69,8.8-3.83,12.73c8.18,6.33,117.48.72,128.61-3.09.14-8.1-2.4-11.23-2.4-11.23s-2.27,4.82-47.42,8.59C138.18,339.82,125.27,327.64,125.27,327.64Z"
              fill="#854612"
            />
            <path
              d="M114.6,352.5s-4,8.9-2.95,12.83c10,6.33,136,3.16,149.57-.65.17-8.11-3.59-12.18-3.59-12.18s-1.4,4.45-56.45,8.22C125.55,365.9,114.6,352.5,114.6,352.5Z"
              fill="#854612"
            />
            <path
              d="M204.54,140.81a5,5,0,0,0-.06,5.38,3.42,3.42,0,0,0,4.56,1.05,4.05,4.05,0,0,0,2.64,2.93,5.63,5.63,0,0,0,4-.43A3.68,3.68,0,0,0,219,152a4.14,4.14,0,0,0,3.87-1.55,5.66,5.66,0,0,0,3.62,1.49c2.54.25,3.32-1.42,3.32-1.42a7.89,7.89,0,0,0,3.84,1.19,3.7,3.7,0,0,0,3.25-2,4.09,4.09,0,0,0,3.44.81c2.89-.81,3.21-2.59,3.21-2.59a6.78,6.78,0,0,0,4.47-.29c2-1,1.4-3.77,1.4-3.77s1.51.59,1.59-.43-1.29-2.66-1.29-2.66a69.1,69.1,0,0,1-25.54,4.72C209.57,145.45,204.54,140.81,204.54,140.81Z"
              fill="#4842d5"
            />
            <path
              d="M234.05,151.73a3.77,3.77,0,0,0,2.82-2,4.09,4.09,0,0,0,3.44.81c2.89-.81,3.21-2.59,3.21-2.59a6.78,6.78,0,0,0,4.47-.29c2-1,1.4-3.77,1.4-3.77s1.51.59,1.59-.43-1.29-2.66-1.29-2.66A65.93,65.93,0,0,1,233.07,145Z"
              fill="#392ec6"
            />
            <path
              d="M221,116.36a1.88,1.88,0,0,0,1.41,2.49,3.45,3.45,0,0,0,3.42-1.31s-.75,2.89-3.5,2.43S221,116.36,221,116.36Z"
              fill="#392ec6"
            />
            <path
              d="M222.59,123.65a1.88,1.88,0,0,0,1.7,2.3,3.45,3.45,0,0,0,3.24-1.71s-.41,3-3.19,2.83S222.59,123.65,222.59,123.65Z"
              fill="#392ec6"
            />
            <path
              d="M217.73,126.65a1.86,1.86,0,0,0,1.4,2.48,3.43,3.43,0,0,0,3.42-1.3s-.75,2.89-3.5,2.42S217.73,126.65,217.73,126.65Z"
              fill="#392ec6"
            />
            <path
              d="M223.64,132.61a1.87,1.87,0,0,0,1.62,2.35,3.42,3.42,0,0,0,3.29-1.6s-.5,2.95-3.27,2.73S223.64,132.61,223.64,132.61Z"
              fill="#392ec6"
            />
            <path
              d="M266.33,120.93a2.62,2.62,0,0,0,2.21,2.4c2.11.36,2.77-2.31,2.77-2.31s0,3.66-2.75,3.44S266.33,120.93,266.33,120.93Z"
              fill="#392ec6"
            />
            <path
              d="M262.94,116.39a2.63,2.63,0,0,0,2.22,2.4c2.11.36,2.77-2.31,2.77-2.31s0,3.66-2.75,3.44S262.94,116.39,262.94,116.39Z"
              fill="#392ec6"
            />
            <path
              d="M247.15,112.78a2.63,2.63,0,0,0,1.55,2.88c2,.86,3.25-1.56,3.25-1.56s-.88,3.56-3.51,2.65S247.15,112.78,247.15,112.78Z"
              fill="#392ec6"
            />
            <path
              d="M253.16,108.76a2.63,2.63,0,0,0,1.55,2.87c2,.87,3.26-1.55,3.26-1.55s-.88,3.55-3.52,2.65S253.16,108.76,253.16,108.76Z"
              fill="#392ec6"
            />
            <path
              d="M260.47,103.45a2.64,2.64,0,0,0,2.11,2.5c2.09.45,2.87-2.17,2.87-2.17s-.14,3.65-2.91,3.3S260.47,103.45,260.47,103.45Z"
              fill="#392ec6"
            />
            <path
              d="M280.24,105.15a2.64,2.64,0,0,1-2.11,2.5c-2.09.45-2.87-2.18-2.87-2.18s.14,3.66,2.91,3.31S280.24,105.15,280.24,105.15Z"
              fill="#4842d5"
            />
            <path
              d="M279.41,115.41a2.62,2.62,0,0,1-1.7,2.79c-2,.76-3.17-1.72-3.17-1.72s.69,3.59,3.37,2.83S279.41,115.41,279.41,115.41Z"
              fill="#4842d5"
            />
            <path
              d="M285.89,110.53a2.64,2.64,0,0,1-1.71,2.79c-2,.76-3.16-1.72-3.16-1.72s.68,3.59,3.37,2.83S285.89,110.53,285.89,110.53Z"
              fill="#4842d5"
            />
            <path
              d="M255.34,96.14A2.63,2.63,0,0,0,257,99c2,.78,3.18-1.68,3.18-1.68s-.72,3.58-3.4,2.79S255.34,96.14,255.34,96.14Z"
              fill="#392ec6"
            />
            <path
              d="M255.11,120.74a2.65,2.65,0,0,0,1.76,2.76c2,.71,3.13-1.79,3.13-1.79s-.61,3.61-3.31,2.9S255.11,120.74,255.11,120.74Z"
              fill="#392ec6"
            />
            <path
              d="M214.86,138.72a1.87,1.87,0,0,0,1.69,2.3,3.43,3.43,0,0,0,3.24-1.7s-.4,3-3.19,2.83S214.86,138.72,214.86,138.72Z"
              fill="#392ec6"
            />
            <path
              d="M212.61,133.62a1.87,1.87,0,0,0,1.47,2.45,3.44,3.44,0,0,0,3.38-1.4s-.67,2.91-3.43,2.52S212.61,133.62,212.61,133.62Z"
              fill="#392ec6"
            />
            <path
              d="M226,145.08a1.88,1.88,0,0,0,1.47,2.45,3.45,3.45,0,0,0,3.39-1.4s-.68,2.91-3.44,2.52S226,145.08,226,145.08Z"
              fill="#392ec6"
            />
            <polygon
              points="120.03 347.81 126.31 346.86 134.8 349.4 147.05 349.4 134.03 351 126.31 348.02 120.03 347.81"
              fill="#854612"
            />
            <polygon
              points="124.31 351.74 127.31 351 132.27 353.65 137.31 354.08 130.81 354.93 127.7 352.5 124.31 351.74"
              fill="#854612"
            />
            <polygon
              points="248.12 341.02 241.41 340.7 232.83 343.23 224 343.23 233.36 344.84 241.41 342.19 248.12 341.02"
              fill="#854612"
            />
            <polygon
              points="251.09 343.23 243.76 343.14 238.35 346.01 244.72 344.57 251.09 343.23"
              fill="#854612"
            />
            <path
              d="M245.46,350.36c-.85.64-22.72-4.14-24.63.64s14.76,3.08,14.76,3.08-11.58.8-10.94-2.47,8.6-.93,13.27-.61A21.27,21.27,0,0,0,245.46,350.36Z"
              fill="#854612"
              opacity="0.58"
            />
            <path
              d="M174.7,296c-.84.64-22.72-4.14-24.63.64s14.76,3.08,14.76,3.08-11.57.8-10.94-2.47,8.6-.93,13.28-.61A21.24,21.24,0,0,0,174.7,296Z"
              fill="#854612"
              opacity="0.58"
            />
            <polygon
              points="151.25 345.61 160.32 344.97 180.92 344.97 161.37 346.34 151.25 345.61"
              fill="#854612"
            />
            <path
              d="M147.77,357.53c-4.78-.32-9.67-5.15.66-5.92s13.9,4.33,11.24,5.92-7.28,1.27-7.28,1.27,6.53-1.62,4-3.87-9.63-2.26-10-.51A3.68,3.68,0,0,0,147.77,357.53Z"
              fill="#854612"
              opacity="0.58"
            />
            <path
              d="M175.84,347.85c3.41-.14,8.69-1.16,18.23-3.43s20.15-.41,18.91,3.43-16.61,5.19-21.82,4.06,0-5.23,9-5.39c-5.25,2.21-8.38,4.37-1,3.69s10.72-2,9.28-3.69-10.1-2.36-17.23.32S175.84,347.85,175.84,347.85Z"
              fill="#854612"
              opacity="0.58"
            />
            <polygon
              points="137.56 325.07 143.84 324.25 152.33 326.45 164.58 326.45 151.56 327.82 143.84 325.26 137.56 325.07"
              fill="#854612"
            />
            <polygon
              points="141.84 328.46 144.84 327.82 149.8 330.11 154.84 330.48 148.34 331.21 145.23 329.12 141.84 328.46"
              fill="#854612"
            />
            <polygon
              points="168.78 323.17 177.85 322.63 198.45 322.63 178.9 323.8 168.78 323.17"
              fill="#854612"
            />
            <polygon
              points="202.09 307.89 211.15 307.34 231.75 307.34 212.21 308.52 202.09 307.89"
              fill="#854612"
            />
            <polygon
              points="174.98 294.21 184.04 293.66 204.64 293.66 185.09 294.84 174.98 294.21"
              fill="#854612"
            />
            <polygon
              points="166.09 306.98 175.15 306.43 195.75 306.43 176.2 307.61 166.09 306.98"
              fill="#854612"
            />
            <polygon
              points="194.89 313.52 205.79 312.87 230.56 312.85 207.06 314.27 194.89 313.52"
              fill="#854612"
            />
            <path
              d="M165.3,333.46c-4.78-.28-9.66-4.44.66-5.11s13.9,3.73,11.24,5.11-7.28,1.1-7.28,1.1,6.53-1.4,4-3.35-9.63-1.94-10-.43S165.3,333.46,165.3,333.46Z"
              fill="#854612"
              opacity="0.58"
            />
            <path
              d="M205.56,297.61c-3.05-.17-6.17-2.83.42-3.25s8.86,2.38,7.16,3.25a11,11,0,0,1-4.64.7s4.17-.89,2.54-2.13-6.14-1.24-6.35-.28S205.56,297.61,205.56,297.61Z"
              fill="#854612"
              opacity="0.58"
            />
            <path
              d="M193.37,325.1c3.41-.11,8.69-1,18.23-3s20.15-.35,18.91,3-16.6,4.49-21.82,3.51,0-4.51,8.95-4.65c-5.25,1.91-8.38,3.77-1,3.18s10.72-1.77,9.28-3.18-10.1-2-17.23.28S193.37,325.1,193.37,325.1Z"
              fill="#854612"
              opacity="0.58"
            />
            <path
              d="M175.38,310.23c-2.88-.1-7.33-.84-15.38-2.49s-17-.3-15.95,2.49,14,3.78,18.41,2.95,0-3.8-7.56-3.92c4.43,1.61,7.07,3.18.85,2.69s-9.05-1.5-7.84-2.69,8.53-1.71,14.55.24S175.38,310.23,175.38,310.23Z"
              fill="#854612"
              opacity="0.58"
            />
            <path
              d="M235.44,123.85a1.87,1.87,0,0,1-1.69,2.3,3.45,3.45,0,0,1-3.25-1.7s.41,3,3.19,2.82S235.44,123.85,235.44,123.85Z"
              fill="#4842d5"
            />
            <path
              d="M241.17,129a1.87,1.87,0,0,1-1.69,2.3,3.45,3.45,0,0,1-3.24-1.71s.4,3,3.18,2.83S241.17,129,241.17,129Z"
              fill="#4842d5"
            />
            <path
              d="M239.51,136.51a1.87,1.87,0,0,1-1.69,2.3,3.43,3.43,0,0,1-3.24-1.7s.4,3,3.18,2.83S239.51,136.51,239.51,136.51Z"
              fill="#4842d5"
            />
            <path
              d="M245.32,139.44A1.87,1.87,0,0,1,244.1,142a3.44,3.44,0,0,1-3.51-1.05s1,2.83,3.67,2.17S245.32,139.44,245.32,139.44Z"
              fill="#4842d5"
            />
            <path
              d="M232.12,117.8a1.61,1.61,0,0,1-1.05,2.22,3,3,0,0,1-3-.9s.82,2.43,3.15,1.85S232.12,117.8,232.12,117.8Z"
              fill="#4842d5"
            />
            <path
              d="M267.46,222.78a1.73,1.73,0,0,1,.12.82l-.11,1.47a1.86,1.86,0,0,1-2,1.71l-2.51-.19-.31-.05a1.84,1.84,0,0,0,1.58,1.16l2.51.19a1.85,1.85,0,0,0,2-1.71l.11-1.46A1.85,1.85,0,0,0,267.46,222.78Z"
              fill="#ebd6ff"
            />
            <path
              d="M255.3,202.87a1.93,1.93,0,0,1,.13.83l-.12,1.47a1.86,1.86,0,0,1-2,1.71l-2.51-.2a1.06,1.06,0,0,1-.31-.05,1.85,1.85,0,0,0,1.58,1.17l2.51.19a1.86,1.86,0,0,0,2-1.71l.11-1.46A1.87,1.87,0,0,0,255.3,202.87Z"
              fill="#ebd6ff"
            />
            <path
              d="M263.39,194.89a1.73,1.73,0,0,1,.12.82l-.11,1.47a1.86,1.86,0,0,1-2,1.71l-2.52-.19a1.7,1.7,0,0,1-.31-.06,1.86,1.86,0,0,0,1.59,1.17l2.51.19a1.86,1.86,0,0,0,2-1.71l.11-1.46A1.85,1.85,0,0,0,263.39,194.89Z"
              fill="#ebd6ff"
            />
            <path
              d="M258.32,215.72a3,3,0,0,1,.2,1.31l-.18,2.31a2.94,2.94,0,0,1-3.15,2.71l-4-.31a2.64,2.64,0,0,1-.49-.08,2.94,2.94,0,0,0,2.51,1.85l4,.3a3,3,0,0,0,3.16-2.7l.17-2.32A2.94,2.94,0,0,0,258.32,215.72Z"
              fill="#ebd6ff"
            />
            <path
              d="M259.33,230.9a1.93,1.93,0,0,1,.13.83l-.12,1.46a1.84,1.84,0,0,1-2,1.71l-2.51-.19a1.54,1.54,0,0,1-.31-.05,1.85,1.85,0,0,0,1.58,1.17l2.52.19a1.86,1.86,0,0,0,2-1.71l.11-1.47A1.86,1.86,0,0,0,259.33,230.9Z"
              fill="#ebd6ff"
            />
            <path
              d="M70,214.6c1.3-9.47,1-20.92-6.57-24s-13.33,26.47-12.2,38.24,6.29,20.79,8.54,16.56S70,214.6,70,214.6Z"
              fill="#fff"
            />
            <path
              d="M67.26,193.59c.12,3.16-2,7.12-2.46,10.22,0,0-12.72,12.87-10.52,27.69.38,2.53-1,3.2-2.82-.48,1.51,10.67,6.17,18.35,8.28,14.38C62,241.16,70,214.6,70,214.6,71,207.13,71,198.44,67.26,193.59Z"
              fill="#dce6ff"
            />
            <path
              d="M142.05,294.2s-1.45-45.3,45-45.77c46-.47,43.82,46.31,43.82,46.31s6.11,2.15,15.57-.3c8-2.07,9.18-4.69,9.18-4.69s2.66-65.77-69.94-66.83c-68.53-1-69,67.51-69,67.51S129.41,299.78,142.05,294.2Z"
              fill="#b5820c"
            />
            <path
              d="M57.83,203.73A2.9,2.9,0,0,1,54,205.65c-1.38-.46-1.34-2.24-.67-4.23s1.71-3.43,3.09-3S58.5,201.74,57.83,203.73Z"
              fill="#a99aff"
            />
            <path
              d="M55.78,217a2.89,2.89,0,0,1-3.59,2.34c-1.43-.31-1.58-2.08-1.14-4.13s1.31-3.6,2.74-3.29S56.22,215,55.78,217Z"
              fill="#a99aff"
            />
            <path
              d="M54.49,212.31a5.88,5.88,0,0,1,.41,3.47,2.91,2.91,0,0,1-3.59,2.34,2.13,2.13,0,0,1-.38-.14,1.63,1.63,0,0,0,1.26,1.38A2.89,2.89,0,0,0,55.78,217,5.38,5.38,0,0,0,54.49,212.31Z"
              fill="#9f77ff"
            />
            <path
              d="M57.33,199.22a5.85,5.85,0,0,1,0,3.29,2.9,2.9,0,0,1-3.83,1.92,1.5,1.5,0,0,1-.56-.34,1.65,1.65,0,0,0,1.1,1.56,2.9,2.9,0,0,0,3.83-1.92A5.61,5.61,0,0,0,57.33,199.22Z"
              fill="#9f77ff"
            />
            <path
              d="M265.31,149.42a2.23,2.23,0,0,1,0,.45l-.11,1.46a1.86,1.86,0,0,1-2,1.71l-2.51-.19a1.72,1.72,0,0,1-.84-.28,1.84,1.84,0,0,0,1.69,1.55l2.51.2a1.87,1.87,0,0,0,2-1.71l.11-1.47A1.87,1.87,0,0,0,265.31,149.42Z"
              fill="#ebd6ff"
            />
            <path
              d="M258.14,161.87l-.13,1.71a2.26,2.26,0,0,1-2.42,2.07l-3.05-.23a2.33,2.33,0,0,1-.84-.24v.07a2.27,2.27,0,0,0,2.08,2.42l3,.23a2.25,2.25,0,0,0,2.42-2.07l.14-1.78A2.26,2.26,0,0,0,258.14,161.87Z"
              fill="#ebd6ff"
            />
            <path
              d="M257.22,134.41a2.53,2.53,0,0,1,0,.28l-.09,1.15a1.48,1.48,0,0,1-1.58,1.36l-2-.15a1.49,1.49,0,0,1-.72-.26,1.49,1.49,0,0,0,1.35,1.31l2,.15a1.48,1.48,0,0,0,1.58-1.36l.09-1.15A1.48,1.48,0,0,0,257.22,134.41Z"
              fill="#ebd6ff"
            />
            <path
              d="M217,195c1.92,0,5.53,7.22,5.95,9.35s4,5.94,5.1,6.58a13.81,13.81,0,0,0,4.88,1.28c1.06,0,4.46,2.12,4.46,2.12v11.47c0,1.7-.63,7.64-.85,8.7a41.52,41.52,0,0,1-2.55,5.31s-.21,1.28,1.7,2.76a5.28,5.28,0,0,0,4,1.07s1.64.61,4-.88c3.05-.84,4.43-.63,6.45.8.52.36,1.09-.56,2.15.08s-2.13-1.28-3.4-2.13-4.25-.85-4.25-.85l-3.4-1.91s-.84-6.79-1.06-7.86a15.86,15.86,0,0,1-.63-6.15,54.71,54.71,0,0,0,.85-5.74c0-1.06,0-3.4-.43-4.25s1.27-2.54,1.27-2.54a4.71,4.71,0,0,0,2.13-2.13,9.44,9.44,0,0,0,.42-3.18c0-.85-1.26-3.25-.27-3.62a2.81,2.81,0,0,0,2.18-2.54,19.51,19.51,0,0,0-.63-5.1L244,200.54a6.51,6.51,0,0,1-1.2,1.14c-1,.8-2,1.64-1.75,2.7a31.74,31.74,0,0,1,0,4.54l-2.31,2.55a11.73,11.73,0,0,1-2.6-2.86,17.14,17.14,0,0,1-1.91-5.1l-.22-2.13-2.33-2.12-1.28.85s2.06,6.41,3,7.86c.5.79,2.89,3.82,2.89,3.82s-3.9-1.46-6.45-2.31-3.24-2.79-3.88-3.42-1.27-3.83-2.12-4.89S217,195,217,195Z"
              fill="#946235"
            />
            <path
              d="M223.19,204.94a27,27,0,0,0,1.51,2.63,12.68,12.68,0,0,0,1.76,1c.47.15,1.59.15,2.07.63s3.74,1.6,5.17,2.15a5.52,5.52,0,0,0,2.55.4s-1.48-.59-3.26-1.22c-2.41-.85-4.52-1.12-6.14-3.32a7.66,7.66,0,0,1-.87-1.59Z"
              fill="#72300a"
              opacity="0.56"
            />
            <path
              d="M233.07,207.21a7.58,7.58,0,0,0,1.11,1.93,4.52,4.52,0,0,0,2.51.22l-1.63-2.27Z"
              fill="#72300a"
              opacity="0.56"
            />
            <path
              d="M241,204.38l.08,1.72s.16,0,.68.47.87.44,1.19,1-1,2.83-1.11,3.19a21.47,21.47,0,0,1-1.56,1.59,14.77,14.77,0,0,0-.4,2.23s.5-2.06,1.3-2.4a3.86,3.86,0,0,0,2.13-2.13,6.42,6.42,0,0,0,.29-3.9,5.51,5.51,0,0,1-.13-1.93Z"
              fill="#72300a"
              opacity="0.56"
            />
            <path
              d="M268.66,245.19c0-9.56,12.17-16.95,22-19s15.39,28.44,12,39.95-24.46,15.44-26.53,10.94S268.66,245.19,268.66,245.19Z"
              fill="#fff"
            />
            <path
              d="M292.29,229.47c0-9.56,2-20.86,10.13-22.9s10,28,7.21,39.54-9.39,19.75-11.12,15.25S292.29,229.47,292.29,229.47Z"
              fill="#fff"
            />
            <path
              d="M291.5,226.11c3.1,9.38,4.12,22.3,2.17,28.94-2.33,7.93-13.05,12.26-20.17,12.71a69.8,69.8,0,0,0,2.63,9.33c2.07,4.5,23.14.58,26.53-10.94C305.94,255,300.78,225.94,291.5,226.11Z"
              fill="#dce6ff"
            />
            <path
              d="M302.42,206.57a10.43,10.43,0,0,0-1.43.48c2.75,9.16,2.94,25,1.07,32.7a40.65,40.65,0,0,1-5.58,13.09,73.12,73.12,0,0,0,2,8.52c1.73,4.5,8.3-3.74,11.12-15.25S310.59,204.54,302.42,206.57Z"
              fill="#dce6ff"
            />
            <path
              d="M295.69,242.08c.83,1.92.16,4.41-3.08,5.79s-7.81,1.15-8.63-.78,2.41-4.82,5.64-6.2S294.87,240.15,295.69,242.08Z"
              fill="#a99aff"
            />
            <path
              d="M305.63,219.73c.83,1.93.66,4.19-1.47,5.11s-5.42.12-6.24-1.81,1.12-4.26,3.25-5.17S304.81,217.8,305.63,219.73Z"
              fill="#a99aff"
            />
            <path
              d="M295.69,242.08a3,3,0,0,0-1.51-1.63,2.4,2.4,0,0,0,.11.23c.82,1.93.15,4.41-3.08,5.79a10.45,10.45,0,0,1-7.31.39,1,1,0,0,0,.08.23c.82,1.93,5.4,2.16,8.63.78S296.52,244,295.69,242.08Z"
              fill="#9f77ff"
            />
            <path
              d="M305.63,219.73A3.89,3.89,0,0,0,304.3,218c0,.06.06.11.09.18.82,1.92.65,4.19-1.48,5.1a5.73,5.73,0,0,1-5.08-.49,1.43,1.43,0,0,0,.09.27c.82,1.93,4.11,2.72,6.24,1.81S306.46,221.66,305.63,219.73Z"
              fill="#9f77ff"
            />
            <path
              d="M245.58,257.66c0-9.55,12.17-17,22-19s15.39,28.44,12,40-24.45,15.44-26.53,10.94S245.58,257.66,245.58,257.66Z"
              fill="#fff"
            />
            <path
              d="M273.3,241.4c2,8.61,2.47,18.59.84,24.15-2.85,9.68-18.2,14-24.24,12.45a89.5,89.5,0,0,0,3.15,11.56c2.08,4.5,23.14.58,26.53-10.94C282.23,269.6,279.38,249,273.3,241.4Z"
              fill="#dce6ff"
            />
            <path
              d="M274.72,246.38c.83,1.93.16,4.41-3.08,5.79s-7.81,1.15-8.63-.78,2.41-4.81,5.65-6.2S273.9,244.45,274.72,246.38Z"
              fill="#a99aff"
            />
            <path
              d="M271,263c.82,1.92.15,4.41-3.08,5.79s-7.82,1.15-8.64-.78,2.41-4.82,5.65-6.2S270.17,261,271,263Z"
              fill="#a99aff"
            />
            <path
              d="M274.72,246.38a3.13,3.13,0,0,0-3.52-1.9,3.14,3.14,0,0,1,1.05,1.36c.83,1.93.16,4.41-3.08,5.79a11.57,11.57,0,0,1-5,.87c1.78.84,5,.72,7.43-.33C274.88,250.79,275.55,248.31,274.72,246.38Z"
              fill="#9f77ff"
            />
            <path
              d="M271,263a3,3,0,0,0-2.13-1.84,3.78,3.78,0,0,1,.17.35c.82,1.93.15,4.41-3.08,5.8a11,11,0,0,1-6.72.59.49.49,0,0,0,0,.11c.82,1.93,5.4,2.16,8.64.78S271.82,264.89,271,263Z"
              fill="#9f77ff"
            />
            <path
              d="M218.13,261.9c-1.76-3.93,13.23-25.27,17-23.47,7.05,3.34,19.46,16.65,17.2,23.36-2.73,8.13-24,15.18-25.8,14.25S219.08,264,218.13,261.9Z"
              fill="#fff"
            />
            <path
              d="M227.88,277.87c-.26-3,21.82-17.2,25-14.45s9.56,23,6.05,28.31-25.65,5.07-26.77,3.48S228.08,280.18,227.88,277.87Z"
              fill="#fff"
            />
            <path
              d="M219.24,256.91c1.07,2.35,3.14,10.08,8.55,12.26,6.3,2.54,19.75-3.31,24.69-10.63a6.52,6.52,0,0,1-.12,3.25c-2.73,8.13-24,15.18-25.8,14.25s-7.48-12-8.43-14.14C217.72,261,218.21,259.17,219.24,256.91Z"
              fill="#dce6ff"
            />
            <path
              d="M230.42,274.66c.81,4.45.87,11.72,4.56,14.75s19.12,2.45,24.93-1.58a7.85,7.85,0,0,1-1,3.9c-3.51,5.28-25.65,5.07-26.77,3.48s-4.06-15-4.26-17.34C227.82,277.23,228.81,276.06,230.42,274.66Z"
              fill="#dce6ff"
            />
            <path
              d="M296.92,48.81c14.19-.44,25.7-9.14,28.61-26.76-3.19,5.22-11.15,8.17-11.15,8.17s7.32-7,4.46-16.33c-2.51,3.28-16,8.2-28.28,6.28,2.17,3.83,3.76,9.1,4.38,16.42A82.86,82.86,0,0,0,296.92,48.81Z"
              fill="#74a9ff"
            />
            <path
              d="M72.59,208.61c.64,1.27.43,22.93.43,22.93l16.78,7.65,18.47-8.29.21-27.6L87,194.16l-7.86,4Z"
              fill="#fffad1"
            />
            <polygon
              points="89.58 239.09 89.8 239.19 108.27 230.9 108.48 203.3 89.58 195.25 89.58 239.09"
              fill="#ebd6ff"
            />
            <path
              d="M93.85,214.75s-2.72,1.16-6.79-2.91-7.18-11.64-7.18-11.64l-7.57,9.7s-3.3.77-3.69-1.36c2.91-1.94,11.26-13.78,11.26-13.78l13-5.62s13.81,17,17.3,17.34C104.56,214.63,93.85,214.75,93.85,214.75Z"
              fill="#392ec6"
            />
            <rect
              x="80.42"
              y="157.1"
              width="2.26"
              height="38.64"
              rx="1.13"
              fill="#282117"
            />
            <path
              d="M75.14,232.6S72,210.52,79.6,212.22s6.16,25.27,6.16,25.27Z"
              fill="#a122ff"
            />
            <path
              d="M102.41,229.1l-3.63,1.38a3.66,3.66,0,0,1-5-3.42v-6.7a3.66,3.66,0,0,1,2.36-3.42l3.63-1.38a3.66,3.66,0,0,1,5,3.42v6.7A3.66,3.66,0,0,1,102.41,229.1Z"
              fill="#eb8730"
            />
            <path
              d="M97.37,216.63l-2,.76a3.66,3.66,0,0,0-1.52,3v6.7a3.66,3.66,0,0,0,5,3.42l2-.77a3.68,3.68,0,0,0,1.52-3V220A3.66,3.66,0,0,0,97.37,216.63Z"
              fill="#ffbe3a"
            />
            <path
              d="M78.19,231.17c0-9.55-2.35-20.86-12.17-22.89s-12,28-8.66,39.54,11.28,19.75,13.35,15.25S78.19,231.17,78.19,231.17Z"
              fill="#fff"
            />
            <path
              d="M66,208.28l-.35-.06c2.84,4.62,3.7,11,3.69,16.78,0,0-5.4,27.39-7.48,31.89a2.46,2.46,0,0,1-.31.53c3.57,5.83,7.73,8.73,9.14,5.65,2.08-4.5,7.48-31.9,7.48-31.9C78.2,221.62,75.84,210.31,66,208.28Z"
              fill="#dce6ff"
            />
            <path
              d="M104.35,246.88c0-9.56-12.17-17-22-19s-15.39,28.43-12,39.95,24.46,15.43,26.53,10.93S104.35,246.88,104.35,246.88Z"
              fill="#fff"
            />
            <path
              d="M98.86,236.1c-4.82,4.54-7.15,17.5-8.67,28.22S73,267,69.36,258.54a33.68,33.68,0,0,0,1,9.3c3.39,11.51,24.46,15.43,26.53,10.93s7.47-31.89,7.47-31.89C104.36,242.81,102.15,239.13,98.86,236.1Z"
              fill="#dce6ff"
            />
            <path
              d="M127.43,259.35c0-9.56-12.17-17-22-19s-15.39,28.43-12,39.95,24.45,15.43,26.53,10.93S127.43,259.35,127.43,259.35Z"
              fill="#fff"
            />
            <path
              d="M121.47,248.14c-1.44,3.87-9.82,18.45-8.82,33.73-5.46,4.79-19.22-1.56-20.16-8a28.45,28.45,0,0,0,.94,6.45c3.39,11.51,24.45,15.43,26.53,10.93s7.47-31.89,7.47-31.89C127.44,255.09,125,251.26,121.47,248.14Z"
              fill="#dce6ff"
            />
            <ellipse
              cx="102.11"
              cy="251.72"
              rx="3.8"
              ry="6.37"
              transform="translate(-169.02 268.26) rotate(-71.41)"
              fill="#a99aff"
            />
            <ellipse
              cx="108.73"
              cy="266.71"
              rx="3.8"
              ry="6.37"
              transform="translate(-178.73 284.74) rotate(-71.41)"
              fill="#a99aff"
            />
            <ellipse
              cx="78.19"
              cy="236.27"
              rx="3.8"
              ry="6.37"
              transform="translate(-170.68 235.06) rotate(-71.41)"
              fill="#a99aff"
            />
            <ellipse
              cx="79.35"
              cy="252.83"
              rx="3.8"
              ry="6.37"
              transform="translate(-185.58 247.43) rotate(-71.41)"
              fill="#a99aff"
            />
            <path
              d="M65.82,220.73c-.67,2-3.64,2-6.14,1.15s-2.86-2.76-2.19-4.74,2.11-3.3,4.61-2.46S66.49,218.75,65.82,220.73Z"
              fill="#a99aff"
            />
            <path
              d="M64.51,239.37c-.67,2-3.23,2.12-5.34,1.41s-2.34-2.58-1.67-4.56,2-3.35,4.09-2.63A5.14,5.14,0,0,1,64.51,239.37Z"
              fill="#a99aff"
            />
            <path
              d="M82.62,234.46a2.68,2.68,0,0,1,.13,1.92c-.67,2-3.91,2.69-7.25,1.56a9.45,9.45,0,0,1-3.21-1.79A7.69,7.69,0,0,0,77,239.87c3.34,1.12,6.58.42,7.25-1.57C84.64,237.07,84,235.64,82.62,234.46Z"
              fill="#9f77ff"
            />
            <path
              d="M83.64,251a2.66,2.66,0,0,1,.14,1.91c-.67,2-3.92,2.69-7.25,1.56a9.4,9.4,0,0,1-3.22-1.79A7.71,7.71,0,0,0,78,256.4c3.33,1.12,6.58.42,7.25-1.57C85.67,253.6,85,252.17,83.64,251Z"
              fill="#9f77ff"
            />
            <path
              d="M106.52,249.94a2.65,2.65,0,0,1,.13,1.91c-.67,2-3.91,2.69-7.25,1.57a9.63,9.63,0,0,1-3.21-1.8,7.68,7.68,0,0,0,4.69,3.72c3.34,1.12,6.58.42,7.25-1.57C108.54,252.55,107.88,251.12,106.52,249.94Z"
              fill="#9f77ff"
            />
            <path
              d="M113.19,264.89a2.71,2.71,0,0,1,.13,1.91c-.67,2-3.91,2.69-7.25,1.57a9.54,9.54,0,0,1-3.21-1.8,7.62,7.62,0,0,0,4.69,3.72c3.33,1.12,6.58.42,7.25-1.57C115.21,267.5,114.54,266.07,113.19,264.89Z"
              fill="#9f77ff"
            />
            <path
              d="M64,215.82a4.22,4.22,0,0,1,.55,3.25c-.67,2-3.64,2-6.14,1.14a4.44,4.44,0,0,1-1-.49,3.34,3.34,0,0,0,2.36,2.16c2.5.84,5.47.84,6.14-1.15C66.31,219.29,65.44,217.18,64,215.82Z"
              fill="#9f77ff"
            />
            <path
              d="M62.15,233.85a4.76,4.76,0,0,1,.68,3.84c-.66,2-3.22,2.12-5.34,1.41L57.3,239a2.71,2.71,0,0,0,1.87,1.75c2.11.71,4.67.58,5.34-1.41A5.22,5.22,0,0,0,62.15,233.85Z"
              fill="#9f77ff"
            />
            <path
              d="M154.53,260.72c1.69-3.77-12.7-24.25-16.35-22.52-6.76,3.2-18.67,16-16.5,22.42,2.62,7.8,23.08,14.56,24.76,13.66S153.62,262.76,154.53,260.72Z"
              fill="#fff"
            />
            <path
              d="M146.32,276.86c.26-3-21.82-17.2-25-14.45s-9.56,23-6,28.3,25.65,5.08,26.77,3.49S146.11,279.17,146.32,276.86Z"
              fill="#fff"
            />
            <path
              d="M153.47,255.93c-1,2.26-3,9.68-8.21,11.77-6,2.43-18.95-3.18-23.7-10.21a6.28,6.28,0,0,0,.12,3.13c2.62,7.8,23.08,14.56,24.76,13.66s7.18-11.52,8.09-13.56C154.92,259.85,154.46,258.1,153.47,255.93Z"
              fill="#dce6ff"
            />
            <path
              d="M143.78,273.65c-.82,4.44-.88,11.72-4.56,14.75s-19.13,2.44-24.94-1.58a8,8,0,0,0,1,3.89c3.51,5.28,25.65,5.08,26.77,3.49s4.06-15,4.27-17.34C146.37,276.22,145.39,275.05,143.78,273.65Z"
              fill="#dce6ff"
            />
            <path
              d="M150.88,190.62a17.34,17.34,0,0,0-4.3-14.55,3.33,3.33,0,0,0-1.78-1.18,1.31,1.31,0,0,0-1.57,1.09c-.56-4.67-6.5-7.76-10.64-5.53a13.85,13.85,0,0,0-5.89-1.55c-2,.08-4.2,1.36-4.58,3.37a4.86,4.86,0,0,0-5.63,6.87c-3.29,1.24-4.4,6.15-2,8.7a3.33,3.33,0,0,0-3.87,2.34,5.5,5.5,0,0,0,1,4.73,5.21,5.21,0,0,1,1.16,2c.19,1-.4,2-.62,3-.71,3.17,2.34,6,5.36,7.19C129.76,212,148.5,204.23,150.88,190.62Z"
              fill="#527e23"
            />
            <path
              d="M131.53,193.31a5.11,5.11,0,0,0,.63-2.86,28.51,28.51,0,0,0,4.46-2.23c1-.8.64-1.75.32-4.3s-1.43-2.23-1.43-2.23-1.28-1-1.44-1.6,2.23-2.54,2.23-4.14-2.7-2.54-2.7-2.54-2.23-.64-1.91-1.28a4.12,4.12,0,0,0-.52-2.27,11.06,11.06,0,0,0-4.47-1c-2,.08-4.2,1.36-4.58,3.37a4.86,4.86,0,0,0-5.63,6.87c-3.29,1.24-4.4,6.15-2,8.7a3.33,3.33,0,0,0-3.87,2.34,5.5,5.5,0,0,0,1,4.73,5.21,5.21,0,0,1,1.16,2c.19,1-.4,2-.62,3a4.44,4.44,0,0,0,0,1.92,4.53,4.53,0,0,0,1.62-.31,4,4,0,0,1,3.18-.16,10.84,10.84,0,0,0,3.83-1.12,4.55,4.55,0,0,0,2.7-3.5,7.72,7.72,0,0,1,1-2.55,24.14,24.14,0,0,0,4,.8A3.28,3.28,0,0,0,131.53,193.31Z"
              fill="#6c9b23"
            />
            <path
              d="M80.91,140.05s.79-1.54,9.94-2.82,22,2.71,30.42-2.23c-1.46,6.95-8.89,10.9-8.89,10.9a23.29,23.29,0,0,0,11.28-6.76c-.91,8.42-8.42,19.73-20.86,19.91s-19.7-.15-22.26,2A85.31,85.31,0,0,1,80.91,140.05Z"
              fill="#19a7d7"
            />
            <path
              d="M91.75,152.68c-5.23-2.73-8.49-8-10.34-13.05a1.4,1.4,0,0,0-.5.42,85.31,85.31,0,0,0-.37,21c2.56-2.19,9.81-1.86,22.26-2,.61,0,1.2-.05,1.79-.11l6.65-1.92a20.92,20.92,0,0,0,4.18-2.77C107.38,155.14,97.17,155.5,91.75,152.68Z"
              fill="#1992d7"
            />
            <g>
              <path
                d="M196,26.57c-.62-.19-.9-.53-.82-1s.11-.8.17-1.15a6.23,6.23,0,0,1,.22-.92A.82.82,0,0,1,196,23a1,1,0,0,1,.57-.08c.21,0,.57.11,1.07.23q1.1-2.24,2.3-4.39t2.33-4.06a1.5,1.5,0,0,1,1.21-.78c.42,0,.86,0,1.32,0s.86.06,1.22.11.42.06.6.1a4.8,4.8,0,0,1,.47.1,1.43,1.43,0,0,1,1,1c.35,1,.76,2.41,1.23,4.1s.89,3.55,1.3,5.57l.61.05.32,0h.21a.81.81,0,0,1,.75.82,5,5,0,0,1,0,1.43l-.06.4a2.22,2.22,0,0,1-.1.41,1.18,1.18,0,0,1-.39.63,1.23,1.23,0,0,1-.65.15c.06.38.1.74.14,1.08s.08.64.11.9a2.22,2.22,0,0,1,0,.41,1,1,0,0,1,0,.18.73.73,0,0,1-.68.68,12.81,12.81,0,0,1-1.52.13A8.17,8.17,0,0,1,207.8,32a1,1,0,0,1-.62-.29,1.43,1.43,0,0,1-.24-.68l-.31-2.58q-1.38-.12-2.76-.33c-.59-.08-1.17-.17-1.75-.27l-1.7-.32c-.18.45-.34.88-.5,1.3s-.31.84-.45,1.24a.87.87,0,0,1-1.05.68,8.77,8.77,0,0,1-1.44-.35,11.71,11.71,0,0,1-1.4-.55.78.78,0,0,1-.49-.87,1.24,1.24,0,0,1,0-.16c0-.07.05-.17.11-.33s.19-.54.33-.89S195.86,26.94,196,26.57Zm6-2.79,2,.29,2,.26c-.16-1-.35-2-.56-3s-.46-2-.73-2.89c-.5.94-1,1.85-1.4,2.74S202.47,22.91,202.06,23.78Z"
                fill="#fe9c1b"
              />
              <path
                d="M214.92,20.09c.1-.45.26-.73.47-.82a3.09,3.09,0,0,1,.9-.18,32.1,32.1,0,0,1,6.74.37,17.59,17.59,0,0,1,2.46.53,10,10,0,0,1,2.11.88A4.52,4.52,0,0,1,229,22.08a2,2,0,0,1,.38,1.56,3.31,3.31,0,0,1-.46,1.31A4.54,4.54,0,0,1,228,26a7.29,7.29,0,0,1-1.32.85,15.3,15.3,0,0,1-1.58.66,9,9,0,0,1,1.77.63,5.43,5.43,0,0,1,1.38.95,3.36,3.36,0,0,1,.95,3,4.44,4.44,0,0,1-.93,2.16,6.14,6.14,0,0,1-1.95,1.59,8.61,8.61,0,0,1-2.72.88,10.93,10.93,0,0,1-3.28,0c-.59-.09-1.24-.2-1.95-.35a14.54,14.54,0,0,1-1.94-.55,2.07,2.07,0,0,1-1-.69,2.77,2.77,0,0,1-.28-1.61q.06-1.25.12-2.34c0-.73.1-1.44.16-2.13s.14-1.37.22-2,.17-1.35.27-2l.22-1.53a2.81,2.81,0,0,1-.71,0c-.44-.06-.68-.36-.72-.88a4.94,4.94,0,0,1,0-.86,6.42,6.42,0,0,1,.09-.87l0-.35A2.83,2.83,0,0,1,214.92,20.09Zm5.62,3.13c-.07.52-.14,1-.21,1.54l-.18,1.52a10,10,0,0,0,3-.87,4.71,4.71,0,0,0,1.76-1.32,5.84,5.84,0,0,0-2.29-.7c-.31,0-.65-.08-1-.1Zm4.06,8a.75.75,0,0,0-.15-.6,1.89,1.89,0,0,0-.59-.46,4.11,4.11,0,0,0-.92-.34,9.31,9.31,0,0,0-1.1-.22,12.79,12.79,0,0,0-2-.14l-.25,2.89a6.59,6.59,0,0,0,.82.21c.27.06.53.1.76.14a4.63,4.63,0,0,0,2.39-.16A1.57,1.57,0,0,0,224.6,31.24Z"
                fill="#fee21c"
              />
              <path
                d="M230.39,28a10.33,10.33,0,0,1,.3-4,9.65,9.65,0,0,1,1.69-3.41,10.1,10.1,0,0,1,2.84-2.48A9.53,9.53,0,0,1,239,16.92a11.78,11.78,0,0,1,1.88-.07l.1-.45a.79.79,0,0,1,.72-.71,4.43,4.43,0,0,1,1.15.06,7,7,0,0,1,1.37.33.87.87,0,0,1,.6.78,1.52,1.52,0,0,1,0,.36c0,.51-.1,1.05-.17,1.64s-.17,1.17-.27,1.78-.21,1.19-.31,1.77-.21,1.11-.32,1.59a1.23,1.23,0,0,1-.25.62.86.86,0,0,1-.55.25l-.16,0h-.32l-.77-.06a5.68,5.68,0,0,1-.88-.17.91.91,0,0,1-.62-.39,1.06,1.06,0,0,1-.21-.51.81.81,0,0,1,0-.16c0-.05,0-.19,0-.42s.05-.6.1-1.05.1-.92.18-1.41a1.85,1.85,0,0,0-.34,0l-.39,0a4.67,4.67,0,0,0-1.74.59,5.53,5.53,0,0,0-1.51,1.27,5.62,5.62,0,0,0-1,1.8,5.08,5.08,0,0,0-.21,2.22,4.64,4.64,0,0,0,.45,1.55,3.64,3.64,0,0,0,.91,1.2,3.78,3.78,0,0,0,1.33.71,4.3,4.3,0,0,0,1.7.12,8.68,8.68,0,0,0,2.19-.58,13.62,13.62,0,0,0,2-1.05,1.18,1.18,0,0,1,.55-.23.74.74,0,0,1,.62.31,3.72,3.72,0,0,1,.74,1.06,3.67,3.67,0,0,1,.37,1.2,1.56,1.56,0,0,1,0,.61,1,1,0,0,1-.31.52,7.47,7.47,0,0,1-1.28,1,12.74,12.74,0,0,1-1.61.81,14.18,14.18,0,0,1-1.72.62,11.07,11.07,0,0,1-1.64.33,9.44,9.44,0,0,1-3.15-.16,7.93,7.93,0,0,1-2.75-1.21,7.06,7.06,0,0,1-2-2.2A7.86,7.86,0,0,1,230.39,28Z"
                fill="#ffb0d2"
              />
            </g>
            <path
              d="M87.45,141.05a.76.76,0,0,1,.57.25,1.3,1.3,0,0,1,.22.66c.1,1,.18,2,.25,2.89l.21,2.77c0,.49.07,1,.09,1.43l.07,1.43.07,1.46c0,.48,0,1,0,1.47a1.41,1.41,0,0,1-.1.72c-.08.16-.29.27-.64.33a10.64,10.64,0,0,1-1.65.2.94.94,0,0,1-.73-.2,1.15,1.15,0,0,1-.27-.64q-.21-1.59-.36-3.06c-.1-1-.17-2-.22-2.94S84.93,146,84.9,145s-.05-1.9,0-2.9a1.14,1.14,0,0,1,.15-.62,1,1,0,0,1,.5-.29,4.52,4.52,0,0,1,1.12-.19A5.63,5.63,0,0,1,87.45,141.05Z"
              fill="#fee01f"
            />
            <path
              d="M99.64,143.49a3.49,3.49,0,0,1-.33,1.42,15.38,15.38,0,0,1-1,1.92c-.41.7-.86,1.44-1.37,2.21s-1,1.51-1.54,2.23l3-.26.32,0,.4,0,.38,0,.26,0a.72.72,0,0,1,.52.11.71.71,0,0,1,.24.41,3.84,3.84,0,0,1,.12.82,7.36,7.36,0,0,1,0,1,.87.87,0,0,1-.22.53,1,1,0,0,1-.52.19c-.76.11-1.48.19-2.13.27s-1.36.13-2.09.17l-1.49,0c-.54,0-1.14,0-1.8,0a1.15,1.15,0,0,1-.55-.16.75.75,0,0,1-.33-.51l-.09-.53a5,5,0,0,1-.06-.56V152a2,2,0,0,1,.08-.57,2.49,2.49,0,0,1,.35-.57c.8-1.05,1.57-2.12,2.32-3.21a39.39,39.39,0,0,0,2.14-3.51,10.45,10.45,0,0,0-2.07-.51,18.83,18.83,0,0,0-2.22-.19c-.42,0-.63-.17-.64-.45v-.15a2.49,2.49,0,0,1,.07-.34c.05-.22.13-.48.22-.78s.21-.6.33-.92a.89.89,0,0,1,.29-.4,1.6,1.6,0,0,1,.69-.15h.83c.34,0,.72,0,1.13.09s.83.12,1.26.21a8.35,8.35,0,0,1,1.26.36,4.17,4.17,0,0,1,1.61,1A2.26,2.26,0,0,1,99.64,143.49Z"
              fill="#75ff50"
            />
            <path
              d="M111.21,148.54a3,3,0,0,1-.7,2,7.64,7.64,0,0,1-2,1.77q-.45.27-.93.51c-.32.17-.63.31-.94.44s-.6.25-.88.34-.52.18-.74.24l-.63.18a3.21,3.21,0,0,1-.43.08.89.89,0,0,1-.48-.1,1.28,1.28,0,0,1-.45-.43c-.21-.26-.38-.5-.53-.71a4.27,4.27,0,0,1-.42-.88,1,1,0,0,1-.09-.4q0-.48.66-.63c.42-.09.87-.2,1.34-.35s.94-.32,1.38-.5a12.28,12.28,0,0,0,1.26-.6,6.78,6.78,0,0,0,1-.66,2.28,2.28,0,0,0-1.24-.64,7.4,7.4,0,0,0-1.75-.1c-.1,0-.21,0-.31,0l-.49,0a1.2,1.2,0,0,1-.58-.1c-.16-.07-.28-.27-.36-.59a3.19,3.19,0,0,1-.09-.63,2.94,2.94,0,0,1,0-.42c0-.14,0-.28,0-.41a.9.9,0,0,1,.25-.58,1.94,1.94,0,0,1,.57-.25,7.4,7.4,0,0,0,1.88-.71,3.81,3.81,0,0,0,1.22-1.06,5.54,5.54,0,0,0-1.25-.23c-.43,0-.88,0-1.33,0a9.93,9.93,0,0,0-1.18.11c-.3,0-.53.07-.71.08a.53.53,0,0,1-.35-.09.48.48,0,0,1-.16-.37,1.87,1.87,0,0,1,0-.37,10,10,0,0,1,.31-1,4.41,4.41,0,0,1,.43-.87,1.72,1.72,0,0,1,.5-.57,2.21,2.21,0,0,1,.66-.18,3,3,0,0,1,.43,0l.43,0a12.67,12.67,0,0,1,2.15.07,7.07,7.07,0,0,1,1.81.43,3.53,3.53,0,0,1,1.27.82,1.79,1.79,0,0,1,.52,1.23,2.93,2.93,0,0,1-.11,1,3.53,3.53,0,0,1-.45.94,3.71,3.71,0,0,1-.77.82,3.5,3.5,0,0,1-1.09.61A6.09,6.09,0,0,1,110.3,147,2.29,2.29,0,0,1,111.21,148.54Z"
              fill="#6b0ae0"
            />
            <g>
              <g>
                <polygon
                  points="284.27 44.61 283.11 44.83 280.7 42.35 280.84 41.06 298.88 23.59 302.32 27.14 284.27 44.61"
                  fill="#fe9c1b"
                />
                <polygon
                  points="301.83 26.64 298.88 23.59 280.84 41.06 280.7 42.35 283.07 44.79 301.83 26.64"
                  fill="#fede25"
                />
                <polygon
                  points="299.54 24.27 298.88 23.59 280.84 41.06 280.7 42.35 280.78 42.43 299.54 24.27"
                  fill="#fef787"
                />
                <polygon
                  points="298.88 23.59 298.82 24.95 301.13 27.31 302.32 27.14 304.05 22 298.88 23.59"
                  fill="#fdf8ea"
                />
                <path
                  d="M302.11,22.6a1.56,1.56,0,0,0,.43.88,1.65,1.65,0,0,0,.86.46l.65-1.94Z"
                  fill="#141412"
                />
              </g>
              <ellipse
                cx="292.37"
                cy="34.77"
                rx="2.51"
                ry="16.51"
                transform="translate(89.31 247.98) rotate(-53.18)"
                fill="#7122ad"
              />
              <path
                d="M304.71,42.51c-1.38.57-7.64-2.87-14.53-8-5-3.76-9.05-7.45-10.82-9.75a.43.43,0,0,0-.2.14c-.83,1.11,4.41,6.44,11.71,11.91s13.89,9,14.72,7.88C305.85,44.32,305.51,43.56,304.71,42.51Z"
                fill="#5f1dad"
              />
              <path
                d="M279.16,24.88c-.63.84,2.25,4.13,6.87,8.05a13.5,13.5,0,0,0,2.72-3.78C283.71,25.85,279.79,24,279.16,24.88Z"
                fill="#d9d8d9"
              />
              <ellipse
                cx="284.75"
                cy="28.03"
                rx="0.67"
                ry="3.79"
                transform="matrix(0.56, -0.83, 0.83, 0.56, 101.69, 247.94)"
                fill="#fdf8ea"
              />
              <path
                d="M282.67,23.34A3.81,3.81,0,0,0,278,20.57a3.73,3.73,0,0,0-1.4.68c-.67,0-1.49-.52-2.28-2.26,0,0-.64,6.34,2.54,8.56l.05,0a3.78,3.78,0,0,0,2.95.46A3.82,3.82,0,0,0,282.67,23.34Z"
                fill="#733b21"
              />
              <path
                d="M282.61,23.15a3.81,3.81,0,0,1-5.71,2.24l0,0c-1.81-1.27-2.39-3.86-2.55-5.86-.07,1.61,0,6.17,2.58,8l.05,0a3.78,3.78,0,0,0,2.95.46,3.82,3.82,0,0,0,2.78-4.64C282.66,23.28,282.63,23.22,282.61,23.15Z"
                fill="#5c3621"
              />
            </g>
            <path
              d="M153.29,160.61s2.66-1,2.87-2.34-1.06-3.61-1.06-3.61-.21-5.62-.32-7.11-3.4-2-3.82-2.55.21-2.65.21-2.65,1.49-1.28,2.76-1.07,2,.85,2.76-.63a3.64,3.64,0,0,1,2.34-1.81s.53,1,1.06-.32a15.72,15.72,0,0,0,.68-2.18,16.5,16.5,0,0,0-6.79-1.52c-3,.12-6.09,2-6.65,4.89a7.05,7.05,0,0,0-8.16,10c-4.77,1.81-6.4,8.93-2.87,12.62a4.15,4.15,0,0,0-3.34.52,14.67,14.67,0,0,1,1,1.61c1.27,2.34,1.8,2.23,3.61,3.61s1.49,2.23,5.52,2.23,6.37.75,7.33-.85a9.65,9.65,0,0,0,.95-4.14,13.26,13.26,0,0,1,2.45-1.59C155,163.16,153.29,160.61,153.29,160.61Z"
              fill="#6c9b23"
            />
            <path
              d="M280.18,328.87l1.28-3.75c-.14.95,1.19,1.54,2.05,1.11a4,4,0,0,0,1.65-2.27c2.12-5.18,4.25-11,2.08-16.21a24.47,24.47,0,0,1,.61,17.05c1.83-1.54,2-4.41,3.7-6.09,1.87-1.84,4.87-1.64,7.47-1.33a13.34,13.34,0,0,0-5.46,7.76l4.68-.49c-1.68.18-6.45,6.25-8,7.53-2.46,2-6.06,5.83-9.11,6.8-7.14,2.28-3.58-10.08-2.91-13.7C279,326.43,279.55,327.67,280.18,328.87Z"
              fill="#68c902"
            />
            <path
              d="M184.4,61.31c.54-7.38,1.95-14.4,8.93-16.44,5.55-1.63,11.42,1.93,10.55,7.57-.54,3.52-4.46,6.23-4.46,6.23s3.22-9.13-1.62-9.2c-9.07-.14-2.07,11.84-2.07,11.84S188.6,64.76,184.4,61.31Z"
              fill="#4842d5"
            />
            <g>
              <path
                d="M170.47,174.49l-2.85-.81a2.6,2.6,0,0,1-1.88-2.71l3.11-38.6a2.61,2.61,0,0,1,.73-1.61l1.16-1.19a2.6,2.6,0,0,1,4.13.54l1.62,2.89a2.62,2.62,0,0,1,.32,1.48l-3,37.72A2.61,2.61,0,0,1,170.47,174.49Z"
                fill="#ffbe3a"
              />
              <path
                d="M176.18,142.36l.63-7.88a2.62,2.62,0,0,0-.32-1.48l-1.62-2.89a2.6,2.6,0,0,0-4.13-.54l-1.16,1.19a2.61,2.61,0,0,0-.73,1.61l-2.16,26.82Z"
                fill="#fff"
                opacity="0.26"
              />
              <path
                d="M170.47,174.49l-2.85-.81a2.6,2.6,0,0,1-1.88-2.71l3.11-38.6a2.61,2.61,0,0,1,.73-1.61l1.16-1.19a2.6,2.6,0,0,1,4.13.54l1.62,2.89a2.62,2.62,0,0,1,.32,1.48l-3,37.72A2.61,2.61,0,0,1,170.47,174.49Z"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
              />
            </g>
            <g>
              <path
                d="M192.83,194.69l2.91-.59a2.6,2.6,0,0,0,2.09-2.55l-.06-38.73a2.59,2.59,0,0,0-.61-1.66l-1.06-1.28a2.61,2.61,0,0,0-4.16.22l-1.84,2.75a2.58,2.58,0,0,0-.44,1.45l.06,37.84A2.6,2.6,0,0,0,192.83,194.69Z"
                fill="#ffbe3a"
              />
              <path
                d="M189.67,162.2v-7.9a2.58,2.58,0,0,1,.44-1.45l1.84-2.75a2.61,2.61,0,0,1,4.16-.22l1.06,1.28a2.59,2.59,0,0,1,.61,1.66l0,26.91Z"
                fill="#fff"
                opacity="0.26"
              />
              <path
                d="M192.83,194.69l2.91-.59a2.6,2.6,0,0,0,2.09-2.55l-.06-38.73a2.59,2.59,0,0,0-.61-1.66l-1.06-1.28a2.61,2.61,0,0,0-4.16.22l-1.84,2.75a2.58,2.58,0,0,0-.44,1.45l.06,37.84A2.6,2.6,0,0,0,192.83,194.69Z"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
              />
            </g>
            <g>
              <path
                d="M165.87,227.26l-2.85-.81a2.61,2.61,0,0,1-1.88-2.71l3.11-38.61a2.61,2.61,0,0,1,.73-1.61l1.16-1.19a2.6,2.6,0,0,1,4.13.55l1.62,2.88a2.64,2.64,0,0,1,.32,1.48l-3,37.72A2.61,2.61,0,0,1,165.87,227.26Z"
                fill="#ffbe3a"
              />
              <path
                d="M171.58,195.12l.63-7.88a2.64,2.64,0,0,0-.32-1.48l-1.62-2.88a2.6,2.6,0,0,0-4.13-.55L165,183.52a2.61,2.61,0,0,0-.73,1.61L162.09,212Z"
                fill="#fff"
                opacity="0.26"
              />
              <path
                d="M165.87,227.26l-2.85-.81a2.61,2.61,0,0,1-1.88-2.71l3.11-38.61a2.61,2.61,0,0,1,.73-1.61l1.16-1.19a2.6,2.6,0,0,1,4.13.55l1.62,2.88a2.64,2.64,0,0,1,.32,1.48l-3,37.72A2.61,2.61,0,0,1,165.87,227.26Z"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
              />
            </g>
            <path
              d="M190.29,63.74a27.28,27.28,0,0,1,0-8.86A5.48,5.48,0,0,1,195,50s-1.55-.27-1.49,3,2.3,8.86,2.3,8.86Z"
              fill="#392ec6"
            />
            <path
              d="M222.86,108c.4-5.44,1.44-10.62,6.59-12.13,4.09-1.2,8.43,1.43,7.79,5.59-.4,2.59-3.3,4.59-3.3,4.59s2.38-6.73-1.19-6.79c-6.69-.1-1.53,8.74-1.53,8.74S226,110.53,222.86,108Z"
              fill="#4842d5"
            />
            <path
              d="M228,109.9a13.44,13.44,0,0,1-.75-6.65,4,4,0,0,1,3.49-3.6s-.94.5-.89,2.9a16.69,16.69,0,0,0,1.54,5.5Z"
              fill="#392ec6"
            />
            <path
              d="M262.7,68.75c.45-6.16,1.34-12.53,7.17-14.24,4.62-1.35,9.53,1.62,8.8,6.33C278.22,63.77,275,66,275,66s2.69-7.62-1.36-7.68c-7.56-.11-2.37,10.3-2.37,10.3S266.2,71.62,262.7,68.75Z"
              fill="#4842d5"
            />
            <path
              d="M267.33,70.26a22.88,22.88,0,0,1,0-7.39,4.57,4.57,0,0,1,3.95-4.07s-1.3-.22-1.24,2.49a46.15,46.15,0,0,0,1.42,7.86Z"
              fill="#392ec6"
            />
            <path
              d="M214.33,259.18c-1.47,0-14-5.11-14.48-6.7s1.24-28.89,7.86-28.55,25.48,9.9,26.83,12.95S218.47,259.23,214.33,259.18Z"
              fill="#fff"
            />
            <path
              d="M204.14,226.92c-2,8-2,19.31-1.69,20.29.43,1.59,13,6.69,14.47,6.7,3,0,12.62-10.78,17.3-17.51a2.21,2.21,0,0,1,.32.48c1.34,3.05-16.07,22.35-20.21,22.3-1.47,0-14-5.11-14.48-6.7C199.51,251.23,200.47,234,204.14,226.92Z"
              fill="#dce6ff"
            />
            <path
              d="M278.32,143.24a13.19,13.19,0,0,0-2.2-7h0c-2-2.76-4.8-2.69-6.57.17h0a14.65,14.65,0,0,0-1.75,4.64l-.4,5.62.74,14.92a.09.09,0,0,0,0,0l10.24-16.9Z"
              fill="#fff"
              opacity="0.26"
            />
            <path
              d="M272.6,168.41l4.08-.54c1.59-.21,2.72-2.6,2.58-5.45l-.94-19.18a13.19,13.19,0,0,0-2.2-7h0c-2-2.76-4.8-2.69-6.57.17h0a18,18,0,0,0-2.15,10.08l.74,15.1C268.34,165.59,270.38,168.7,272.6,168.41Z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="M186.57,97.23l7.84,13s-8.25,5.14-9.2,4.47C185.89,110.89,186.57,97.23,186.57,97.23Z"
              fill="#392ec6"
            />
            <path
              d="M180.87,115.52,175.5,115a4,4,0,0,1-3.56-4.12l.64-14.13a6.76,6.76,0,0,1,2.66-5.07h0a6.75,6.75,0,0,1,8.62.36h0A9.54,9.54,0,0,1,187,99.54l-.5,11.12A5.11,5.11,0,0,1,180.87,115.52Z"
              fill="#ffbe3a"
            />
            <path
              d="M172.06,108.39l14.83-10.72a9.54,9.54,0,0,0-3-5.65h0a6.76,6.76,0,0,0-11.28,4.71Z"
              fill="#fff"
              opacity="0.26"
            />
            <path
              d="M180.87,115.52,175.5,115a4,4,0,0,1-3.56-4.12l.64-14.13a6.76,6.76,0,0,1,2.66-5.07h0a6.75,6.75,0,0,1,8.62.36h0A9.54,9.54,0,0,1,187,99.54l-.5,11.12A5.11,5.11,0,0,1,180.87,115.52Z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="M234.92,155.52a6.75,6.75,0,0,0-8.62-.15,9.52,9.52,0,0,0-3.56,7L237.1,173.2l.18-12.46A6.75,6.75,0,0,0,234.92,155.52Z"
              fill="#fff"
              opacity="0.26"
            />
            <path
              d="M227.75,179l5.4-.22a4,4,0,0,0,3.79-3.9l.2-14.15a6.74,6.74,0,0,0-2.35-5.22h0a6.75,6.75,0,0,0-8.62-.15h0a9.55,9.55,0,0,0-3.59,7.32l-.16,11.13A5.12,5.12,0,0,0,227.75,179Z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="M252.48,179.1c-.92-2-2.26-4.39-4.5-4.51a13.61,13.61,0,0,1-1.69,0c-1.42-.25-2.17-1.77-2.89-3a15.55,15.55,0,0,0-2.48-3.28,4.51,4.51,0,0,0-2-1.34,1.94,1.94,0,0,0-2.15.7,5.51,5.51,0,0,0-10.45,2,3.47,3.47,0,0,0-3.21.11,25,25,0,0,0-6.28.47,2.78,2.78,0,0,0-1.59.66,2.66,2.66,0,0,0-.59,1.47,11.36,11.36,0,0,0,.32,4.75c-1.45-.36-3.32-.57-4.14.69a3.23,3.23,0,0,0-.4,1.14,12.7,12.7,0,0,0,0,5,5.19,5.19,0,0,1-2.31.4c-2.11.24-3.61,2.42-3.69,4.55a9.68,9.68,0,0,0,2.22,5.86,4.52,4.52,0,0,0,2.11,1.79,1.79,1.79,0,0,0,2.28-1.06,2.37,2.37,0,0,0,2.57,2.49,6.56,6.56,0,0,0,2.92,5.42,6.33,6.33,0,0,0,6,.57,5.79,5.79,0,0,0,8.43,2.31,5,5,0,0,0,5.36,2.28,7.78,7.78,0,0,0,4.11-3.11c.26-.35.55-.77,1-.8.81-.08,1.19,1.15,2,1.24a1.53,1.53,0,0,0,1-.37,11.59,11.59,0,0,0,4.78-8.49,12.26,12.26,0,0,0,4.65,2.32,4.45,4.45,0,0,0,4.72-1.83c0,.73.91,1.13,1.64,1.06a14.69,14.69,0,0,1,2.17-.37,5.33,5.33,0,0,0,1.13.08c1.38-.23,1.24-2.32,2.14-3.4a4,4,0,0,0,2.52-2.77,8.31,8.31,0,0,0-.67-6,25,25,0,0,0-3.54-5c-1.41-1.68-3-3.47-5.15-3.86-.18,1.06-1.69,1-2.76,1A5.74,5.74,0,0,0,252.48,179.1Z"
              fill="#527e23"
            />
            <path
              d="M240.45,167.81a3.85,3.85,0,0,0-1.51-.88,1.94,1.94,0,0,0-2.15.7,5.51,5.51,0,0,0-10.45,2,3.47,3.47,0,0,0-3.21.11,25,25,0,0,0-6.28.47,2.78,2.78,0,0,0-1.59.66,2.66,2.66,0,0,0-.59,1.47,11.36,11.36,0,0,0,.32,4.75c-1.45-.36-3.32-.57-4.14.69a3.23,3.23,0,0,0-.4,1.14,12.7,12.7,0,0,0,0,5,5.19,5.19,0,0,1-2.31.4,3.84,3.84,0,0,0-2.45,1.38,6.23,6.23,0,0,0,2.42,2.86c3,1.43,4.62,2.54,4.94,3.5s4.3,3.19,5.25,3.19a2.65,2.65,0,0,0,2.07-1.12,3,3,0,0,1,2.87-.32c.64.48,1,2.07,1.91.48s2.07-2.5,2-2.92,1.2-.58,1.67-.11a2.6,2.6,0,0,0,1.76.8c1,.16,1.43-.32,1.91-1.11s2.39-3,2.39-3a10.67,10.67,0,0,0,2.23,1.91c1.11.64,4.46,0,4.93-.16s1.6-.48,2.07,0-.79.48,1.44.8,4,0,3.82-.8-.16-2.87-1.75-3.18-1.91-.48-2.71-.32-3.34-.48-3.66-1,1.75-2.71,1.75-2.71,1.27.48,1-.63-.32-1.6-.8-1.91-1.12-.64-1.75-1.12-2.07-1.59-1.75-2.39a2.91,2.91,0,0,1,1.43-1.75,3.17,3.17,0,0,0,.8-3.19c-.27-.53-.35-2.26-.74-3a3.2,3.2,0,0,0-.25-.27A1.74,1.74,0,0,1,240.45,167.81Z"
              fill="#6c9b23"
            />
            <path
              d="M159.24,225.35c1.21-.28,10.55-.68,10.55-.68s-1.49-2.71-2.84-5A9.51,9.51,0,0,0,163,216c-.41-.14-.95-1.89-.95-1.89l-2.3-1.22-2.84,4.73Z"
              fill="#527e23"
            />
            <path
              d="M166.94,225.45c1.06-1.37,9.9-7.45,22-6.17s19.5,4.23,18.95,8.09-7.23,22.49-10.66,23.44-22.65,1.68-24.22.8S164.85,228.14,166.94,225.45Z"
              fill="#fff"
            />
            <path
              d="M203,222.31c1.62,3.35.27,16.34-7.31,21.5-7.34,5-21.32,2.14-25.59.78,1.18,3.79,2.33,6.71,2.88,7,1.57.88,20.8.16,24.22-.8s10.12-19.59,10.66-23.44C208.16,225.41,206.39,223.69,203,222.31Z"
              fill="#dce6ff"
            />
            <path
              d="M159.08,258.34c1.41,0,13.5-5.14,13.92-6.73s-1.19-29-7.55-28.69-24.51,10-25.79,13S155.1,258.39,159.08,258.34Z"
              fill="#fff"
            />
            <path
              d="M168.87,225.92c1.94,8.08,1.89,19.41,1.63,20.39-.42,1.6-12.51,6.72-13.91,6.74-2.92,0-12.14-10.84-16.63-17.6a2,2,0,0,0-.3.48c-1.29,3.06,15.44,22.46,19.42,22.41,1.41,0,13.5-5.14,13.92-6.73C173.33,250.35,172.4,233,168.87,225.92Z"
              fill="#dce6ff"
            />
            <path
              d="M225.73,59.2s10.4-1.59,18.89,2.87,20,10.47,32.49,7.25c-3.4,12.71-11.48,10-11.48,10s3.35,7.43,13.81-2.11c-6.58,20.87-23.6,18.4-31.25,14.63s-14.8-3.65-22.46-4.3C225,74.18,225.73,59.2,225.73,59.2Z"
              fill="#8914e6"
            />
            <path
              d="M279.44,77.23c-10.46,9.54-13.81,2.11-13.81,2.11s8.08,2.69,11.48-10c-12.22,3.14-23.43-2.5-31.85-6.91a39.69,39.69,0,0,1,4.07,16.93c.2,5.88.88,10.6,2.53,14C260.36,95.86,273.77,95.21,279.44,77.23Z"
              fill="#670ed8"
            />
            <circle cx="248.65" cy="76.92" r="2.83" fill="#fb2a0d" />
            <ellipse
              cx="248.19"
              cy="76.66"
              rx="5.03"
              ry="12.79"
              transform="translate(-2.49 144.74) rotate(-32.36)"
              fill="none"
              stroke="#87e0ff"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <ellipse
              cx="248.19"
              cy="76.66"
              rx="12.79"
              ry="5.03"
              transform="translate(-9.97 105.47) rotate(-23.53)"
              fill="none"
              stroke="#87e0ff"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <circle cx="241.89" cy="65.62" r="1.46" fill="#24fefc" />
            <circle cx="259.15" cy="75.2" r="1.46" fill="#93fe25" />
          </g>
          <path
            d="M407.83,252.34l-14.7,18.36c-2.52,3.13-5.24,6.48-8.33,9.93-1.54,1.72-3.17,3.46-4.93,5.2-.86.87-1.78,1.7-2.68,2.54s-1.81,1.68-2.74,2.46a118.16,118.16,0,0,1-11.38,8.71c-3.86,2.61-7.77,5-11.66,7.16-7.78,4.34-15.47,7.92-22.87,11.22-2.46.39-4.9.73-7.36,1l2.74-2.31c-.37-.35-.65-.41-.69-.05a27.08,27.08,0,0,1-2.15-4.42,24.51,24.51,0,0,0-1.14-3.35,2.79,2.79,0,0,1,1.12,1.48,12.28,12.28,0,0,1-.78-2.89,7.08,7.08,0,0,0-1-2.93c.21-.26,2.17,2.45,3.81,6.88a3.26,3.26,0,0,1-.14-1.6l.08.16c-.73-2.82-1.17-4.77-1.72-5.66a9.17,9.17,0,0,1,2.81,4.14,22.52,22.52,0,0,1-1.42-6.56,14.14,14.14,0,0,0-1.92-6.81c.48-.22,3.16,3.65,5.93,9.8a2.4,2.4,0,0,1,.19-1,4.88,4.88,0,0,0-.54-3.93c.4.2,1.66,2.36,2.9,5.39,0-.83.13-1.49.09-2.4-.17-3.68-.7-4.85-2.08-8.09-.33-.78-.1-1.13.26-.69a22.72,22.72,0,0,1,1.57,2.25c.54.12,1.66,1.35,2.35,2.93a24.62,24.62,0,0,1-1.77-5.84,14.51,14.51,0,0,0-2.15-5.88c.37-.55,4.54,4.83,8.25,13.72a6.68,6.68,0,0,1-.39-3.25l.16.31c-1.7-5.67-2.81-9.59-4-11.35,1.47.7,4.47,4.28,6.12,8.12-2.32-5.83-3.54-10.4-3.75-13.14a30.18,30.18,0,0,0-5.07-13.45c.42-.21,2.07,1.55,4.51,4.85a144.71,144.71,0,0,1,9,14.11,4.87,4.87,0,0,1,.16-2.12c.45-1.1.3-4.33-2-7.79.82.34,3.87,4.42,7.09,10.25a42.27,42.27,0,0,0-.43-4.86c-1.43-7.34-2.95-9.49-6.74-15.59-.91-1.45-.66-2.17.16-1.37a65.22,65.22,0,0,1,12.21,16.65,61.74,61.74,0,0,1,3.92,9.05l.74-.56V291c-.16-1.2-.11-2.12-.36-3.36-1-4.66-2-6-4.49-9.74-.6-.89-.4-1.38.15-.91a35.84,35.84,0,0,1,8.07,10.16l.51.95c.83-.63,1.66-1.31,2.51-2-.18-.25-.35-.49-.5-.73a27.85,27.85,0,0,0-2.54-3.91,3.54,3.54,0,0,1,2,1.48,15.83,15.83,0,0,1-2-3.43,8.84,8.84,0,0,0-2.23-3.38c.16-.4,3.64,2.3,7.33,7.32a4.33,4.33,0,0,1-.72-2l.15.17c-1.92-3.32-3.23-5.6-4.27-6.52,1.06.2,3.55,1.94,5.2,4.09a33.07,33.07,0,0,1-4.45-7.68,18.64,18.64,0,0,0-5.4-7.57c.45-.39,5.44,3.21,11.74,9.48A3.18,3.18,0,0,1,368,272c.12-.77-.5-2.8-2.56-4.55.59.06,3.19,2.07,6.2,5.16-.38-1-.55-1.91-1.06-3-2.08-4.4-3.36-5.52-6.72-8.72-.8-.76-.73-1.29-.07-.94a38.55,38.55,0,0,1,10.33,8.47,43.75,43.75,0,0,1,3.8,4.88l.43-.43c-.28-.7-.4-1.26-.75-2a14.52,14.52,0,0,0-4.3-5.43c-.52-.47-.46-.82,0-.61a22.84,22.84,0,0,1,6.58,5.21l.61.68c2.78-2.82,5.32-5.36,7.79-7.63s4.92-4.4,7.38-6.4c4.91-4,9.86-7.55,15.06-11.13C409.71,247.87,408.79,250.11,407.83,252.34Zm-74,55.5-.63-1.19a21.79,21.79,0,0,1,.4,2.23l.33-.25A5.69,5.69,0,0,1,333.81,307.84Z"
            fill="#68c902"
          />
          <path
            d="M248.81,378.51l-16.64-3.46a42,42,0,0,0-5.47-.86,10.59,10.59,0,0,0-1.49,0,19.05,19.05,0,0,0-1.93.23,50.94,50.94,0,0,0-5.76,1.41l-8.13,2.48c-1.54.46-3.26.94-5,1.36s-3.41.82-5.11,1.18c-3.39.71-6.75,1.25-10.05,1.69-6.62.87-13,1.27-19.18,1.49s-12,.24-17.86.25q-17.62,0-35.22-.77-5.19-1.2-10.4-2.57l5.14-.73c-.26-.49-.6-.67-.89-.38a18.66,18.66,0,0,1,0-4.91,16.7,16.7,0,0,0,.63-3.5,2.13,2.13,0,0,1,.54,1.84,8.69,8.69,0,0,1,.82-2.93,5,5,0,0,0,.6-3c.44-.14,1.28,3.18.63,7.87a2.8,2.8,0,0,1,.83-1.48v.18c.84-2.84,1.5-4.77,1.35-5.81.71.67,1.35,2.93,1,5a16.74,16.74,0,0,1,2.31-6.48,10.33,10.33,0,0,0,1.8-6.92c.77,0,1.82,4.7,1.53,11.44a2.86,2.86,0,0,1,.9-.84,4,4,0,0,0,1.78-3.73c.41.36.66,2.86.35,6.12.55-.73,1.12-1.26,1.64-2.08,2.12-3.36,2.19-4.64,2.47-8.15.06-.84.59-1.05.78-.49a15,15,0,0,1,.59,2.72c.62.36,1.28,2,1.16,3.69a17.79,17.79,0,0,1,1.48-6c.66-1.26,1.6-4.24,1-6.22.88-.3,2.76,6.41,1.72,16a5.56,5.56,0,0,1,1.6-3.06v.35c1.53-5.82,2.73-9.79,2.35-11.91,1.47,1.31,2.92,5.88,2.44,10,.94-6.24,2.5-10.85,4.18-13.35s4.22-8.94,3.07-14.23c1.53,0,4,9.42,4,23.16a5.42,5.42,0,0,1,1.74-1.77c1.35-.73,3.6-3.59,3.24-7.76.84.7,1.58,5.76,1.24,12.42a47.73,47.73,0,0,0,3.11-4.4c3.9-7,3.84-9.66,4-16.84,0-1.72,1-2.2,1.43-1.09,2.06,5.53,2.86,12.49,1.73,20.59a51.69,51.69,0,0,1-2.26,9.77l1.28-.09.05-.09c.71-1.11,1.47-1.87,2.12-3.07,2.44-4.49,2.37-6.14,2.34-10.65,0-1.08.64-1.4.93-.71a25.09,25.09,0,0,1,1.44,12.9l-.16,1.08,4.46-.41a8.77,8.77,0,0,1,0-.89c.16-2.39.44-4.06.2-4.68a2.83,2.83,0,0,1,1.08,2.29,11.24,11.24,0,0,1,.51-4,6.4,6.4,0,0,0,.17-4.07c.54-.27,2.36,3.86,2.51,10.1a3.67,3.67,0,0,1,.81-2.11l0,.23c.5-3.88.9-6.54.45-7.86,1.08.71,2.5,3.47,2.61,6.18,0-4.09.53-7.18,1.33-9a13.62,13.62,0,0,0,.24-9.4c.88-.17,3.57,5.5,5.44,14.19a3.63,3.63,0,0,1,.91-1.38,5.16,5.16,0,0,0,1-5.37c.63.32,1.9,3.38,2.7,7.62a26.67,26.67,0,0,0,1.36-3.27c1.36-5.07.85-6.7-.26-11.21-.27-1.08.29-1.55.74-.93a26.24,26.24,0,0,1,4.52,12.58,33.77,33.77,0,0,1,.22,6.28l.82-.21c.26-.78.57-1.36.77-2.19.76-3.19.46-4.21-.26-7-.17-.67.19-1,.48-.59a16.67,16.67,0,0,1,2.82,7.91l.1.91c5-1.25,9.13-1.84,12.18-1.51.38,0,.76.08,1.1.15s.69.12,1,.2c.69.17,1.44.38,2.24.63,1.6.49,3.42,1.17,5.47,1.93,8.52,3.14,16.58,6.5,24.82,10.07C255.72,378.6,252.27,378.57,248.81,378.51ZM130.09,377c0-.44,0-.89,0-1.34a18.86,18.86,0,0,1-.89,2.16l.57-.07A4.33,4.33,0,0,1,130.09,377Z"
            fill="#68c902"
          />
          <path
            d="M72.61,337.49l-4.71-3.91-2.07-1.72,0,0h0l.22-.26,2.18-2.79,1.48-1.92,1.2-1.6.94-1.3.7-1,.61-.89.5-.77a17,17,0,0,0,1.8-3.45,3.44,3.44,0,0,0,.12-.41l0-.14v-.08h0c0-.14-.23,1.23-.12.65h0v0a1.42,1.42,0,0,0,0-.47h0a2,2,0,0,0,.12.49,4.65,4.65,0,0,0,.4,1,8.25,8.25,0,0,0,.81,1.44,14.07,14.07,0,0,0,1.38,2,28.65,28.65,0,0,0,2.3,2.85l1.84,2.11c.67.75,1.35,1.48,2,2.19l.52.53.27.26.47.51.44.46h0v0l0,0-.59.62-1.2,1.27-.83.86-1.06,1c-.67.19-1.48.46-2.21.65s-1.37.22-2.06.31l.69-1.84c-.4-.28-.58-.35-.45-.05-.26-.27-2.12-2.3-3.2-3.73s-1.82-2.44-2.15-2.79a6.83,6.83,0,0,1,1.29,1.27c-.82-1-1.43-1.85-1.77-2.38a16.73,16.73,0,0,0-1.91-2.4A43.79,43.79,0,0,1,76,329.76a6.86,6.86,0,0,1-.83-1.3l.12.13A56.49,56.49,0,0,0,71.59,324a24.9,24.9,0,0,1,3.6,3.38c-2-2.31-3.46-4.08-4.19-5.09a42.93,42.93,0,0,0-4.69-5.19,3.3,3.3,0,0,1,.66.51c.41.36,1,.88,1.73,1.56,1.47,1.36,3.54,3.31,5.94,5.67a4.41,4.41,0,0,1-.48-.74,12.89,12.89,0,0,0-2.49-2.89c.31.19,2.16,1.86,4.49,4.15-.46-.6-.77-1.07-1.32-1.71a61.27,61.27,0,0,0-5.7-5.95c-.61-.58-.7-.8-.28-.45q1,.81,2.07,1.77a19.09,19.09,0,0,1,2.82,2.33c-1.92-1.85-3.4-3.35-4.25-4.29a54.61,54.61,0,0,0-4.44-4.39c-.12-.34,5,4,11.88,10.66a25,25,0,0,1-2.09-2.29l.26.24c-4.09-4.18-6.8-7.12-8.37-8.54a58.42,58.42,0,0,1,7.48,6.69,91.14,91.14,0,0,1-8.83-10.09c-.7-1.06-2-2.9-3.57-5a48.61,48.61,0,0,0-5.32-6.19c.12-.11.65.21,1.5.92a38,38,0,0,1,3.53,3.23c2.88,2.91,6.62,7.32,10.9,12.7a8.41,8.41,0,0,1-.84-1.59,22.15,22.15,0,0,0-1.1-2.37,38.65,38.65,0,0,0-2.64-4.45c.68.41,3.48,4.63,7,10.31A32.06,32.06,0,0,1,73,313a71,71,0,0,1-2.39-8c-.62-2.35-1.39-4.68-2.49-8.1-.52-1.63.12-2.35.81-1.37a28.43,28.43,0,0,1,3.59,8.79c.86,3.34,1.5,7.05,2.45,11l.35,1.36.31,1.14,0,.06.09.29-.09-.28h0a1.14,1.14,0,0,1-.07-.22.67.67,0,0,1,0-.17l-.13-.89c-.19-1.5-.36-3-.6-5.27-.12-1.07,0-1.37.18-.67a43.79,43.79,0,0,1,.5,5.89l0,.89h0a1,1,0,0,1,0,.25h0s0,.09,0,.07v.14s0,.06,0,0l.06-.33c.13-.81.6-2.69.82-4a13.18,13.18,0,0,1-.52,2.7l-.31,1.26s0,0,0,0l0,.16h0l0,.13s-.13.39.19-.54c.43-1.21.76-2.14,1-2.78a18.86,18.86,0,0,1-.8,2.41l-.62,1.51h0l0,.06,0,0,.25-.57c.36-.8.7-1.53,1-2.18a24,24,0,0,1,1.7-3l2.23-3.26a34.45,34.45,0,0,0,2.71-4.54c.19.11-.37,1.56-1.64,3.87s-3.25,5.49-5.69,9.21a7.29,7.29,0,0,1,.73-.89,37.09,37.09,0,0,0,3.15-3.89c-.17.44-2.09,3.1-4.69,6.53.64-.74,1.15-1.27,1.9-2.09,3.09-3.29,4.22-4.54,7.17-8.13.71-.85,1-1,.59-.38a131.1,131.1,0,0,1-8.4,10.37l-4,4.55.06.1c.46-.48.81-.8,1.33-1.32a63.2,63.2,0,0,0,4.58-5c.45-.53.63-.63.36-.26-1.34,1.85-3.14,4.05-5.31,6.5l-.6.67c2.18,3.39,2.6,7.52,2.68,12.34C74.39,337.24,73.49,337.38,72.61,337.49Zm7.24-9.81-1-.91c.56.61,1.06,1.15,1.48,1.62v-.14Z"
            fill="#68c902"
          />
          <path
            d="M10.49,305.84l-2.14-5.21-.53-1.3-.08-.2,6.17-2.61,2.09-.9,1.77-.79,2.22-1,1.46-.7c.85-.42,1.33-.67,1.8-.94a10.52,10.52,0,0,0,1.56-1L25,291l.17-.18a.36.36,0,0,0,.08-.09c.05-.07-.05.07-.08.39a2.89,2.89,0,0,0,.1,1.16,2.52,2.52,0,0,0,.27.65c0,.07-.06-.09-.25-.26a4,4,0,0,0-.37-.26l-.2-.12-.11,0h0l2,.84,0,0a5.8,5.8,0,0,0,1.08.26,16.65,16.65,0,0,0,2.65.15l1,0c.38,0,.75,0,1.12-.08s.92-.07,1.38-.13l1.6-.2,1.89-.28c.77-.12,1.53-.25,2.29-.4l1.49-.27,1.58-.3s0,0,0,0a4.51,4.51,0,0,0-1.78,1.3,10.51,10.51,0,0,0-1.12-.31c-.45.14-.6.21-.29.16-.36.1-3,.8-4.77,1.2s-3,.65-3.43.78a13.64,13.64,0,0,1,1.73-.5c-1.27.29-2.28.5-2.9.61s-2.06.39-3,.65a76.77,76.77,0,0,1,7.6-1.9,13.65,13.65,0,0,1-1.49.26l.17,0c-2.82.57-4.75.93-5.76,1.18A44.6,44.6,0,0,1,32.41,294c-3,.61-5.25,1-6.47,1.13s-4.38.54-6.92,1.1a17.4,17.4,0,0,1,3.07-.77c2-.41,4.76-.92,8.08-1.49-.41,0-.71.08-.86.08a37.69,37.69,0,0,0-3.78.42c.34-.1,2.8-.46,6-.9l-2.13.19c-3.4.28-4.69.33-8.19.65-.84.07-1.07,0-.52-.08.83-.12,1.73-.22,2.69-.3a25.38,25.38,0,0,1,3.64-.35c-2.66.13-4.77.17-6,.11a60.19,60.19,0,0,0-6.24,0c-.17-.11,1.41-.33,4.25-.39,1.41,0,3.14,0,5.11,0l5.4.12-1,0-.9-.06.35,0c-5.84-.3-9.78-1-11.9-1.13a16.82,16.82,0,0,1,4,0c1.82.15,4,.48,6,.8-6.19-.93-10.67-2.17-12.95-3.41C12,289.08,10,288,7.64,286.85A27.89,27.89,0,0,0,0,284c.21-.59,2.71-.51,6.66.6,4,.95,9.34,3.32,15.46,6.43a6.26,6.26,0,0,1-1.42-1.09c-.24-.3-.89-.93-1.84-1.88A34.54,34.54,0,0,0,15,284.61a12.79,12.79,0,0,1,3.36,2.19c1.72,1.35,3.93,3.28,6.46,5.44A20.49,20.49,0,0,1,21.86,289a67.8,67.8,0,0,1-4.42-7.09c-1.21-2.11-2.55-4.16-4.49-7.18-.94-1.43-.45-2.3.41-1.51A31.23,31.23,0,0,1,19,280.83c1.71,3,3.32,6.4,5.27,9.92l1.26,2.18h0l-.05-.08,0-.09,0,0-.37-.83c-.59-1.4-1.17-2.82-2-4.92-.41-1-.34-1.33,0-.69a46.39,46.39,0,0,1,2.1,5.53l.21.63,0,.05v0a2.38,2.38,0,0,1-.15-.53h0s0-.11,0-.08l0-.12v-.12l0-.71c0-.74-.05-1.55-.11-2.18,0-.05.06.18.09.65l0,.88v1h0a.61.61,0,0,1,0-.15l.21-1.53c0,.32-.28,1.86-.19,1.38,0,0,0,0,0,0l0-.11a15.17,15.17,0,0,1,1.28-3.16c.41-.72,1.19-1.95,2.17-3.32a21,21,0,0,0,2.7-4.54c.35.2,0,1.79-1.29,4.09a38.16,38.16,0,0,1-2.62,4c-.54.73-1.13,1.5-1.75,2.3l-.49.62,0,0h0l-.09.09,0,0,0,0,.43-.4c.64-.57,1.54-1.27,2.55-2.16a14.4,14.4,0,0,1-1.92,1.73l-1.44,1.17,0,0a6.43,6.43,0,0,1-.6.43l.62-.39.65-.38c.42-.24.82-.45,1.21-.65l2.17-1.08c1.41-.69,2.82-1.41,4.88-2.47,1-.5,1.38-.39.76,0-3.06,2-7.24,3.76-11.95,6l-1.23.6.43-.21.79-.41-.74.38-.78.38-1,.48,5-2.09c.64-.27.83-.29.42-.09-2.05,1-4.68,2.09-7.71,3.31l-.84.34a2.88,2.88,0,0,0,0,.58c0,.23,0,.46,0,.7a13.46,13.46,0,0,1-.16,1.39,16.43,16.43,0,0,1-.76,2.8A38.77,38.77,0,0,1,13,306.62Q11.71,306.25,10.49,305.84Zm22.08-12.48h.06l.53,0-.37,0Z"
            fill="#68c902"
          />
        </g>
        <g transform="translate(545 285)">
          <path
            d="M131.53,407.68c0-.88,0-1.6,0-2.17s0-1,0-1.23a1.11,1.11,0,0,1,.18-.63,1.36,1.36,0,0,1,.87-.37l1-.09c.33,0,.66,0,1,0h.46a3.15,3.15,0,0,1,.44,0,1,1,0,0,1,.87.38,2.94,2.94,0,0,1,.18,1.25v1.79c0,.83,0,1.64,0,2.44s0,1.6,0,2.41a2.67,2.67,0,0,1,1.1.16,1,1,0,0,1,.51.68,5.93,5.93,0,0,1,.15,1.37v.44a1.85,1.85,0,0,1,0,.46,1.08,1.08,0,0,1-.37.68,1.71,1.71,0,0,1-1.05.35l-.53,0c0,.81-.12,1.63-.2,2.48s-.17,1.7-.27,2.58a1.84,1.84,0,0,1-.37.92,1.22,1.22,0,0,1-.82.4l-.42,0h-.42l-.83,0-.83-.08a1.55,1.55,0,0,1-.84-.33,1,1,0,0,1-.29-.78s0-.17,0-.39,0-.47.08-.72,0-.64.07-.94l.08-.9c0-.3.05-.62.08-1s0-.72.09-1.12q-.77,0-1.56,0h-3.22q-.81,0-1.62,0c0,.79.07,1.51.11,2.17s.1,1.25.15,1.75c0,.2,0,.39.05.57s0,.3,0,.36a1,1,0,0,1-.92,1.13,6.43,6.43,0,0,1-1.11.18A11.27,11.27,0,0,1,122,422h-.31a1.33,1.33,0,0,1-1-.33,1.47,1.47,0,0,1-.35-.89c-.13-.89-.23-1.76-.31-2.6s-.15-1.69-.22-2.53a1.78,1.78,0,0,1-1-.21,1,1,0,0,1-.38-.74,2.58,2.58,0,0,1,0-.48v-.28c0-.23,0-.46,0-.68s0-.44.08-.67c.05-.4.17-.65.36-.74a2.49,2.49,0,0,1,.77-.18c0-1.11-.05-2.23-.05-3.36v-3.54a2.56,2.56,0,0,1,.2-1.2.89.89,0,0,1,.75-.38l.57,0,.56,0a14.23,14.23,0,0,1,2.11.16l.41.12a.6.6,0,0,1,.27.23,1.07,1.07,0,0,1,.15.46,5.5,5.5,0,0,1,0,.77c0,1.09,0,2.18,0,3.27s0,2.18.06,3.27c1.76-.06,3.6-.08,5.51-.08h1.24c0-.6,0-1.2,0-1.81S131.53,408.3,131.53,407.68Z"
            fill="#fff"
          />
          <path
            d="M148.84,409a2.23,2.23,0,0,1,.54.28.69.69,0,0,1,.2.57,1.76,1.76,0,0,1,0,.19c0,.08,0,.22-.06.41a5.65,5.65,0,0,1,3.22,2,6.25,6.25,0,0,1,.56,6.37,6.19,6.19,0,0,1-1.62,2,7.17,7.17,0,0,1-2.25,1.2,8.2,8.2,0,0,1-2.52.41,10.77,10.77,0,0,1-3.11-.43,6.39,6.39,0,0,1-2.37-1.25,5.51,5.51,0,0,1-1.5-2.05,7.08,7.08,0,0,1-.53-2.81,6.47,6.47,0,0,1,.66-2.93,7.3,7.3,0,0,1,1.71-2.26,7.91,7.91,0,0,1,2.39-1.43,6.9,6.9,0,0,1,3.68-.44A7.66,7.66,0,0,1,148.84,409ZM148,414a5,5,0,0,1-.51-.2,1.14,1.14,0,0,1-.33-.23,1,1,0,0,1-.2-.39,2.57,2.57,0,0,1-.06-.63,3.47,3.47,0,0,0-2.24,1.07,3.22,3.22,0,0,0-.9,2.33,2.48,2.48,0,0,0,.22,1,2.26,2.26,0,0,0,.62.78,2.72,2.72,0,0,0,.91.47,3.61,3.61,0,0,0,1.1.16,3.74,3.74,0,0,0,1.09-.16,3,3,0,0,0,1-.47,2.37,2.37,0,0,0,.7-.78,2,2,0,0,0,.27-1,1.76,1.76,0,0,0-.45-1.25A2.49,2.49,0,0,0,148,414Z"
            fill="#fff"
          />
          <path
            d="M166.88,410.58a5.88,5.88,0,0,1,1.91-1.41,5.23,5.23,0,0,1,2.15-.46,5.47,5.47,0,0,1,1.52.2,3.56,3.56,0,0,1,1.3.66,3.16,3.16,0,0,1,.92,1.17,3.94,3.94,0,0,1,.34,1.74c0,.47,0,1,0,1.66s-.06,1.31-.1,2-.11,1.49-.18,2.28-.18,1.57-.28,2.34a2.51,2.51,0,0,1-.25.83c-.13.26-.43.38-.88.38-.25,0-.59,0-1-.06a11.08,11.08,0,0,1-1.24-.2,1,1,0,0,1-.84-1.16c0-.21,0-.87.14-2s.15-2.61.15-4.49a2.77,2.77,0,0,0-.16-1,.58.58,0,0,0-.58-.39,3.72,3.72,0,0,0-2.27,1q0,.48,0,1v1.09c0,.76,0,1.58,0,2.47s0,1.7-.08,2.43a1.71,1.71,0,0,1-.26,1,1,1,0,0,1-.89.32h-1.39a5.78,5.78,0,0,1-.75,0,.94.94,0,0,1-.72-.4,1.7,1.7,0,0,1-.25-.89c0-1.07,0-2.12,0-3.14s0-2.08-.13-3.19a3.09,3.09,0,0,0-.22-1,.59.59,0,0,0-.55-.35,2.52,2.52,0,0,0-1.08.26,5.76,5.76,0,0,0-1,.63c0,1.13.05,2.23.11,3.31s.13,2.16.23,3.25c0,.11,0,.2,0,.29a2.35,2.35,0,0,1,0,.26.87.87,0,0,1-.27.69,2,2,0,0,1-1.12.29,2.54,2.54,0,0,1-.41,0h-.91a2.38,2.38,0,0,1-.39,0,1.45,1.45,0,0,1-1.07-.37,1.86,1.86,0,0,1-.33-.95c-.14-1.33-.25-2.68-.34-4s-.13-2.74-.13-4.12v-1c0-.32,0-.64,0-1a6.22,6.22,0,0,1,.12-1,.75.75,0,0,1,.62-.54,5.9,5.9,0,0,1,.74-.13l.87-.1.89-.06.77,0c.26,0,.44.06.52.19a.82.82,0,0,1,.14.5c0,.1,0,.21,0,.31s0,.23,0,.37a5.38,5.38,0,0,1,1.46-.85,4.36,4.36,0,0,1,1.6-.33,5.86,5.86,0,0,1,2.08.33A3.29,3.29,0,0,1,166.88,410.58Z"
            fill="#fff"
          />
          <path
            d="M189,415.74a12.67,12.67,0,0,1-1.61.45c-.63.14-1.3.26-2,.37s-1.45.2-2.22.28-1.49.13-2.19.17a3.76,3.76,0,0,0,1.35,1,4.39,4.39,0,0,0,1.75.36,7.91,7.91,0,0,0,1.61-.2,7.63,7.63,0,0,0,1.69-.57,1.88,1.88,0,0,1,.55-.18.36.36,0,0,1,.32.14,1.81,1.81,0,0,1,.21.44,5.54,5.54,0,0,1,.17.58l.12.58a1,1,0,0,1,.05.27v.25a1.21,1.21,0,0,1-.42.9,5.55,5.55,0,0,1-2.23,1.22,10.46,10.46,0,0,1-3.23.46,6.54,6.54,0,0,1-6.61-6.61,6.62,6.62,0,0,1,.57-2.76,6.91,6.91,0,0,1,1.51-2.18,7.14,7.14,0,0,1,2.2-1.41,7,7,0,0,1,2.6-.5,6.54,6.54,0,0,1,3.07.66,6.19,6.19,0,0,1,3.08,3.58,5.93,5.93,0,0,1,.33,1.74,1.24,1.24,0,0,1-.13.58A.93.93,0,0,1,189,415.74Zm-5.74-3.34a2.93,2.93,0,0,0-1.72.55,2.77,2.77,0,0,0-1.07,1.4c.79,0,1.62-.09,2.5-.16a15.38,15.38,0,0,0,2.42-.37,1.92,1.92,0,0,0-.91-1.09A2.57,2.57,0,0,0,183.22,412.4Z"
            fill="#fff"
          />
          <path
            d="M191,410.55a6.22,6.22,0,0,1,.12-1,.75.75,0,0,1,.62-.54,5.9,5.9,0,0,1,.74-.13l.87-.1.89-.06.77,0c.26,0,.44.06.52.19a.82.82,0,0,1,.14.5c0,.1,0,.23,0,.38s0,.29,0,.41a6.21,6.21,0,0,1,1.65-1.06,4.9,4.9,0,0,1,2-.39,1.26,1.26,0,0,1,1.11.58,3.29,3.29,0,0,1,.52,1.24,6.64,6.64,0,0,1,.16,1.33c0,.48,0,.9,0,1.25a1.71,1.71,0,0,1-.28,1,2.81,2.81,0,0,1-1,.86,7.67,7.67,0,0,1-.87.38,2.61,2.61,0,0,1-.84.2.76.76,0,0,1-.69-.39,1.52,1.52,0,0,1-.24-.83c0-.19,0-.44,0-.76a4.41,4.41,0,0,0-.11-.82l-.67.37a7.93,7.93,0,0,0-.75.56c0,.94,0,1.84.07,2.67s.08,1.57.13,2.21.09,1.18.13,1.61.06.71.06.85a.87.87,0,0,1-.27.69,2,2,0,0,1-1.12.29,2.54,2.54,0,0,1-.41,0h-.91a2.38,2.38,0,0,1-.39,0,1.45,1.45,0,0,1-1.07-.37,1.86,1.86,0,0,1-.33-.95c-.14-1.33-.25-2.69-.34-4.07s-.13-2.75-.13-4.12v-.95C190.94,411.19,190.94,410.87,191,410.55Z"
            fill="#fff"
          />
          <path
            d="M211.25,409a2.23,2.23,0,0,1,.54.28.69.69,0,0,1,.2.57,1.76,1.76,0,0,1,0,.19c0,.08,0,.22-.06.41a5.65,5.65,0,0,1,3.22,2,6.25,6.25,0,0,1,.56,6.37,6.32,6.32,0,0,1-1.62,2,7.11,7.11,0,0,1-2.26,1.2,8.09,8.09,0,0,1-2.51.41,10.77,10.77,0,0,1-3.11-.43,6.39,6.39,0,0,1-2.37-1.25,5.51,5.51,0,0,1-1.5-2.05,7.08,7.08,0,0,1-.53-2.81,6.47,6.47,0,0,1,.66-2.93,7.3,7.3,0,0,1,1.71-2.26,8,8,0,0,1,2.38-1.43,6.94,6.94,0,0,1,3.69-.44A7.66,7.66,0,0,1,211.25,409Zm-.82,5.06a5,5,0,0,1-.51-.2,1.14,1.14,0,0,1-.33-.23.9.9,0,0,1-.2-.39,2.49,2.49,0,0,1-.07-.63,3.52,3.52,0,0,0-2.24,1.07,3.26,3.26,0,0,0-.89,2.33,2.33,2.33,0,0,0,.22,1,2.26,2.26,0,0,0,.62.78,2.72,2.72,0,0,0,.91.47,3.55,3.55,0,0,0,1.09.16,3.75,3.75,0,0,0,1.1-.16,3,3,0,0,0,1-.47,2.49,2.49,0,0,0,.7-.78,2,2,0,0,0,.26-1,1.8,1.8,0,0,0-.44-1.25A2.49,2.49,0,0,0,210.43,414Z"
            fill="#fff"
          />
          <path
            d="M226.82,409a2.69,2.69,0,0,1,.54.28.69.69,0,0,1,.19.57,1.42,1.42,0,0,1,0,.19c0,.08,0,.22-.07.41a5.68,5.68,0,0,1,3.23,2,5.8,5.8,0,0,1,1.17,3.67,5.66,5.66,0,0,1-.62,2.7,6.06,6.06,0,0,1-1.62,2,7,7,0,0,1-2.25,1.2,8.09,8.09,0,0,1-2.51.41,10.72,10.72,0,0,1-3.11-.43,6.39,6.39,0,0,1-2.37-1.25,5.51,5.51,0,0,1-1.5-2.05,6.91,6.91,0,0,1-.53-2.81,6.47,6.47,0,0,1,.66-2.93,7.3,7.3,0,0,1,1.71-2.26,8,8,0,0,1,2.38-1.43,6.94,6.94,0,0,1,3.69-.44A7.66,7.66,0,0,1,226.82,409ZM226,414a5,5,0,0,1-.51-.2.92.92,0,0,1-.33-.23.9.9,0,0,1-.2-.39,2.1,2.1,0,0,1-.07-.63,3.52,3.52,0,0,0-2.24,1.07,3.26,3.26,0,0,0-.89,2.33,2.33,2.33,0,0,0,.22,1,2.26,2.26,0,0,0,.62.78,2.63,2.63,0,0,0,.91.47,3.55,3.55,0,0,0,1.09.16,3.75,3.75,0,0,0,1.1-.16,3,3,0,0,0,1-.47,2.49,2.49,0,0,0,.7-.78,2.11,2.11,0,0,0,.26-1,1.8,1.8,0,0,0-.44-1.25A2.49,2.49,0,0,0,226,414Z"
            fill="#fff"
          />
          <path
            d="M244.86,410.58a5.88,5.88,0,0,1,1.91-1.41,5.2,5.2,0,0,1,2.15-.46,5.35,5.35,0,0,1,1.51.2,3.52,3.52,0,0,1,1.31.66,3.26,3.26,0,0,1,.92,1.17,3.94,3.94,0,0,1,.34,1.74c0,.47,0,1,0,1.66s-.06,1.31-.1,2-.11,1.49-.19,2.28-.17,1.57-.27,2.34a2.51,2.51,0,0,1-.25.83c-.14.26-.43.38-.89.38-.24,0-.59,0-1-.06a10.72,10.72,0,0,1-1.24-.2,1,1,0,0,1-.85-1.16c0-.21,0-.87.15-2s.14-2.61.14-4.49a2.79,2.79,0,0,0-.15-1,.58.58,0,0,0-.58-.39,3.72,3.72,0,0,0-2.27,1q0,.48,0,1v1.09c0,.76,0,1.58,0,2.47s0,1.7-.08,2.43a1.79,1.79,0,0,1-.26,1,1,1,0,0,1-.9.32h-1.38a5.78,5.78,0,0,1-.75,0,.94.94,0,0,1-.73-.4,1.8,1.8,0,0,1-.25-.89c0-1.07,0-2.12,0-3.14s0-2.08-.13-3.19a2.81,2.81,0,0,0-.23-1,.56.56,0,0,0-.54-.35,2.45,2.45,0,0,0-1.08.26,5.76,5.76,0,0,0-1,.63c0,1.13,0,2.23.1,3.31s.13,2.16.24,3.25c0,.11,0,.2,0,.29a2.35,2.35,0,0,1,0,.26.87.87,0,0,1-.27.69,2,2,0,0,1-1.12.29,2.63,2.63,0,0,1-.41,0h-.91a2.6,2.6,0,0,1-.4,0,1.43,1.43,0,0,1-1.06-.37,1.86,1.86,0,0,1-.33-.95c-.14-1.33-.26-2.68-.35-4s-.13-2.74-.13-4.12v-1q0-.48,0-1a6.22,6.22,0,0,1,.12-1,.75.75,0,0,1,.62-.54,5.71,5.71,0,0,1,.73-.13l.87-.1.9-.06.76,0a.6.6,0,0,1,.53.19.82.82,0,0,1,.13.5c0,.1,0,.21,0,.31s0,.23,0,.37a5.38,5.38,0,0,1,1.46-.85,4.32,4.32,0,0,1,1.6-.33,5.9,5.9,0,0,1,2.08.33A3.34,3.34,0,0,1,244.86,410.58Z"
            fill="#fff"
          />
        </g>
      </g>
      <g
        className="prefix__static-item"
        onClick={() => literacyCheck('/process-steps-admin')}
        style={{ cursor: 'pointer' }}
      >
        <g transform="translate(40 400)">
          <path
            d="M94,.28h1a1.94,1.94,0,0,1,1.94,1.94V57.57a3,3,0,0,1-3,3h0a3,3,0,0,1-3-3V3.36A3.08,3.08,0,0,1,94,.28Z"
            fill="#f1ba0e"
          />
          <ellipse cx="93.96" cy="1.32" rx="2.98" ry="1.32" fill="#e88803" />
          <path
            d="M93.72,56.49V1.14A2,2,0,0,1,93.9.28c-1.62,0-3,.31-3,1.94V57.57a3,3,0,0,0,5.34,1.88A3,3,0,0,1,93.72,56.49Z"
            fill="#e88803"
          />
          <g>
            <polygon
              points="88.83 272.21 153.54 249.91 133.56 234.12 88.83 272.21"
              fill="#55a32a"
            />
            <polygon
              points="45.81 278.04 82 266.35 54.92 250.55 45.81 278.04"
              fill="#55a32a"
            />
            <g>
              <path
                d="M90.74,180.52,20.8,153.07s24.38,75.5,23.54,95.22l44.49,23.92,48.31-22.66s6.05-67.2,12.09-96.75c-8.6-11.61-34.94-17.8-34.94-17.8Z"
                fill="#e88803"
              />
              <path
                d="M33.13,157.94s12.33,47.61,31.26,46.18,21.9-25.66,21.9-25.66Z"
                fill="#f1ba0e"
              />
              <path
                d="M118.59,132.7,90.74,180.52l-4.45-2.06L84,198.82V262l4.61,10.13.23.12,48.31-22.66s2.1-5,7.27-31.67,15.76-34.85,16.06-36.71C151.87,169.56,118.59,132.7,118.59,132.7Z"
                fill="#f1ba0e"
              />
              <path
                d="M91.64,271.22s-8.39-81.44,21.08-81.44,24.42,59.77,24.42,59.77Z"
                fill="#e88803"
              />
              <path
                d="M128.92,255.88c.14-49.47-27.91-53-27.91-53l-.6,64.08A114.37,114.37,0,0,0,128.92,255.88Z"
                fill="#7c3ae1"
              />
              <path
                d="M128.92,255.88c2.93-46-26.25-52.24-26.25-52.24l-.6,64.08A119.07,119.07,0,0,0,128.92,255.88Z"
                fill="#a83ce1"
              />
              <polygon
                points="100.42 266.95 102.07 267.72 102.09 265.04 100.42 266.95"
                fill="#7c3ae1"
              />
              <circle cx="123.83" cy="238.08" r="3.16" fill="#7c3ae1" />
              <circle cx="124.59" cy="237.14" r="2.75" fill="#f1ad0e" />
              <path
                d="M125.55,238.94a2.75,2.75,0,0,1-2.75-2.75,2.7,2.7,0,0,1,.4-1.41,2.74,2.74,0,1,0,3.74,3.78A2.73,2.73,0,0,1,125.55,238.94Z"
                fill="#f16e64"
              />
              <path
                d="M65.8,241.4,49.43,234a3.43,3.43,0,0,1-2-3l-1.26-37.35a3.39,3.39,0,0,1,4.79-3.2l16.37,7.41a3.42,3.42,0,0,1,2,3l1.26,37.35A3.39,3.39,0,0,1,65.8,241.4Z"
                fill="#aa460a"
              />
              <path
                d="M63.88,237.45l-13.13-6.28a2.88,2.88,0,0,1-1.6-2.51l-1.07-31.53a2.73,2.73,0,0,1,3.84-2.69l13.13,6.28a2.88,2.88,0,0,1,1.6,2.51l1.07,31.53A2.73,2.73,0,0,1,63.88,237.45Z"
                fill="#95e4f8"
              />
              <path
                d="M65.05,200.72l-13.13-6.28a2.67,2.67,0,0,0-3.63,1.49L67.61,231.7l-1-28.47A2.88,2.88,0,0,0,65.05,200.72Z"
                fill="#fff"
              />
              <path
                d="M67.34,197.87,51,190.46a3.38,3.38,0,0,0-4,.9,3.38,3.38,0,0,1,3-.07l16.36,7.41a3.39,3.39,0,0,1,2,3L69.55,239a3.38,3.38,0,0,1-.8,2.3,3.37,3.37,0,0,0,1.84-3.13l-1.26-37.35A3.42,3.42,0,0,0,67.34,197.87Z"
                fill="#8a3e0a"
              />
              <path
                d="M64.92,215.93c3.51,6.35,18.37,35.36,13.22,42.57-8.64,12.13-15.52.24-18-2.36-.88-8.42-.17-8.42-.17-8.42a10.4,10.4,0,0,0,10.14,7.5c8.43.24-6.68-28.08-6.68-28.08Z"
                fill="#4c42d3"
              />
              <path
                d="M20.26,202c-3.31,4.14-2.15,13.72-6.69,22.12S0,253.53,3.64,255.7c3.73,9.07,38.24,22.16,42.17,22.34,9.52-1.13,16.66-12.55,16.66-12.55s5.07-52.22,3.57-56.24c-4.79-6.32-22.71-16.33-28.71-15.43S23.57,197.81,20.26,202Z"
                fill="#4c42d3"
              />
              <path
                d="M39.16,208.35a94.72,94.72,0,0,0-18.26-7.13c-.23.24-.44.48-.64.73-3.31,4.14-2.15,13.72-6.69,22.12S0,253.53,3.64,255.7c3.73,9.07,38.24,22.16,42.17,22.34a14.36,14.36,0,0,0,3-.7c3.6-14.74,6.57-55.92,5.17-60.17C52.32,212.16,49.69,214,39.16,208.35Z"
                fill="#3024cf"
              />
              <path
                d="M12.69,234.25c3.31-1,18.75,8.47,29.27,11.43s-3.13,27.95-21.54,16.93S8.58,235.49,12.69,234.25Z"
                fill="#f160ce"
              />
              <path
                d="M54.3,224s-6.67,18.87-29.19,12c-14.25-4.37-7.72-22.34-7.72-22.34Z"
                fill="#261abb"
              />
              <path
                d="M56.37,212.45c2.11,10.62-8.08,24.6-24,20.84-13.19-3.1-19.85-16.53-12.45-30.84S56.37,212.45,56.37,212.45Z"
                fill="#4c42d3"
              />
              <path
                d="M37.42,227.08l-3.87-3.81a.68.68,0,0,0-.63-.19l-5.34,1a.71.71,0,0,1-.76-1l2.43-4.86a.73.73,0,0,0,0-.66l-2.63-4.76a.71.71,0,0,1,.72-1l5.38.81a.69.69,0,0,0,.62-.21l3.71-4a.7.7,0,0,1,1.21.36l.89,5.37a.73.73,0,0,0,.4.52l4.92,2.3a.71.71,0,0,1,0,1.27l-4.83,2.5a.73.73,0,0,0-.37.54l-.67,5.4A.71.71,0,0,1,37.42,227.08Z"
                fill="#f1ad0e"
              />
              <path
                d="M118.59,132.7s1.22,51.48-.93,57.94a44.92,44.92,0,0,1,17.43,25l9.32,2.29s7-25.95,16.06-36.71C151.43,166.55,118.59,132.7,118.59,132.7Z"
                fill="#ab9201"
              />
              <path
                d="M90.35,271.22s-1.87-31.54.57-48.18,5.59-24.23,9.46-27.82a24.62,24.62,0,0,1,7.46-4.87s-6.74,4-8.6,8.75-5.6,20.36-6.17,23.66-.86,10.61-.86,10.61a10.81,10.81,0,0,1,1.47-2.3c.86-1,1.29-4.84,1.29-4.84s.32,4.31-.43,5.92a16.06,16.06,0,0,1-2,3.12S92,241,92,244.62s-.11,12.69-.11,12.69a11.09,11.09,0,0,0,1.18-2,16.48,16.48,0,0,0,.54-2.9s.11,3.55-.91,5.11-.54,6.72-.49,7,.76,6.07.76,6.07S91.64,272.82,90.35,271.22Z"
                fill="#aa460a"
              />
              <path
                d="M94.93,207.7c-.78-.57-1.07-3.3-.86-4.73s.58-3.37.58-3.37-1.72,4-1.44,6.38a13.11,13.11,0,0,0,.94,3.73Z"
                fill="#aa460a"
              />
              <path
                d="M93.39,204.51a3.14,3.14,0,0,1-2.47-.65c1.65,1.87,2.62,1.29,2.62,1.29Z"
                fill="#aa460a"
              />
              <path
                d="M87.87,219.57s1.76,6.05,3.48,6.41a4.24,4.24,0,0,0-.29,1.58A12.87,12.87,0,0,1,87.87,219.57Z"
                fill="#aa460a"
              />
              <path
                d="M85.94,178.05c0,1.29-1.4,6.35-4.74,12.59S70.34,202.47,68.94,202.9l-1.39.43s.32,1.18,2.25.43a41.17,41.17,0,0,0,5.92-3.66,8.57,8.57,0,0,1-.22,3.55c1.51-1.08,1.4-4.3,1.4-4.3s1.62-1.51,3.55-3.66A25.9,25.9,0,0,0,84,189.78a5.14,5.14,0,0,1,2.15,2.15,5.39,5.39,0,0,0-1.61-3.66S88.09,180,88.09,179A6.46,6.46,0,0,0,85.94,178.05Z"
                fill="#aa460a"
              />
              <path
                d="M112.72,189.78c4.69-.58,12.31,5.75,17.2,15.48,9.36,18.61,6,44.88,6,44.88s.53.83,1.5,0,.65-3,.65-3,1.07-30.15-6.67-42.48C123.26,191.6,119.53,189.63,112.72,189.78Z"
                fill="#aa460a"
              />
              <path
                d="M46.9,192.57c-1.62-.75-3.66-4.3-4.41-6.24s-3.77-10.21-4.41-11.83-4.63-3.44-4.63-3.44a12.92,12.92,0,0,1,3.63,1.08c-1.8-2.44-3.23-8.32-3.3-9s-3.37-2.73-3.37-2.73l2.43.86-1.14-3.94s2.72.5,3.15,1c.07,2.15,4.81,15.42,5.59,18s2.73,7.38,2.73,7.38l.5-2.08s.43,4,.65,4.74a57.89,57.89,0,0,0,3.15,5Z"
                fill="#aa460a"
              />
              <path
                d="M118.59,132.7c0,2.16-.14,39.87-.71,45.32s-1.44,12.19-1.44,12.19l2.3,1.29a166.47,166.47,0,0,0,.86-17.07c.14-11.47.72-40,.72-40Z"
                fill="#aa460a"
              />
              <path
                d="M134.51,213.87,145,217s.43,2.44,0,2.58-9.61-3.58-9.61-3.58Z"
                fill="#aa460a"
              />
              <path
                d="M98.09,201.82c-.36.93-2.08,4.37-2.37,6s-1.65,7.24-1.65,7.46-1.5,6.31-1.5,6.31L93.9,218l-.11,1.45s1.93-9.14,2.58-11.4S98.09,201.82,98.09,201.82Z"
                fill="#91320a"
              />
              <path
                d="M92.82,224.08a57.39,57.39,0,0,1-.48,5.92,15.63,15.63,0,0,0-.13,3.37l-.63,2.11s.27-3.22.22-3.55S92.82,224.08,92.82,224.08Z"
                fill="#91320a"
              />
              <path
                d="M92.23,238.06l-.38-1.13s-.11,1.89-.11,3.34-.21,7.69-.21,7.69l-.48-2.31a35,35,0,0,0-.06,6.13,35.89,35.89,0,0,1,.27,5.43,12.83,12.83,0,0,0,.22,2l.37-1.94Z"
                fill="#91320a"
              />
              <path
                d="M92.17,259.2a16.38,16.38,0,0,0-.64,3.6c0,1.5.75,8.66.75,8.66a1.54,1.54,0,0,0,.65-.92C92.28,265,92.17,259.2,92.17,259.2Z"
                fill="#91320a"
              />
              <path
                d="M99.2,198c-.11.47-1.29,2-2,3.8A40.53,40.53,0,0,0,95.87,206a23.29,23.29,0,0,1,1-5.06A11.23,11.23,0,0,1,99.2,198Z"
                fill="#91320a"
              />
              <path
                d="M92.39,223.87c-.11.7-.81,6.4-.81,6.4a21.56,21.56,0,0,1,0-4.31A15.92,15.92,0,0,1,92.39,223.87Z"
                fill="#91320a"
              />
              <path
                d="M92,233.71c.32,0,.93-.38,1.29-1.2s.79-1.11,1-1.65a42.9,42.9,0,0,0,.68-4.63s-.75,4.16-1.29,4.84A23.25,23.25,0,0,1,92,232.83Z"
                fill="#91320a"
              />
              <path
                d="M184.13,157.4c.23-2-1.93-3-3.12-3.44-.14-.27-.29-.53-.45-.8.39-.94.82-3-.95-5.65s-4.67-2.12-6.32-1.57c-.46-.31-.93-.61-1.41-.91-.28-1.46-.93-3.65-2.38-4.62s-3.82,0-5.13.75l-.84-.35a3.72,3.72,0,0,0-1.13-3c-1.17-1.09-3.71-.11-5.24.64l-1.35-.43c-.21-1.22-.74-3.12-2-3.76s-3.27.85-4.5,1.95l-1.33-.32a3.79,3.79,0,0,0-3.1-3,1,1,0,0,0-.07.47c-16.79-16.73-37-42-39.05-68-.09-2.18-5.08-3.72-11.14-3.45S83.73,64.2,83.83,66.38c0,0-6.33,37.69-34.36,69.81a6.54,6.54,0,0,0-6.44.24c-3.45,2.3-3.3,4.16-3.3,4.16s-6.6-1.29-9.18,1S28,145.18,28,145.18s-6.56-1-8.93,2c-2.07,2.64-2.24,4.2-2.26,4.55l-.07.06a6.68,6.68,0,0,0-5.52,1.41A5,5,0,0,0,10,158.42a3.46,3.46,0,0,0-.22.31,6.07,6.07,0,0,0-4.15,3.8,4.65,4.65,0,0,0,1.58,5.19,2.11,2.11,0,0,0,0,.25,5.45,5.45,0,0,0-.74,6.18c1.56,3,4.9,3.08,6,3l.28.27a3.81,3.81,0,0,0,1.92,3.87,6.38,6.38,0,0,0,4.66.81l.42.23a5.19,5.19,0,0,0,3.1,3.83,5.76,5.76,0,0,0,4.8-.16l.35.14c.45.84,2,3.53,4.45,3.89a11.38,11.38,0,0,0,5.41-.72l.38.1a3.68,3.68,0,0,0,3,2.77,7.09,7.09,0,0,0,4.73-1l1,.2c.4.7,1.4,1.8,3.91,2.36a6.59,6.59,0,0,0,5.31-.83l1.06.14a8,8,0,0,0,4.53,2.55,6.51,6.51,0,0,0,5.21-1.51l.75.06A8.86,8.86,0,0,0,73.28,197a6,6,0,0,0,4.81-2.19l1,0A7.56,7.56,0,0,0,84,197.52c2.53.21,4.28-1.67,5-2.68l1,0a9.69,9.69,0,0,0,5.28,2.41,4.82,4.82,0,0,0,4.74-2.82l1.05-.06a6.19,6.19,0,0,0,5.11,2.31,4.14,4.14,0,0,0,3.85-3.06l.71-.08a6.62,6.62,0,0,0,5.48,2.57,4.88,4.88,0,0,0,4.26-3.81l.77-.12c.91,1,2.81,2.55,5.15,2.35,2.81-.25,4.16-3.19,4.5-4.06l.21,0a4.67,4.67,0,0,0,5.47,2,5.64,5.64,0,0,0,3.76-3.38,9.4,9.4,0,0,0,6.07.15c2.54-.81,3.18-2.33,3.24-3.57l1.45-.49a6.27,6.27,0,0,0,3.26.3,4.62,4.62,0,0,0,3.78-3l1.62-.69a5.55,5.55,0,0,0,3.85.42c2.31-.54,3.13-2.78,3.41-4l1-.58a9,9,0,0,0,6.88-.89,3.4,3.4,0,0,0,1.16-4.94l.83-.81c1.86-.15,5.05-.77,5.65-3.18a5.45,5.45,0,0,0-.72-4.43,12.3,12.3,0,0,0,.5-2.38A6.77,6.77,0,0,0,184.13,157.4Z"
                fill="#983c0a"
              />
              <g>
                <path
                  d="M77.37,194.51l-.92-.11a4.94,4.94,0,0,1-4.61,1.07,4.89,4.89,0,0,1-3.5-2.43l-.86-.18a5.33,5.33,0,0,1-4.09,1.22,3.73,3.73,0,0,1-2.7-2.9l-.34-.1a8.29,8.29,0,0,1-4.68,1c-2.12-.31-3.63-3.17-4.05-4.07l-.31-.13a4.17,4.17,0,0,1-4.19.33,5.62,5.62,0,0,1-2.86-4l-.37-.24a4.64,4.64,0,0,1-4.1-.73A4.51,4.51,0,0,1,38,179.06l-.26-.28c-.93.09,14.57-14.17,32.64-43.42S93,74,94.86,61.93h-.25c-6,.27-10.88,2.26-10.78,4.44,0,0-6.33,37.69-34.36,69.81a6.54,6.54,0,0,0-6.44.24c-3.45,2.3-3.3,4.16-3.3,4.16s-6.6-1.29-9.18,1S28,145.18,28,145.18s-6.56-1-8.93,2c-2.07,2.64-2.24,4.2-2.26,4.55l-.07.06a6.68,6.68,0,0,0-5.52,1.41A5,5,0,0,0,10,158.42a3.46,3.46,0,0,0-.22.31,6.07,6.07,0,0,0-4.15,3.8,4.65,4.65,0,0,0,1.58,5.19,2.11,2.11,0,0,0,0,.25,5.45,5.45,0,0,0-.74,6.18c1.56,3,4.9,3.08,6,3l.28.27a3.81,3.81,0,0,0,1.92,3.87,6.38,6.38,0,0,0,4.66.81l.42.23a5.19,5.19,0,0,0,3.1,3.83,5.76,5.76,0,0,0,4.8-.16l.35.14c.45.84,2,3.53,4.45,3.89a11.38,11.38,0,0,0,5.41-.72l.38.1a3.68,3.68,0,0,0,3,2.77,7.09,7.09,0,0,0,4.73-1l1,.2c.4.7,1.4,1.8,3.91,2.36a6.59,6.59,0,0,0,5.31-.83l1.06.14a8,8,0,0,0,4.53,2.55,6.51,6.51,0,0,0,5.21-1.51l.75.06A8.86,8.86,0,0,0,73.28,197,5.87,5.87,0,0,0,77.83,195C77.66,194.85,77.5,194.67,77.37,194.51Z"
                  fill="#7a280a"
                />
                <path d="M141.92,189.18l-.18.06,0,.11.35.06Z" fill="#7a280a" />
              </g>
              <path
                d="M66,177.73s6.38,6.6,13.26,1C76,186.76,66.83,185.47,66,177.73Z"
                fill="#7a280a"
              />
              <path
                d="M108.78,172.59s10.83,4.77,16.33-5.26C125.08,178.53,113.49,181.45,108.78,172.59Z"
                fill="#7a280a"
              />
              <path
                d="M118.67,157.53s10.84,4.78,16.34-5.26C135,163.47,123.39,166.4,118.67,157.53Z"
                fill="#7a280a"
              />
              <path
                d="M135,164.09s9.64,2.77,13.11-6.27C149.33,167.22,139.93,171,135,164.09Z"
                fill="#7a280a"
              />
              <path
                d="M107.52,136.2s8.9,4.63,14.1-3.55C121,142.12,111,144,107.52,136.2Z"
                fill="#7a280a"
              />
              <path
                d="M118.59,137.7s7.74,4,12.27-3.08C130.3,142.85,121.64,144.45,118.59,137.7Z"
                fill="#7a280a"
              />
              <path
                d="M95.68,118.42s7.37,3.84,11.68-2.94C106.83,123.32,98.57,124.85,95.68,118.42Z"
                fill="#7a280a"
              />
              <path
                d="M104.85,119.66s6.42,3.34,10.17-2.55C114.56,123.93,107.38,125.26,104.85,119.66Z"
                fill="#7a280a"
              />
              <path
                d="M95,102.29s7.37,3.83,11.68-3C106.18,107.19,97.93,108.71,95,102.29Z"
                fill="#7a280a"
              />
              <path
                d="M95.89,85.37s7.37,3.83,11.69-3C107,90.27,98.79,91.79,95.89,85.37Z"
                fill="#7a280a"
              />
              <path
                d="M104.21,103.53s6.42,3.34,10.17-2.56C113.91,107.8,106.73,109.13,104.21,103.53Z"
                fill="#7a280a"
              />
              <path
                d="M91.81,151.57s9.52,5,15.08-3.79C106.2,157.9,95.55,159.86,91.81,151.57Z"
                fill="#7a280a"
              />
              <path
                d="M90,128s6.88,8.23,15.38,2.3C100.88,139.38,90.29,137.1,90,128Z"
                fill="#7a280a"
              />
              <path
                d="M103.65,153.18s8.28,4.31,13.12-3.3C116.17,158.69,106.91,160.4,103.65,153.18Z"
                fill="#7a280a"
              />
              <path
                d="M87.12,182.67s8.87,4.61,14.06-3.54C100.54,188.57,90.61,190.4,87.12,182.67Z"
                fill="#7a280a"
              />
              <path
                d="M98.16,184.17s7.72,4,12.24-3.08C109.84,189.3,101.2,190.89,98.16,184.17Z"
                fill="#7a280a"
              />
              <path
                d="M144.23,170s9.47,3.22,13.35-5.63C158.39,173.74,148.85,177.06,144.23,170Z"
                fill="#7a280a"
              />
              <path
                d="M155.37,169.76s8.24,2.79,11.62-4.91C167.69,173.05,159.39,175.94,155.37,169.76Z"
                fill="#7a280a"
              />
              <path
                d="M132.75,205.93a3.53,3.53,0,0,0,.15-.91,3.28,3.28,0,0,0-.35-1.07,6.29,6.29,0,0,1-.38-3.71,6.52,6.52,0,0,0,.19-1,2.13,2.13,0,0,0-1.18-2,7.45,7.45,0,0,1,.5,3.82,5.2,5.2,0,0,0-.08,1.88,3,3,0,0,1,.24,1c0,.5-.46.87-.59,1.35a2.26,2.26,0,0,0,.74,1.91,8,8,0,0,1,.73,1C132.85,207.5,132.58,206.72,132.75,205.93Z"
                fill="#aa460a"
              />
              <path
                d="M132.52,213.33c-.43-.15-.89-.17-1.32-.32a5.14,5.14,0,0,1-2.43-2.48,4.44,4.44,0,0,0,1.84,3c.33.18.69.29,1,.48,1.4.81,1.69,2.77,3,3.76-.24-.19-.18-2.32-.39-2.8A3,3,0,0,0,132.52,213.33Z"
                fill="#aa460a"
              />
              <path
                d="M138.28,224.89a4,4,0,0,0,.12-2.33l-.29-2a13.82,13.82,0,0,1,.61,4.7,3.22,3.22,0,0,1-.13.87c-.19.56-.64,1-.82,1.56-.28.84.12,1.86-.37,2.63a10.38,10.38,0,0,1-.32-2.83C137.16,226.41,137.84,225.79,138.28,224.89Z"
                fill="#aa460a"
              />
              <path
                d="M131.27,207.14a32.51,32.51,0,0,1,1.66,3.93c0,.21,1.08,4.09,1.08,4.09s-.75-4.74-.91-5.22A30.64,30.64,0,0,0,131.27,207.14Z"
                fill="#91320a"
              />
              <path
                d="M123.2,194.83C122.6,194.6,128,201,128,201S124.76,195.42,123.2,194.83Z"
                fill="#91320a"
              />
              <path
                d="M136.75,228s.65,10.92.7,12.26C138.15,236.29,136.75,228,136.75,228Z"
                fill="#91320a"
              />
              <path
                d="M135.16,214.12c.28,1.18.53,2,.53,2l4.27,1.65s-3.15-2.08-3.4-2.18A12.13,12.13,0,0,1,135.16,214.12Z"
                fill="#91320a"
              />
              <polygon
                points="140.25 216.91 144.48 218.63 142.36 218.31 140.25 216.91"
                fill="#91320a"
              />
            </g>
            <path
              d="M26.36,258C17.77,252.82,15,248,14.5,242.69c-.07-.78,2-2,2-2.71s-2.34-2.31-2.24-2.93a16.19,16.19,0,0,1,.66-2.6,4.59,4.59,0,0,0-2.22-.2C8.58,235.49,2,251.6,20.42,262.61c9.27,5.55,17.32,2,21.7-3.32C37.81,261.32,32.34,261.54,26.36,258Z"
              fill="#f142ab"
            />
            <path
              d="M12,236.21c-.73.88,28.19,15,29.61,13.47S13.86,234.05,12,236.21Z"
              fill="#f1ba0e"
            />
            <path
              d="M55.44,204.5s-9.48,3.75-16.81.17c-6.87-3.36-1.52-7.51-1.52-7.51l3.46,1.06s-3.21,1.81.08,3.6,10.93,1.11,10.93,1.11Z"
              fill="#261abb"
            />
            <path
              d="M37.11,197.16s-.25-9.12,8.22-8.54,10,10.29,10.11,15.88c-3.12.82-3.86-1.57-3.86-1.57s-.35-10.47-5.31-11.54-5.7,6.83-5.7,6.83S38.83,199.36,37.11,197.16Z"
              fill="#4c42d3"
            />
            <path
              d="M40.57,198.22a2,2,0,0,1-1.94.14c1-5.57,3.73-7.31,6.94-7.06C41.85,191.79,40.57,198.22,40.57,198.22Z"
              fill="#3024cf"
            />
            <path
              d="M71.81,247s6.73,10.43,3.28,14.94C70.65,267.72,63,259.72,63,259.72l.6-6.62s6.86,4.21,8.46.73C73.25,251.29,71.81,247,71.81,247Z"
              fill="#261abb"
            />
            <path
              d="M63.75,251.63l-11,2s2.1,5.24,6.4,5.34S63.75,251.63,63.75,251.63Z"
              fill="#261abb"
            />
            <path
              d="M52.79,253.64s4.08,3.06,8.62,1.11c3-1.28,2.34-3.12,2.34-3.12s4.17,16.67-6.38,21.11S52.79,253.64,52.79,253.64Z"
              fill="#f160ce"
            />
            <path
              d="M61.71,268.61c-7.16,3-6.72-6.84-5.69-13.5a10,10,0,0,1-3.23-1.47s-6,23.55,4.58,19.1a10.38,10.38,0,0,0,5.07-4.48Z"
              fill="#f142ab"
            />
            <polygon
              points="16.63 240.77 14.29 240.77 14.81 237.62 16.12 237.62 16.63 240.77"
              fill="#f17e0e"
            />
            <path
              d="M54.52,223s-.08-14.66,5.75-16.19c3.89-1,5.75,3.37,5.75,3.37s-2.35-2.41-6.65,1.1C55.73,214.25,54.52,223,54.52,223Z"
              fill="#261abb"
            />
            <circle cx="15.46" cy="237.62" r="1.17" fill="#f1ba0e" />
            <path
              d="M15.89,238.34a1.18,1.18,0,0,1-1.17-1.18,1.28,1.28,0,0,1,.14-.55,1.17,1.17,0,1,0,1.63,1.56A1.2,1.2,0,0,1,15.89,238.34Z"
              fill="#f17e0e"
            />
            <polygon
              points="16.63 240.77 16.9 240.49 16.39 238.32 16.23 238.49 16.63 240.77"
              fill="#f1ba0e"
            />
            <path
              d="M109.15,282.21a41,41,0,0,0-7.62.17c-.36.06-.54.09-1.27.26l-3,.75c-1.33.31-3,.68-5.08,1a36.1,36.1,0,0,1-6.2.33,24.88,24.88,0,0,1-3.39-2.33c.59-.27,1.15-.53,1.7-.81-.06-.48-.16-.65-.26-.36,0-.37,0-3.14.21-4.92s.34-3,.33-3.51a7,7,0,0,1,.07,1.83c.1-1.31.21-2.34.32-2.95a18.58,18.58,0,0,0,.24-3.05,47.08,47.08,0,0,1-.06,7.85,7,7,0,0,1,.26-1.5v.18c.28-2.86.44-4.81.42-5.85a27.28,27.28,0,0,1,.23,4.93c.15-3.06.34-5.33.51-6.55a42.73,42.73,0,0,0,.22-7,3.15,3.15,0,0,1,.12.83l.16,2.32c.13,2,.28,4.84.39,8.21a3.28,3.28,0,0,1,.18-.86,11.21,11.21,0,0,0,.2-3.81,58.88,58.88,0,0,1,.45,6.1c.1-.76.2-1.31.27-2.16a46.36,46.36,0,0,0-.16-8.23c-.06-.84,0-1.07.09-.52.13.83.26,1.73.39,2.68a18,18,0,0,1,.66,3.61c-.25-2.65-.39-4.75-.44-6a56.53,56.53,0,0,0-.66-6.21,37.89,37.89,0,0,1,.83,4.18c.49,2.78,1.19,6.79,1.81,11.56a20,20,0,0,1-.12-3.11l.06.35c-.63-5.82-1.19-9.78-1.62-11.85a91.38,91.38,0,0,1,2.29,9.77c-1-6.17-1.72-10.75-2-13.24a126.48,126.48,0,0,0-2.76-14,10.05,10.05,0,0,1,.51,1.62c.31,1.06.73,2.61,1.26,4.57,1.05,3.94,2.51,9.55,4.12,16.22a12.07,12.07,0,0,1-.12-1.78,32.05,32.05,0,0,0-1.31-7.65c.31.67,1.66,5.55,3.21,12-.19-1.52-.28-2.66-.52-4.36a149.68,149.68,0,0,0-3.2-16.46c-.38-1.67-.28-2.16.07-1.09a185.68,185.68,0,0,1,5,20c.77,3.75,1.4,6.91,1.87,9.51l.17-.09v-.09l-.39-3c-.62-4.34-.94-5.95-1.9-10.36-.23-1-.16-1.35,0-.67,1,3.39,1.91,7.68,2.86,12.65l.2,1.05a3.46,3.46,0,0,1,.47-.18l-.16-.87c-.42-2.33-.67-3.95-.81-4.57a15.87,15.87,0,0,1,.55,2.31c-.3-1.69-.51-3-.59-3.85s-.34-2.75-.63-4a82.11,82.11,0,0,1,2,10.13,18.75,18.75,0,0,1-.22-2l0,.22c-.51-3.74-.78-6.31-1-7.66a45,45,0,0,1,1.24,6.37c-.53-4-.8-7-.83-8.63a70.88,70.88,0,0,0-.82-9.19,19,19,0,0,1,.87,4.09c.42,2.6.92,6.31,1.43,10.73a6.58,6.58,0,0,1,0-1.16,24.51,24.51,0,0,0-.17-5c.15.45.54,3.71.91,8l0-2.83c0-4.52-.06-6.21-.38-10.84-.08-1.1,0-1.41.15-.69.53,3.6.86,8.11,1.08,13.31q.13,3.57.23,6.07l.11,0,0-1.87c0-2.83,0-3.89-.17-6.81,0-.69,0-.88.08-.42.27,2.26.44,5.1.55,8.37l0,.9c2.93,1.06,5.33,4.09,8.2,7.85ZM89.76,277.6l-.15-1.33c0,.83,0,1.56-.07,2.2l.18-.1C89.72,278.1,89.74,277.84,89.76,277.6Z"
              fill="#68c902"
            />
            <path
              d="M177.61,266.46c-2.94-1.42-6.26-2.64-9.77-4A56.07,56.07,0,0,1,157,256.94c-.43-.5-.85-1-1.27-1.55l.9.35c0-.13,0-.2-.08-.16a5.43,5.43,0,0,1,.69-1,5.37,5.37,0,0,0,.58-.67.62.62,0,0,1-.17.43,3.26,3.26,0,0,1,.52-.53,1.69,1.69,0,0,0,.51-.57,4.15,4.15,0,0,1-1,1.69.83.83,0,0,1,.32-.23l0,0a6.74,6.74,0,0,0,1-1.1,2.33,2.33,0,0,1-.52,1.14,6.16,6.16,0,0,1,1.2-1.17,3.68,3.68,0,0,0,1.18-1.33,7.38,7.38,0,0,1-1.28,2.56.65.65,0,0,1,.24-.1,1.21,1.21,0,0,0,.74-.65,4.61,4.61,0,0,1-.74,1.34,4.63,4.63,0,0,0,.51-.31,4.69,4.69,0,0,0,1.38-1.57c.12-.18.22-.18.17-.05a4.68,4.68,0,0,1-.25.64,1.52,1.52,0,0,1-.28.89,6.41,6.41,0,0,1,.94-1.19,3.82,3.82,0,0,0,.9-1.29c.15,0-.39,1.61-1.67,3.65a1.71,1.71,0,0,1,.6-.56l0,.08a14,14,0,0,0,1.74-2.46,5.23,5.23,0,0,1-.81,2.4,14,14,0,0,1,2.1-2.67,7.92,7.92,0,0,0,2-3c.19.1-.51,2.38-2,5.47a1.32,1.32,0,0,1,.44-.27,2.65,2.65,0,0,0,1.29-1.54,9.89,9.89,0,0,1-1.13,2.9c.31-.27.59-.45.91-.78a10.14,10.14,0,0,0,2.33-3.55c.18-.38.37-.42.32-.14a16.52,16.52,0,0,1-1.9,4.8,19.47,19.47,0,0,1-1.35,2.06l.2.06h0a7.88,7.88,0,0,0,.62-.55,6.05,6.05,0,0,0,1.45-2.24c.11-.24.24-.27.21-.09a10,10,0,0,1-1.16,3l-.14.24.65.24.1-.2a8.44,8.44,0,0,0,.52-1,.87.87,0,0,1-.1.6,4.62,4.62,0,0,1,.5-.85,2.38,2.38,0,0,0,.47-.9,5.92,5.92,0,0,1-.77,2.48,1.26,1.26,0,0,1,.33-.41l0,.06a10.18,10.18,0,0,0,.93-1.71,3.18,3.18,0,0,1-.35,1.6,8.07,8.07,0,0,1,1.19-1.85,5,5,0,0,0,1.15-2c.15.06-.17,1.57-1,3.64a.68.68,0,0,1,.27-.2,1.75,1.75,0,0,0,.78-1,6.6,6.6,0,0,1-.63,1.92c.19-.19.37-.32.56-.54a6.34,6.34,0,0,0,1.42-2.35c.11-.26.24-.28.22-.1a10.06,10.06,0,0,1-1.13,3.15q-.42.78-.78,1.32l.11.05c.13-.13.24-.21.37-.35a4.1,4.1,0,0,0,.89-1.48c.07-.16.15-.18.14-.06a6.48,6.48,0,0,1-.71,2l-.11.2a22.49,22.49,0,0,1,6.92,5.16Zm-17.73-9.76.16-.29c-.14.15-.28.28-.4.39l.09,0Z"
              fill="#68c902"
            />
            <path
              d="M150,257.4c-3.72,1.09-6.9,1.36-9.32,2a13.33,13.33,0,0,0-3,1.13,5.26,5.26,0,0,0-1.69,1.37,4.65,4.65,0,0,0-.68.15l-.1-.35c-.11,0-.15-.05-.09,0s-.69-.36-1.07-.6-.64-.42-.75-.47a.93.93,0,0,1,.41.18c-.27-.18-.48-.33-.6-.43a2.68,2.68,0,0,0-.62-.44,6,6,0,0,1,1.7,1,1.65,1.65,0,0,1-.28-.25l0,0c-.57-.44-.94-.78-1.16-.91a3.32,3.32,0,0,1,1.07.61,6.61,6.61,0,0,1-1.19-1.14,5.47,5.47,0,0,0-1.26-1.24,7.56,7.56,0,0,1,2.34,1.64.71.71,0,0,1-.11-.21,1.87,1.87,0,0,0-.58-.77,7.35,7.35,0,0,1,1.15,1l-.27-.48a8.39,8.39,0,0,0-1.26-1.65c-.14-.15-.13-.24,0-.16a4.05,4.05,0,0,1,.52.44,1.7,1.7,0,0,1,.72.57,6.71,6.71,0,0,1-.86-1.24,4.45,4.45,0,0,0-.91-1.27c.07-.17,1.32,1,2.72,2.92a2,2,0,0,1-.34-.71l.06.07a26,26,0,0,0-1.56-2.57,5.15,5.15,0,0,1,1.72,1.86,10.17,10.17,0,0,1-1.34-3.12A8.25,8.25,0,0,0,132,251c.29-.17,1.79,1.71,3.35,4.77a1.36,1.36,0,0,1,0-.51,3,3,0,0,0-.41-1.94,10,10,0,0,1,1.45,2.75c0-.4,0-.71-.06-1.16a12.67,12.67,0,0,0-.94-4.14c-.14-.4,0-.57.16-.33a15.7,15.7,0,0,1,1.92,4.79c.24.93.42,1.72.55,2.37l.13-.06v0c0-.28,0-.48,0-.79a8.9,8.9,0,0,0-.52-2.6c-.08-.26,0-.35.08-.2a12,12,0,0,1,1.08,3.06l.05.26.46-.16-.05-.21a11.34,11.34,0,0,0-.26-1.14,1.16,1.16,0,0,1,.27.54,4.08,4.08,0,0,1-.16-1,3.05,3.05,0,0,0-.2-1,6.32,6.32,0,0,1,.83,2.44,1.35,1.35,0,0,1,0-.51l0,.05a13.18,13.18,0,0,0-.31-1.91,3.61,3.61,0,0,1,.6,1.52,8.25,8.25,0,0,1-.16-2.19,6,6,0,0,0-.24-2.31c.15,0,.69,1.41,1.15,3.59a1,1,0,0,1,.08-.31,2,2,0,0,0,0-1.28,7.25,7.25,0,0,1,.5,1.95c0-.26.09-.46.12-.75a7.82,7.82,0,0,0-.12-2.73c0-.27,0-.36.11-.19a11.68,11.68,0,0,1,.69,3.26c.06.6.08,1.11.08,1.53h.11c0-.17.06-.3.08-.49a4.68,4.68,0,0,0-.07-1.71c0-.17,0-.23.07-.12a7.5,7.5,0,0,1,.43,2.05v.23c2.86-.22,5.39.15,8.57-.07Q150.76,256.91,150,257.4Zm-14.76,2.74-.23-.24.33.44v0Z"
              fill="#68c902"
            />
            <path
              d="M228.84,255.68a79.77,79.77,0,0,0-31.24,11.14l-2.38.92.89-.87c-.12-.06-.22-.05-.23.05a4.8,4.8,0,0,1-.72-1,4.69,4.69,0,0,0-.38-.8.53.53,0,0,1,.37.3,2.27,2.27,0,0,1-.26-.72,1.24,1.24,0,0,0-.31-.71c.07-.09.72.47,1.26,1.52a.59.59,0,0,1,0-.42l0,0a5,5,0,0,0-.55-1.39,1.69,1.69,0,0,1,.92.87,3.86,3.86,0,0,1-.42-1.66,2.6,2.6,0,0,0-.57-1.7c.17-.1,1,.73,1.89,2.19a.72.72,0,0,1,.08-.3,1,1,0,0,0-.12-1,3.24,3.24,0,0,1,.88,1.25c0-.23.07-.42.08-.66a3.52,3.52,0,0,0-.52-2.06c-.1-.19,0-.3.11-.21a3.9,3.9,0,0,1,.48.51c.19,0,.53.25.73.64a4.16,4.16,0,0,1-.43-1.49,2.48,2.48,0,0,0-.54-1.48c.17-.19,1.42,1,2.36,3.25a1.38,1.38,0,0,1,0-.86l0,.08a10.58,10.58,0,0,0-.89-2.91,3.37,3.37,0,0,1,1.74,1.92,7.84,7.84,0,0,1-.56-3.47,5.06,5.06,0,0,0-.82-3.56c.41-.19,2,1.64,3.48,4.76a1.35,1.35,0,0,1,.22-.6,2.08,2.08,0,0,0,0-2.12,6.1,6.1,0,0,1,1.54,2.72c.09-.46.24-.83.31-1.33a7,7,0,0,0-.54-4.32c-.15-.41.08-.62.29-.41a9.4,9.4,0,0,1,2.21,4.68,15.32,15.32,0,0,1,.33,2.48l.28-.13v0c.07-.32.18-.56.23-.89a4.58,4.58,0,0,0-.31-2.72c-.09-.25.05-.39.18-.25a6.16,6.16,0,0,1,1.33,3l0,.27c.31-.14.64-.26,1-.39a1,1,0,0,1-.06-.22,5.49,5.49,0,0,0-.27-1.13c.11,0,.32.21.4.48a2.64,2.64,0,0,1-.13-1,1.56,1.56,0,0,0-.21-1c.13-.1.81.79,1.21,2.3a.9.9,0,0,1,.06-.56l0,.06a6.67,6.67,0,0,0-.31-2,2.21,2.21,0,0,1,.94,1.4,5.17,5.17,0,0,1-.06-2.27,3.34,3.34,0,0,0-.24-2.35c.26-.09,1.14,1.22,1.82,3.34a.75.75,0,0,1,.19-.36,1.34,1.34,0,0,0,.15-1.36,4,4,0,0,1,.78,1.87,7.39,7.39,0,0,0,.29-.83,4.44,4.44,0,0,0,0-2.82c-.06-.27.1-.39.21-.24a6.17,6.17,0,0,1,1.09,3.16,10.93,10.93,0,0,1,.05,1.57l.19-.05a5,5,0,0,0,.2-.54,2.78,2.78,0,0,0,0-1.76c0-.17.06-.24.13-.14a4,4,0,0,1,.67,2v.23a42.17,42.17,0,0,1,13.93-.68Zm-29.46,8.07-.18-.28c0,.21.07.4.09.58l.11-.09A1.49,1.49,0,0,1,199.38,263.75Z"
              fill="#68c902"
            />
            <path
              d="M60.79,280.19c-3.18-.23-6.62-.21-10.28-.37a88.23,88.23,0,0,1-11.06-1.21,180.63,180.63,0,0,1-20.89-5.19L15.7,272l1.53.2c-.05-.14-.14-.21-.24-.16a3.91,3.91,0,0,1,.28-1.2,4,4,0,0,0,.38-.81.52.52,0,0,1,.05.49,1.87,1.87,0,0,1,.4-.65,1,1,0,0,0,.35-.69c.14,0,.2.87-.26,2a.71.71,0,0,1,.33-.3l0,0a4,4,0,0,0,.73-1.31,1.49,1.49,0,0,1,0,1.29,3.7,3.7,0,0,1,1.05-1.4,2.23,2.23,0,0,0,.94-1.55c.23.07.26,1.28-.22,2.9a.83.83,0,0,1,.31-.14,1,1,0,0,0,.75-.77,2.75,2.75,0,0,1-.27,1.52c.2-.14.4-.22.61-.38a3,3,0,0,0,1.22-1.79c.07-.2.24-.21.26-.06a2.81,2.81,0,0,1,0,.71,1,1,0,0,1,.12,1,3.82,3.82,0,0,1,.8-1.34,2.12,2.12,0,0,0,.69-1.42c.28,0,.42,1.76-.48,4a1.39,1.39,0,0,1,.66-.62l0,.08a8.46,8.46,0,0,0,1.43-2.7,3,3,0,0,1,.1,2.62,7.51,7.51,0,0,1,2.06-2.9,4.61,4.61,0,0,0,1.8-3.22c.45.12.58,2.59-.27,5.91a1.49,1.49,0,0,1,.62-.29,2,2,0,0,0,1.44-1.64c.2.23.11,1.51-.4,3.1a12.92,12.92,0,0,0,1.19-.84,6,6,0,0,0,2.24-3.77c.12-.42.45-.46.51-.16a8.56,8.56,0,0,1-.81,5.1,11.84,11.84,0,0,1-1.29,2.2l.38.07,0,0c.28-.22.54-.34.81-.59a3.72,3.72,0,0,0,1.39-2.39c.07-.26.29-.28.33-.1a5.3,5.3,0,0,1-.46,3.22l-.12.24,1.29.24a1.42,1.42,0,0,1,.07-.22,4.36,4.36,0,0,0,.39-1.1.63.63,0,0,1,.14.63,2.48,2.48,0,0,1,.44-.91,1.36,1.36,0,0,0,.36-1c.18,0,.39,1.11,0,2.61a.89.89,0,0,1,.39-.44v.06a5.34,5.34,0,0,0,.75-1.83,1.94,1.94,0,0,1,.24,1.68,4.9,4.9,0,0,1,1.15-2,2.93,2.93,0,0,0,.93-2.19c.3.05.56,1.63.24,3.83a.94.94,0,0,1,.39-.24,1.29,1.29,0,0,0,.82-1.16,3.53,3.53,0,0,1,0,2,8.42,8.42,0,0,0,.72-.62,3.93,3.93,0,0,0,1.18-2.6c.05-.27.26-.32.32-.13a5.46,5.46,0,0,1-.15,3.34,8.44,8.44,0,0,1-.65,1.46l.25,0a6.14,6.14,0,0,0,.47-.42,2.36,2.36,0,0,0,.73-1.63c0-.17.16-.21.2-.09a3.31,3.31,0,0,1-.06,2.1l-.08.22c3.41.46,6.39.73,9.09,1.14A45.7,45.7,0,0,1,63.64,280C62.7,280,61.75,280.1,60.79,280.19Zm-38-7.36.07-.33c-.14.17-.27.32-.4.45l.17,0A.75.75,0,0,1,22.76,272.83Z"
              fill="#68c902"
            />
            <path
              d="M9.26,264.6h0l-1.15-.17-1.41-.19q-2.82-.33-5.67-.45l-1-.55L.52,263c0-.12-.06-.16-.09-.09,0-.09,0-.78,0-1.23a7.82,7.82,0,0,0,.08-.88,1.12,1.12,0,0,1,0,.46,4.11,4.11,0,0,1,.1-.74,3.39,3.39,0,0,0,.07-.76,6.52,6.52,0,0,1,0,2,1.12,1.12,0,0,1,.09-.38v0A12.22,12.22,0,0,0,1,259.93a3.52,3.52,0,0,1,.08,1.24,7.84,7.84,0,0,1,.29-1.63,5.79,5.79,0,0,0,.24-1.74,9.64,9.64,0,0,1,.08,2.85.65.65,0,0,1,.1-.22,1.65,1.65,0,0,0,.23-.93A7,7,0,0,1,2,261c.07-.18.13-.31.2-.52a7.4,7.4,0,0,0,.35-2c0-.21.08-.26.1-.12s0,.44,0,.68a2.24,2.24,0,0,1,.08.92,9,9,0,0,1,.24-1.5,5.67,5.67,0,0,0,.2-1.55,12.84,12.84,0,0,1,0,4,2.46,2.46,0,0,1,.22-.76v.09a25.67,25.67,0,0,0,.45-3,7,7,0,0,1,.09,2.52,15.79,15.79,0,0,1,.71-3.29A10.93,10.93,0,0,0,5.31,253c.19,0,.26,2.39-.06,5.8a1.39,1.39,0,0,1,.23-.42A3.51,3.51,0,0,0,6,256.46a14.83,14.83,0,0,1-.19,3.1c.15-.36.3-.63.45-1a14.91,14.91,0,0,0,1-4.11c.06-.42.2-.52.21-.24A21.28,21.28,0,0,1,7,259.31c-.18.94-.37,1.73-.55,2.37h.13v0c.11-.26.21-.44.32-.72a9.45,9.45,0,0,0,.61-2.57c0-.27.12-.33.13-.15a14.32,14.32,0,0,1-.33,3.22l-.06.27.45,0,0-.22c.12-.58.21-1,.22-1.14a1.52,1.52,0,0,1,0,.6,5.94,5.94,0,0,1,.22-.95,3.7,3.7,0,0,0,.19-1,8.08,8.08,0,0,1-.2,2.57,1.7,1.7,0,0,1,.17-.48v.06a16.28,16.28,0,0,0,.41-1.9,4.36,4.36,0,0,1-.05,1.63,10.67,10.67,0,0,1,.59-2.1,7,7,0,0,0,.56-2.25,12.09,12.09,0,0,1-.28,3.75.78.78,0,0,1,.16-.26,2.43,2.43,0,0,0,.44-1.19,9.29,9.29,0,0,1-.28,2c.11-.23.2-.4.31-.66a14.39,14.39,0,0,0,1-2.56c.08-.26.2-.31.19-.12a13.27,13.27,0,0,1-.91,3.21l-.53,1.44,0,0,.21-.43a14.8,14.8,0,0,0,.69-1.58c.06-.17.12-.2.09-.09a12.52,12.52,0,0,1-.73,2l-.09.21a1.11,1.11,0,0,1,.54.76,1.4,1.4,0,0,1-.51,1.27c-.08,0-.1.18-.15.3l-.12.43-.36-.37a1.55,1.55,0,0,0-.17-.13Zm-6.84-2.49v-.34c0,.21-.08.39-.12.55l.06,0Z"
              fill="#68c902"
            />
            <path
              d="M72.81,273.8a16.48,16.48,0,0,0-5.56.05l-.51-.42.16-.28c0-.12-.06-.15-.06-.08,0-.09-.17-.76-.25-1.2s-.12-.75-.15-.87a2.9,2.9,0,0,1,.11.44c0-.32-.09-.58-.11-.73a5.31,5.31,0,0,0-.12-.76,15.94,15.94,0,0,1,.42,1.92,2.35,2.35,0,0,1,0-.38v0c-.1-.71-.17-1.2-.22-1.45a7.85,7.85,0,0,1,.28,1.19,14.75,14.75,0,0,1-.19-1.63,13,13,0,0,0-.23-1.73,3.19,3.19,0,0,1,.2.76c.11.49.24,1.19.39,2a.76.76,0,0,1,0-.22,3.41,3.41,0,0,0-.07-1c0,.08.15.69.27,1.5v-.54a17.82,17.82,0,0,0-.2-2c0-.21,0-.27,0-.14l.13.67a3.83,3.83,0,0,1,.2.89c-.08-.66-.13-1.18-.14-1.5a13,13,0,0,0-.17-1.55,23.3,23.3,0,0,1,.65,3.93,4.91,4.91,0,0,1,0-.77v.09c-.12-1.46-.17-2.46-.26-3a12.74,12.74,0,0,1,.44,2.47,28,28,0,0,1-.15-3.35,20,20,0,0,0-.17-3.56,6.12,6.12,0,0,1,.33,1.58c.15,1,.31,2.45.46,4.16a1.71,1.71,0,0,1,.06-.45,6.51,6.51,0,0,0,0-1.94,24.55,24.55,0,0,1,.3,3.09l.09-1.09a29.42,29.42,0,0,0,0-4.2c0-.43,0-.54.09-.26a40.62,40.62,0,0,1,.31,5.15v2.42h.06v0l.07-.74a21.08,21.08,0,0,0,0-2.64c0-.27,0-.34,0-.17a29.65,29.65,0,0,1,.15,3.24V271l.2,0v-.23c0-.59,0-1,0-1.16a2.77,2.77,0,0,1,.05.6c0-.43,0-.77,0-1a8,8,0,0,0,0-1,17.81,17.81,0,0,1,.11,2.58,3.27,3.27,0,0,1,0-.5v.06c0-.95.07-1.6,0-1.94a9.53,9.53,0,0,1,.1,1.62,19.68,19.68,0,0,1,.13-2.16,13.93,13.93,0,0,0,.13-2.3,4.24,4.24,0,0,1,.09,1c0,.66,0,1.59,0,2.7a1.38,1.38,0,0,1,.06-.28,4.63,4.63,0,0,0,.14-1.25,18.05,18.05,0,0,1,0,2l.12-.7a18.43,18.43,0,0,0,.25-2.7c0-.28.06-.35.07-.17a28.81,28.81,0,0,1-.1,3.34l-.13,1.51h0l.09-.46a13.26,13.26,0,0,0,.16-1.69c0-.18,0-.22,0-.11a18,18,0,0,1-.08,2.1l0,.23a4.25,4.25,0,0,1,2.23,2.21ZM67.5,272l-.06-.33,0,.55,0,0Z"
              fill="#68c902"
            />
            <path
              d="M90,280.69a59.21,59.21,0,0,1-8.22-4.8,30,30,0,0,0-6.35-3.44l-.72-.74.5-.12c0-.12,0-.16,0-.1,0-.09.17-.76.31-1.18s.27-.72.3-.84a1,1,0,0,1-.07.46,3.65,3.65,0,0,1,.28-.69,2.71,2.71,0,0,0,.27-.72,6.12,6.12,0,0,1-.47,1.9,1,1,0,0,1,.18-.34v0a12,12,0,0,0,.56-1.36A3.21,3.21,0,0,1,76.3,270a7.85,7.85,0,0,1,.74-1.48,4.92,4.92,0,0,0,.77-1.58,8.18,8.18,0,0,1-.77,2.75.65.65,0,0,1,.17-.17,1.76,1.76,0,0,0,.52-.82,6.59,6.59,0,0,1-.51,1.44l.36-.43a7,7,0,0,0,1-1.79c.09-.19.17-.21.14-.08s-.12.43-.2.66a1.75,1.75,0,0,1-.23.89,7.27,7.27,0,0,1,.77-1.31,4.87,4.87,0,0,0,.75-1.37c.15,0-.33,1.59-1.45,3.72a2.24,2.24,0,0,1,.49-.62l0,.08a23.08,23.08,0,0,0,1.55-2.57,5.83,5.83,0,0,1-.83,2.39,12.44,12.44,0,0,1,2-2.73A9.33,9.33,0,0,0,83.64,264c.21.11-.63,2.34-2.34,5.32a1.27,1.27,0,0,1,.41-.27,3.19,3.19,0,0,0,1.34-1.46,11.91,11.91,0,0,1-1.45,2.76c.3-.26.57-.44.89-.74a12.93,12.93,0,0,0,2.69-3.26c.23-.36.42-.38.31-.11a18.83,18.83,0,0,1-2.62,4.44c-.58.77-1.09,1.39-1.54,1.89l.13.07h0c.22-.19.39-.29.62-.5a8.55,8.55,0,0,0,1.7-2c.15-.22.26-.23.19-.07a12.75,12.75,0,0,1-1.68,2.78l-.16.21.44.26.13-.18c.35-.48.62-.79.69-.94a1.3,1.3,0,0,1-.24.56,5.64,5.64,0,0,1,.62-.76,3.23,3.23,0,0,0,.61-.81,7,7,0,0,1-1.27,2.25,1.93,1.93,0,0,1,.38-.35l0,.05a13.61,13.61,0,0,0,1.2-1.52,4,4,0,0,1-.71,1.47,9.27,9.27,0,0,1,1.46-1.63,6.21,6.21,0,0,0,1.47-1.79A11.36,11.36,0,0,1,85.12,273a.94.94,0,0,1,.28-.16,2,2,0,0,0,.91-.9,8.1,8.1,0,0,1-1,1.74c.21-.16.38-.26.6-.45a8.21,8.21,0,0,0,1.78-2.07c.16-.23.27-.24.2-.07a12.81,12.81,0,0,1-1.75,2.84q-.56.71-1,1.17l.08.06c.14-.11.25-.17.4-.3a5,5,0,0,0,1.12-1.3c.09-.14.17-.15.12-.05a8,8,0,0,1-1.08,1.8l-.15.18c2.2,1.76,3.84,3.54,6.1,5.38C91.16,280.79,90.6,280.75,90,280.69Zm-12.81-9.42.13-.31-.3.47h.07Z"
              fill="#68c902"
            />
          </g>
          <circle cx="94.5" cy="57.85" r="14.05" fill="#f1ba0e" />
          <path
            d="M100.24,65A14,14,0,0,1,87.15,45.9a14,14,0,1,0,20.45,17A14,14,0,0,1,100.24,65Z"
            fill="#e88803"
          />
          <path
            d="M80.19,94.53A2.66,2.66,0,0,0,79,90.93a5.24,5.24,0,0,0-4.18,0c-2.06.75-4.1,2.82-3.35,4.88A4.64,4.64,0,0,0,68,99a39.25,39.25,0,0,0-1.06,4.86,14.31,14.31,0,0,1-4.74,7.66c-1.26,1-2.77,2-3.38,3.47-.28.67-.34,1.4-.56,2.1-1,3.14-4.73,4.79-5.69,7.94.1-.62-.66-1.1-1.27-1a3,3,0,0,0-1.5,1.09A7.69,7.69,0,0,0,48,127.81a2.62,2.62,0,0,0,.74,2.9,31.22,31.22,0,0,0-5.29-2.9,3.4,3.4,0,0,0-1.61-.4,2.46,2.46,0,0,0-2,2.29,7.11,7.11,0,0,0,.7,3.18,1.76,1.76,0,0,0-2.28-1.47,2.86,2.86,0,0,0-1.77,2.41,8.27,8.27,0,0,0,.38,3.11,11.53,11.53,0,0,0-8.48-2.05,13,13,0,0,1,.87,4.56,16.5,16.5,0,0,0-6.37.6c-1.86.64-3.5,2.36-3.37,4.31s2.66,3.51,4.2,2.3a9.13,9.13,0,0,0,4.4,5.17,27.08,27.08,0,0,0,6.51,2.41,4,4,0,0,0,2,.19,1.36,1.36,0,0,0,1.08-1.5,9.08,9.08,0,0,0,3.37,6.5,7.86,7.86,0,0,0,5.78,2.26c2.12-.21,4.15-2,4-4.15.31,3,3.37,5.09,6.2,6a5.73,5.73,0,0,0,4.07.14,2.59,2.59,0,0,0,1.47-3.39,6.14,6.14,0,0,0,1.62,3.12c.91.76,2.53.78,3.1-.26,1.4,3.76,4.82,6.49,8.55,8s7.78,2,11.78,2.39c-.11-1.71.11-3.92,1.76-4.4a7.1,7.1,0,0,1,1.73-.08c3-.12,4.93-4.24,3.1-6.62-2.35-3.05-4.74-7-8.59-6.78a4.46,4.46,0,0,0-3.58-8.06A22.45,22.45,0,0,0,70,139.35l.12,2.25c0-1.39,0-3.63,0-5,.21,1,1.73.62,2.51,0a23.78,23.78,0,0,0,6.23-8.08c.25-.53.53-1.13,1.09-1.32a3.29,3.29,0,0,1,.89-.1c2.46-.17,3.57-3.11,4.1-5.52a5.51,5.51,0,0,1,2,2.85,2.55,2.55,0,0,0,1.66-2.14,61.65,61.65,0,0,0,4.24,7.68,3,3,0,0,0,1.69,1.43c.74.16,1.65-.58,1.34-1.27-.52-.36-1,.46-1.13,1.09A16.17,16.17,0,0,0,95,137c.21.85.89,1.89,1.7,1.56A9.51,9.51,0,0,0,99,145.68a3.24,3.24,0,0,0,1.55,1.12,3.78,3.78,0,0,0,2.76-.71,35.1,35.1,0,0,0,6.17-4.53,3.25,3.25,0,0,0,1.19-1.74c.21-1.24-.94-2.25-2-2.93a39.22,39.22,0,0,0-8.13-4c.61-2.64,1.22-5.49.22-8s-3.61-4.33-6-5.84a22,22,0,0,0-7-3.27,13,13,0,0,0,6-4.16c2.23-3.13,1.69-7.37,1-11.16a4.17,4.17,0,0,0-4.47,2,4.07,4.07,0,0,0-4.45-6.6,3.2,3.2,0,0,0-1.87-4C82.41,91.25,80.64,92.94,80.19,94.53Z"
            fill="#527e23"
          />
          <path
            d="M69.44,143.24c1-3.69-1.41-7.37-3.72-10.43A4.37,4.37,0,0,0,63.6,131c-.92-.25-2.11.42-2,1.36a44.08,44.08,0,0,0-8.68-8.14l0,0a5.24,5.24,0,0,0-.36.88c.1-.62-.66-1.1-1.27-1a3,3,0,0,0-1.5,1.09A7.69,7.69,0,0,0,48,127.81a2.62,2.62,0,0,0,.74,2.9,31.22,31.22,0,0,0-5.29-2.9,3.4,3.4,0,0,0-1.61-.4,2.46,2.46,0,0,0-2,2.29,5.55,5.55,0,0,0,.39,2.34,1.91,1.91,0,0,0-2-.63,2.86,2.86,0,0,0-1.77,2.41,8.27,8.27,0,0,0,.38,3.11,11.53,11.53,0,0,0-3.17-1.6,6.62,6.62,0,0,0,1.48,1.6,37.49,37.49,0,0,0-.49,5.38,6.07,6.07,0,0,0,2.19,4.75c1.47,1.05,3.86.86,4.76-.7a2.79,2.79,0,0,0,2.56,2.53,3,3,0,0,0,2.83-2.39,3.27,3.27,0,0,0,5.25,1.06,10.13,10.13,0,0,0,10.22,6c.86,2.9,3.67,4.92,6.63,5.59a8.27,8.27,0,0,0,5.55-.5,5.15,5.15,0,0,0,2.9-4.53C77.45,149.48,70.29,147.84,69.44,143.24Z"
            fill="#6c9b23"
          />
          <path
            d="M76.75,90.74a2.9,2.9,0,0,0-2.65,3,2.73,2.73,0,0,0-3,3.52c-2.14,0-4.84.31-5.49,2.35-.46,1.4.36,3-.11,4.39-.18.52-.51,1-.7,1.47a5.41,5.41,0,0,0,.13,3.08,6,6,0,0,0-3.71,2c-.81,1.19-.31,3.27,1.13,3.39-1.77.16-2.58,2.68-1.54,4.11a4.06,4.06,0,0,0,4.83,1,9,9,0,0,0,3.75-3.67,3.36,3.36,0,0,0,4.47,1.52c2.09-1.12,2.31-4,2.26-6.34a1.55,1.55,0,0,0,2,.62,3.74,3.74,0,0,0,1.61-1.59,16.51,16.51,0,0,0,2.55-8.33,4.4,4.4,0,0,0,1.48,1.93,1.52,1.52,0,0,0,2.13-.45,1.59,1.59,0,0,0,1.45,1.73,2.6,2.6,0,0,0,2.17-1.12,4,4,0,0,0-.27-5C88,97,85.93,96.7,84.62,95.42,82.73,93.57,79.72,90.59,76.75,90.74Z"
            fill="#6c9b23"
          />
          <g>
            <path
              d="M77.83,108.46c-.77.89-2.31,1.6-3,1s-.15-2.19.62-3.08a1.55,1.55,0,0,1,2.34,2Z"
              fill="#e4f6fb"
            />
            <path
              d="M77.62,112c-1.16-.15-2.61-1-2.49-1.9s1.74-1.33,2.9-1.17a1.55,1.55,0,0,1-.41,3.07Z"
              fill="#e4f6fb"
            />
            <path
              d="M74.35,113.26c-.42-1.1-.33-2.79.47-3.1s2,.89,2.43,2a1.55,1.55,0,0,1-2.9,1.11Z"
              fill="#e4f6fb"
            />
            <path
              d="M72.07,109.82c1-.54,2.74-.63,3.13.13s-.66,2.09-1.71,2.63a1.55,1.55,0,0,1-1.42-2.76Z"
              fill="#e4f6fb"
            />
            <path
              d="M74.14,106.83c1,.68,1.83,2.14,1.34,2.84s-2.16.38-3.12-.3a1.55,1.55,0,0,1,1.78-2.54Z"
              fill="#e4f6fb"
            />
            <circle cx="75.05" cy="109.76" r="1.24" fill="#feaf26" />
          </g>
          <g>
            <path
              d="M62.55,130.66c-.57.66-1.72,1.19-2.2.77s-.11-1.63.46-2.29a1.16,1.16,0,0,1,1.74,1.52Z"
              fill="#e4f6fb"
            />
            <path
              d="M62.39,133.29c-.86-.11-1.94-.78-1.85-1.41s1.29-1,2.16-.88a1.16,1.16,0,0,1-.31,2.29Z"
              fill="#e4f6fb"
            />
            <path
              d="M60,134.24c-.32-.82-.25-2.08.35-2.31s1.49.66,1.81,1.48a1.16,1.16,0,0,1-2.16.83Z"
              fill="#e4f6fb"
            />
            <path
              d="M58.26,131.68c.78-.41,2-.48,2.33.09s-.49,1.56-1.27,2a1.15,1.15,0,0,1-1.06-2Z"
              fill="#e4f6fb"
            />
            <path
              d="M59.81,129.45c.71.5,1.36,1.59,1,2.11s-1.61.28-2.33-.22a1.16,1.16,0,0,1,1.34-1.89Z"
              fill="#e4f6fb"
            />
            <circle cx="60.48" cy="131.63" r="0.93" fill="#feaf26" />
          </g>
          <g>
            <path
              d="M63,115.15c-.83.95-2.5,1.72-3.2,1.11s-.16-2.36.67-3.32A1.68,1.68,0,0,1,63,115.15Z"
              fill="#e4f6fb"
            />
            <path
              d="M62.79,119c-1.26-.17-2.82-1.13-2.7-2s1.89-1.44,3.14-1.27a1.67,1.67,0,0,1-.44,3.32Z"
              fill="#e4f6fb"
            />
            <path
              d="M59.25,120.33c-.45-1.19-.35-3,.52-3.35s2.16,1,2.62,2.15a1.68,1.68,0,0,1-3.14,1.2Z"
              fill="#e4f6fb"
            />
            <path
              d="M56.79,116.62c1.13-.59,3-.69,3.38.13s-.71,2.26-1.84,2.84a1.67,1.67,0,0,1-1.54-3Z"
              fill="#e4f6fb"
            />
            <path
              d="M59,113.39c1,.73,2,2.3,1.45,3.06s-2.34.41-3.38-.32A1.68,1.68,0,0,1,59,113.39Z"
              fill="#e4f6fb"
            />
            <circle cx="60.02" cy="116.55" r="1.34" fill="#feaf26" />
          </g>
          <g>
            <path
              d="M38.89,134.64c-.84,1-2.5,1.73-3.2,1.12s-.17-2.36.67-3.32a1.68,1.68,0,0,1,2.53,2.2Z"
              fill="#e4f6fb"
            />
            <path
              d="M38.66,138.46c-1.26-.17-2.82-1.13-2.7-2.05s1.88-1.44,3.14-1.27a1.67,1.67,0,0,1-.44,3.32Z"
              fill="#e4f6fb"
            />
            <path
              d="M35.12,139.83c-.46-1.19-.35-3,.51-3.35s2.17,1,2.62,2.15a1.47,1.47,0,0,1-1,2.14A1.48,1.48,0,0,1,35.12,139.83Z"
              fill="#e4f6fb"
            />
            <path
              d="M32.65,136.12c1.13-.59,3-.69,3.39.13s-.71,2.26-1.84,2.84a1.68,1.68,0,0,1-1.55-3Z"
              fill="#e4f6fb"
            />
            <path
              d="M34.9,132.88c1,.74,2,2.31,1.44,3.07s-2.33.41-3.37-.32a1.68,1.68,0,0,1,1.93-2.75Z"
              fill="#e4f6fb"
            />
            <circle cx="35.88" cy="136.05" r="1.34" fill="#feaf26" />
          </g>
          <g>
            <path
              d="M54.31,145.69c-.6.68-1.8,1.24-2.3.8s-.12-1.7.48-2.39a1.21,1.21,0,0,1,1.82,1.59Z"
              fill="#e4f6fb"
            />
            <path
              d="M54.14,148.43c-.9-.12-2-.82-1.93-1.48s1.35-1,2.25-.91a1.21,1.21,0,0,1-.32,2.39Z"
              fill="#e4f6fb"
            />
            <path
              d="M51.6,149.41c-.33-.85-.25-2.17.37-2.41s1.56.7,1.88,1.55a1.2,1.2,0,0,1-2.25.86Z"
              fill="#e4f6fb"
            />
            <path
              d="M49.83,146.74c.81-.42,2.13-.49,2.43.1s-.51,1.62-1.32,2a1.21,1.21,0,0,1-1.11-2.14Z"
              fill="#e4f6fb"
            />
            <path
              d="M51.44,144.42c.75.53,1.42,1.66,1,2.2s-1.68.3-2.43-.23a1.21,1.21,0,0,1,1.39-2Z"
              fill="#e4f6fb"
            />
            <circle cx="52.15" cy="146.69" r="0.97" fill="#feaf26" />
          </g>
          <g>
            <path
              d="M50.78,125.67c-.6.69-1.8,1.25-2.3.81s-.12-1.7.48-2.39a1.21,1.21,0,0,1,1.82,1.58Z"
              fill="#e4f6fb"
            />
            <path
              d="M50.61,128.42c-.9-.12-2-.82-1.94-1.48s1.36-1,2.26-.91a1.21,1.21,0,0,1-.32,2.39Z"
              fill="#e4f6fb"
            />
            <path
              d="M48.07,129.4c-.33-.85-.25-2.17.37-2.41s1.55.7,1.88,1.55a1.2,1.2,0,0,1-2.25.86Z"
              fill="#e4f6fb"
            />
            <path
              d="M46.3,126.73c.81-.42,2.13-.49,2.43.1s-.51,1.62-1.32,2a1.21,1.21,0,0,1-1.11-2.14Z"
              fill="#e4f6fb"
            />
            <path
              d="M47.91,124.41c.75.53,1.42,1.66,1,2.2s-1.68.3-2.43-.23a1.21,1.21,0,0,1,1.39-2Z"
              fill="#e4f6fb"
            />
            <circle cx="48.62" cy="126.68" r="0.97" fill="#feaf26" />
          </g>
          <g>
            <path
              d="M76.72,90.69c-1.16,1.33-3.47,2.39-4.44,1.55s-.23-3.28.93-4.61a2.33,2.33,0,0,1,3.51,3.06Z"
              fill="#e4f6fb"
            />
            <path
              d="M76.4,96c-1.75-.23-3.91-1.57-3.74-2.85s2.61-2,4.36-1.76A2.33,2.33,0,0,1,76.4,96Z"
              fill="#e4f6fb"
            />
            <path
              d="M71.49,97.88c-.63-1.65-.49-4.19.71-4.65s3,1.34,3.64,3a2.33,2.33,0,0,1-4.35,1.67Z"
              fill="#e4f6fb"
            />
            <path
              d="M68.07,92.73c1.57-.81,4.11-1,4.7.18s-1,3.14-2.56,4a2.33,2.33,0,0,1-2.14-4.13Z"
              fill="#e4f6fb"
            />
            <path
              d="M71.19,88.25c1.44,1,2.74,3.2,2,4.25s-3.24.56-4.68-.45a2.33,2.33,0,0,1,2.68-3.8Z"
              fill="#e4f6fb"
            />
            <circle cx="72.55" cy="92.63" r="1.86" fill="#feaf26" />
          </g>
          <path
            d="M128.16,103.31a3.25,3.25,0,0,0,.91,4.8,1.89,1.89,0,1,0-2.53,2.74c-.79-.39-1.69.57-1.63,1.45a5,5,0,0,0,1.15,2.34,2.66,2.66,0,0,1,.56,2.46c-.34.75-1.22,1.08-1.83,1.64a2.95,2.95,0,0,0,2.38,5.11,9.4,9.4,0,0,0-4.28,7,27.68,27.68,0,0,0,.56,8.45,11,11,0,0,0,6.12-1.6,10.65,10.65,0,0,0-.65,13.32,1.79,1.79,0,0,0,1-2.3c-.77,1.39.61,3.26,2.19,3.33a4,4,0,0,0,3.59-2.66,11.75,11.75,0,0,0,.57-4.69,5,5,0,0,0,6.58,3.81,5.46,5.46,0,0,0,2.6-7.35c3.22,2.67,9,.94,10.15-3.07-.29,1,.94,2.08,2,1.83a2.45,2.45,0,0,0,1.68-2.5,4.9,4.9,0,0,0-1.34-2.9,10,10,0,0,0-5-3.1c.45-2.6.88-5.36-.09-7.82s-3.89-4.35-6.29-3.23c.78-3.32.64-7.07-1.4-9.8-1.94-2.58-6.19-3.87-8.87-1.66C140.26,106,131.53,99.17,128.16,103.31Z"
            fill="#527e23"
          />
          <path
            d="M144.1,131.32a13.81,13.81,0,0,0-5.94-10.3,5.9,5.9,0,0,0-2.57-8.82,5.29,5.29,0,0,0,1.13-3.61,4.48,4.48,0,0,0-.44.32,2.92,2.92,0,0,0,.44-.41,8.15,8.15,0,0,0-2.24-5.1q-.34-.34-.78-.72c-1.92-.93-4.17-1.05-5.54.63a3.35,3.35,0,0,0,.21,4.28,1.87,1.87,0,0,0-1.83,3.26c-.79-.39-1.69.57-1.63,1.45a5,5,0,0,0,1.15,2.34,2.66,2.66,0,0,1,.56,2.46c-.34.75-1.22,1.08-1.83,1.64a2.95,2.95,0,0,0,2.38,5.11,9.4,9.4,0,0,0-4.28,7,21,21,0,0,0,.13,5.71,3.91,3.91,0,0,0,3.84-2.95,5.19,5.19,0,0,0,5.08,4.53,4.8,4.8,0,0,0,4.46-4.4,3.87,3.87,0,0,0,2.13,3,3.82,3.82,0,0,0,4.15-.67A5.93,5.93,0,0,0,144.1,131.32Z"
            fill="#6c9b23"
          />
        </g>
        <g transform="translate(40 390)">
          <path
            d="M10.4,314.45c-.61-.1-.92-.39-.92-.88s0-.76,0-1.1a4.78,4.78,0,0,1,.08-.9.75.75,0,0,1,.29-.54,1,1,0,0,1,.53-.15c.2,0,.55,0,1,.07q.74-2.25,1.57-4.45c.56-1.46,1.11-2.85,1.65-4.15a1.41,1.41,0,0,1,1-.89c.4-.08.81-.14,1.24-.19a10.16,10.16,0,0,1,1.18-.07h.57l.46,0a1.34,1.34,0,0,1,1.1.78c.48.94,1.05,2.17,1.72,3.7s1.33,3.23,2,5.08l.57,0,.31,0,.14,0H25a.79.79,0,0,1,.83.67,5.46,5.46,0,0,1,.16,1.36v.38a1.9,1.9,0,0,1-.05.4,1,1,0,0,1-.28.64,1,1,0,0,1-.59.23c.1.36.2.69.28,1s.16.6.22.84a3.28,3.28,0,0,1,.08.38,1.21,1.21,0,0,1,0,.18.69.69,0,0,1-.55.73,11.11,11.11,0,0,1-1.41.33,8.07,8.07,0,0,1-1.48.13.9.9,0,0,1-.63-.19,1.52,1.52,0,0,1-.32-.61l-.64-2.4c-.88.05-1.76.07-2.65.07-.56,0-1.13,0-1.69,0s-1.1,0-1.64-.07c-.11.45-.21.88-.3,1.3s-.18.83-.25,1.23a.83.83,0,0,1-.9.78,7.62,7.62,0,0,1-1.41-.14,9.6,9.6,0,0,1-1.39-.32.73.73,0,0,1-.58-.76s0-.1,0-.16l.06-.32c.05-.24.11-.54.2-.88S10.3,314.81,10.4,314.45ZM15.72,311H17.6l1.91,0c-.29-.93-.61-1.86-.94-2.78s-.7-1.79-1.08-2.62c-.34.95-.66,1.87-.95,2.77S16,310.12,15.72,311Z"
            fill="#fff"
          />
          <path
            d="M35.79,317.78a1.7,1.7,0,0,1-.51-.13.58.58,0,0,1-.27-.21.77.77,0,0,1-.12-.34c0-.13,0-.28,0-.47a5.22,5.22,0,0,1-3.36,1.27,4.91,4.91,0,0,1-2-.41,4.32,4.32,0,0,1-1.54-1.11,4.84,4.84,0,0,1-1-1.68,6.33,6.33,0,0,1-.33-2.07,6.22,6.22,0,0,1,.53-2.61,6.1,6.1,0,0,1,1.42-2,6.52,6.52,0,0,1,2.06-1.31,6.26,6.26,0,0,1,2.42-.48,7.15,7.15,0,0,1,1.11.1,3.9,3.9,0,0,1,1.1.34q0-1.26.06-2.34c0-.72,0-1.31,0-1.77a3.69,3.69,0,0,1,0-.66.89.89,0,0,1,.15-.38.49.49,0,0,1,.28-.18,2.63,2.63,0,0,1,.46-.07l.33,0H37l.67,0a3.45,3.45,0,0,1,.6.05,1.62,1.62,0,0,1,.82.29,1.4,1.4,0,0,1,.26,1c0,.68,0,1.57,0,2.68s-.06,2.31-.1,3.59-.11,2.58-.19,3.91-.17,2.55-.29,3.67a1.73,1.73,0,0,1-.33.95,1.32,1.32,0,0,1-.85.36,2.13,2.13,0,0,1-.46,0h-.91A1.94,1.94,0,0,1,35.79,317.78Zm-.6-8.09a5.63,5.63,0,0,0-.69-.21,3.46,3.46,0,0,0-.83-.09,2.93,2.93,0,0,0-1.24.26,3,3,0,0,0-.93.69,3.36,3.36,0,0,0-.59,1,2.78,2.78,0,0,0-.2,1,2.41,2.41,0,0,0,.47,1.57,1.8,1.8,0,0,0,1.5.59,3.46,3.46,0,0,0,2.37-1.13Z"
            fill="#fff"
          />
          <path
            d="M51.1,307.73a5.08,5.08,0,0,1,1.67-1.23,4.53,4.53,0,0,1,1.87-.4,5.33,5.33,0,0,1,1.33.17,3.11,3.11,0,0,1,1.13.58,2.91,2.91,0,0,1,.81,1,3.46,3.46,0,0,1,.3,1.52c0,.41,0,.9,0,1.45s-.05,1.14-.09,1.78-.09,1.3-.16,2-.15,1.37-.24,2a2.14,2.14,0,0,1-.22.73c-.12.22-.37.33-.77.33-.22,0-.51,0-.9-.06a7.17,7.17,0,0,1-1.08-.17.9.9,0,0,1-.73-1q0-.27.12-1.74c.09-1,.13-2.28.13-3.92a2.38,2.38,0,0,0-.14-.88.5.5,0,0,0-.5-.33,3.22,3.22,0,0,0-2,.82c0,.28,0,.57,0,.87v.95c0,.66,0,1.38,0,2.15s0,1.48-.07,2.13a1.56,1.56,0,0,1-.23.87.94.94,0,0,1-.78.28H49.32a4.43,4.43,0,0,1-.66-.05.81.81,0,0,1-.63-.35,1.53,1.53,0,0,1-.22-.78c0-.93,0-1.84,0-2.73s0-1.82-.11-2.79a2.34,2.34,0,0,0-.2-.83.5.5,0,0,0-.47-.32,2.1,2.1,0,0,0-.94.23,4.46,4.46,0,0,0-.85.56q0,1.47.09,2.88c0,.95.11,1.89.2,2.84,0,.09,0,.18,0,.25a1.93,1.93,0,0,1,0,.24.73.73,0,0,1-.24.59,1.75,1.75,0,0,1-1,.26l-.35,0h-.8l-.34,0a1.23,1.23,0,0,1-.93-.33,1.55,1.55,0,0,1-.29-.82c-.12-1.17-.22-2.35-.3-3.53s-.12-2.39-.12-3.6v-.84c0-.29,0-.56,0-.84a5.11,5.11,0,0,1,.1-.89.65.65,0,0,1,.54-.47c.19,0,.4-.08.65-.11l.75-.08c.26,0,.52,0,.79-.06l.66,0c.23,0,.39.05.46.16a.7.7,0,0,1,.12.44c0,.09,0,.18,0,.27s0,.2,0,.32a4.72,4.72,0,0,1,1.28-.74,3.57,3.57,0,0,1,1.39-.29,5,5,0,0,1,1.82.29A2.91,2.91,0,0,1,51.1,307.73Z"
            fill="#fff"
          />
          <path
            d="M62,301a5.63,5.63,0,0,1,1.09.09,1.47,1.47,0,0,1,.74.36,1.46,1.46,0,0,1,.41.72,4.49,4.49,0,0,1,.13,1.22,3.61,3.61,0,0,1-.1.82,1.54,1.54,0,0,1-.36.65,1.59,1.59,0,0,1-.72.43,4,4,0,0,1-1.19.15,4.66,4.66,0,0,1-1.08-.11,1.46,1.46,0,0,1-.7-.36,1.55,1.55,0,0,1-.38-.69,4.19,4.19,0,0,1-.12-1.1,2.32,2.32,0,0,1,.52-1.64A2.38,2.38,0,0,1,62,301Zm-1.88,6.94a3.49,3.49,0,0,1,.13-.88.65.65,0,0,1,.58-.43,5.35,5.35,0,0,1,.88-.12c.33,0,.66,0,1,0h.39l.37,0c.23,0,.37.09.42.2a1.84,1.84,0,0,1,.09.72c0,1.65,0,3.18-.06,4.61s-.11,2.92-.22,4.45c0,.23,0,.43-.06.59a.69.69,0,0,1-.16.39.72.72,0,0,1-.36.22,2.24,2.24,0,0,1-.66.07,10.69,10.69,0,0,1-1.27-.07c-.47-.05-.78-.16-.91-.36a1.8,1.8,0,0,1-.24-.86c0-.55-.05-1.1-.07-1.64s0-1.09,0-1.62c0-.88,0-1.74,0-2.6S60.05,308.8,60.12,307.89Z"
            fill="#fff"
          />
          <path
            d="M66.07,307.71a6.31,6.31,0,0,1,.1-.89.68.68,0,0,1,.54-.47c.19,0,.4-.08.65-.11l.76-.08c.26,0,.52,0,.78-.06l.67,0a.53.53,0,0,1,.46.16.77.77,0,0,1,.11.44,2.72,2.72,0,0,1,0,.28c0,.1,0,.21,0,.34A6.43,6.43,0,0,1,75,306.2a3.43,3.43,0,0,1,1.16.44,2.62,2.62,0,0,1,.93,1,3.54,3.54,0,0,1,.38,1.76c0,.41,0,.9,0,1.45s-.06,1.14-.1,1.78-.09,1.3-.16,2-.15,1.37-.24,2a1.94,1.94,0,0,1-.22.73c-.11.22-.37.33-.77.33a9.09,9.09,0,0,1-.91-.06,7.24,7.24,0,0,1-1.07-.17.9.9,0,0,1-.73-1q0-.25,0-.63c0-.26.06-.6.1-1s.06-1,.09-1.6,0-1.45,0-2.4a1.55,1.55,0,0,0-.22-.88.72.72,0,0,0-.65-.33,3.91,3.91,0,0,0-1.22.21,5.67,5.67,0,0,0-1.31.68c0,1,0,2,.08,2.94s.13,1.94.22,2.9c0,.09,0,.18,0,.25a1.93,1.93,0,0,1,0,.24.73.73,0,0,1-.24.59,1.72,1.72,0,0,1-1,.26l-.35,0H68l-.35,0a1.25,1.25,0,0,1-.93-.33,1.64,1.64,0,0,1-.29-.82c-.12-1.17-.22-2.35-.3-3.56s-.11-2.4-.11-3.6v-.82C66.05,308.26,66.06,308,66.07,307.71Z"
            fill="#fff"
          />
          <path
            d="M84.1,310.72a10,10,0,0,1,.71-3.76,9.14,9.14,0,0,1,2-3,9.5,9.5,0,0,1,2.95-2,9,9,0,0,1,3.67-.75,11.89,11.89,0,0,1,1.79.14l.14-.41a.77.77,0,0,1,.76-.6,4.59,4.59,0,0,1,1.08.18,8.59,8.59,0,0,1,1.27.46.83.83,0,0,1,.48.81,2,2,0,0,1-.05.34c-.09.48-.2,1-.34,1.53s-.29,1.1-.45,1.66-.32,1.1-.48,1.64-.32,1-.47,1.47a1.28,1.28,0,0,1-.32.57.81.81,0,0,1-.54.17h-.16l-.3,0c-.21,0-.45-.07-.72-.13a7,7,0,0,1-.82-.26.92.92,0,0,1-.54-.43,1.19,1.19,0,0,1-.15-.51.77.77,0,0,1,0-.15c0-.05,0-.19,0-.4l.21-1c.09-.42.2-.86.32-1.32a1.58,1.58,0,0,0-.32,0H93.5a4.22,4.22,0,0,0-1.71.37,5.23,5.23,0,0,0-1.56,1,5.29,5.29,0,0,0-1.14,1.6,4.87,4.87,0,0,0-.44,2.08,4.45,4.45,0,0,0,.25,1.52,3.43,3.43,0,0,0,1.92,2,4,4,0,0,0,1.6.3,8.07,8.07,0,0,0,2.13-.31,14.37,14.37,0,0,0,2.06-.77,1.2,1.2,0,0,1,.55-.16.74.74,0,0,1,.55.36A4,4,0,0,1,98.3,314a3.73,3.73,0,0,1,.21,1.18,1.56,1.56,0,0,1-.1.57,1,1,0,0,1-.36.46,6.46,6.46,0,0,1-1.31.76,12.21,12.21,0,0,1-1.61.6,12.66,12.66,0,0,1-1.7.39,10,10,0,0,1-1.58.14,8.86,8.86,0,0,1-3-.5,7.58,7.58,0,0,1-2.47-1.43,6.72,6.72,0,0,1-1.69-2.32A7.29,7.29,0,0,1,84.1,310.72Z"
            fill="#fff"
          />
          <path
            d="M107.92,306.33a2.25,2.25,0,0,1,.47.24.58.58,0,0,1,.17.5,1.16,1.16,0,0,1,0,.17c0,.07,0,.19-.06.35a5,5,0,0,1,2.82,1.75,5.06,5.06,0,0,1,1,3.2,5,5,0,0,1-.54,2.36,5.34,5.34,0,0,1-1.41,1.71,6.1,6.1,0,0,1-2,1,6.93,6.93,0,0,1-2.19.36,9.27,9.27,0,0,1-2.72-.37,5.68,5.68,0,0,1-2.07-1.09,4.92,4.92,0,0,1-1.31-1.79,6.29,6.29,0,0,1-.46-2.45,5.77,5.77,0,0,1,.58-2.57,6.33,6.33,0,0,1,1.49-2,6.79,6.79,0,0,1,2.08-1.25,6.5,6.5,0,0,1,2.36-.45,5.42,5.42,0,0,1,.86.07A5.84,5.84,0,0,1,107.92,306.33Zm-.71,4.41a2.7,2.7,0,0,1-.45-.17.78.78,0,0,1-.29-.21.74.74,0,0,1-.17-.33,2,2,0,0,1-.06-.55,3,3,0,0,0-1.95.93,2.85,2.85,0,0,0-.79,2,2,2,0,0,0,.2.9,1.9,1.9,0,0,0,.54.68,2.4,2.4,0,0,0,.79.42,3.32,3.32,0,0,0,1,.13,3.4,3.4,0,0,0,1-.13,2.7,2.7,0,0,0,.85-.42,2,2,0,0,0,.61-.68,1.7,1.7,0,0,0,.23-.9,1.57,1.57,0,0,0-.39-1.1A2.25,2.25,0,0,0,107.21,310.74Z"
            fill="#fff"
          />
          <path
            d="M113.81,307.71a4.29,4.29,0,0,1,.1-.89.65.65,0,0,1,.54-.47c.18,0,.4-.08.64-.11l.76-.08c.26,0,.52,0,.78-.06l.67,0a.53.53,0,0,1,.46.16.7.7,0,0,1,.11.44c0,.09,0,.2,0,.33a3.27,3.27,0,0,1,0,.35,5.7,5.7,0,0,1,1.44-.92,4.25,4.25,0,0,1,1.71-.34,1.11,1.11,0,0,1,1,.51,3,3,0,0,1,.46,1.08,6.74,6.74,0,0,1,.13,1.16c0,.42,0,.78,0,1.09a1.46,1.46,0,0,1-.25.84,2.53,2.53,0,0,1-.88.75c-.2.1-.45.21-.76.33a2.36,2.36,0,0,1-.74.17.64.64,0,0,1-.59-.33,1.32,1.32,0,0,1-.21-.73c0-.16,0-.39,0-.66a4,4,0,0,0-.1-.71,5.94,5.94,0,0,0-1.24.8c0,.83,0,1.61.06,2.33s.08,1.38.12,1.93.07,1,.11,1.41.06.62.06.75a.73.73,0,0,1-.24.59,1.75,1.75,0,0,1-1,.26l-.36,0h-.79l-.35,0a1.27,1.27,0,0,1-.93-.33,1.64,1.64,0,0,1-.28-.82c-.13-1.17-.23-2.35-.3-3.56s-.12-2.4-.12-3.6v-.82C113.78,308.26,113.79,308,113.81,307.71Z"
            fill="#fff"
          />
          <path
            d="M123.81,307.71a5.11,5.11,0,0,1,.1-.89.65.65,0,0,1,.54-.47c.19,0,.4-.08.64-.11l.76-.08c.26,0,.52,0,.79-.06l.66,0c.23,0,.39.05.46.16a.7.7,0,0,1,.12.44c0,.09,0,.18,0,.28s0,.21,0,.34a6.49,6.49,0,0,1,3.77-1.2,6.39,6.39,0,0,1,1.09.1,3.4,3.4,0,0,1,1.17.44,2.79,2.79,0,0,1,.93,1,3.54,3.54,0,0,1,.38,1.76c0,.41,0,.9,0,1.45s0,1.14-.09,1.78-.09,1.3-.16,2-.15,1.37-.24,2a2.14,2.14,0,0,1-.22.73c-.12.22-.37.33-.77.33a9.09,9.09,0,0,1-.91-.06,7,7,0,0,1-1.07-.17.9.9,0,0,1-.73-1q0-.25,0-.63c0-.26.05-.6.09-1s.07-1,.09-1.6,0-1.45,0-2.4a1.55,1.55,0,0,0-.22-.88.74.74,0,0,0-.66-.33,3.9,3.9,0,0,0-1.21.21,5.67,5.67,0,0,0-1.31.68c0,1,0,2,.08,2.94s.12,1.94.21,2.9c0,.09,0,.18,0,.25a1.93,1.93,0,0,1,0,.24.73.73,0,0,1-.24.59,1.75,1.75,0,0,1-1,.26l-.35,0h-.8l-.34,0a1.23,1.23,0,0,1-.93-.33,1.55,1.55,0,0,1-.29-.82c-.12-1.17-.22-2.35-.3-3.56s-.12-2.4-.12-3.6v-.82C123.78,308.26,123.79,308,123.81,307.71Z"
            fill="#fff"
          />
          <path
            d="M147.33,312.24a10.79,10.79,0,0,1-1.4.39c-.55.12-1.14.23-1.76.32s-1.27.17-1.93.24-1.31.12-1.92.15a3.13,3.13,0,0,0,1.18.84,3.77,3.77,0,0,0,1.53.31,7.38,7.38,0,0,0,2.87-.66,1.72,1.72,0,0,1,.49-.17.32.32,0,0,1,.27.13,1.66,1.66,0,0,1,.19.38,4.91,4.91,0,0,1,.15.51c0,.17.07.33.1.5a.79.79,0,0,1,.05.24v.22a1.07,1.07,0,0,1-.37.78,4.76,4.76,0,0,1-1.95,1.07,9.07,9.07,0,0,1-2.81.41,5.74,5.74,0,0,1-2.17-.42,5.35,5.35,0,0,1-1.84-1.17,5.81,5.81,0,0,1-1.28-1.82,5.64,5.64,0,0,1-.48-2.37,5.84,5.84,0,0,1,.49-2.41,6,6,0,0,1,1.32-1.9,6,6,0,0,1,4.19-1.66,5.74,5.74,0,0,1,2.68.57,5.24,5.24,0,0,1,1.74,1.4,5.49,5.49,0,0,1,1,1.73,5.14,5.14,0,0,1,.28,1.52,1,1,0,0,1-.11.5A.84.84,0,0,1,147.33,312.24Zm-5-2.92a2.57,2.57,0,0,0-1.5.48,2.43,2.43,0,0,0-.94,1.22c.69,0,1.42-.08,2.18-.14a14.13,14.13,0,0,0,2.12-.32,1.72,1.72,0,0,0-.79-.95A2.3,2.3,0,0,0,142.32,309.32Z"
            fill="#fff"
          />
          <path
            d="M149.08,307.71a5.11,5.11,0,0,1,.1-.89.65.65,0,0,1,.54-.47c.19,0,.4-.08.64-.11l.76-.08c.26,0,.52,0,.79-.06l.66,0c.23,0,.39.05.46.16a.7.7,0,0,1,.12.44c0,.09,0,.2,0,.33a3.09,3.09,0,0,1,0,.35,5.7,5.7,0,0,1,1.44-.92,4.25,4.25,0,0,1,1.71-.34,1.1,1.1,0,0,1,1,.51,2.87,2.87,0,0,1,.46,1.08,7.84,7.84,0,0,1,.14,1.16c0,.42,0,.78,0,1.09a1.53,1.53,0,0,1-.24.84,2.58,2.58,0,0,1-.89.75c-.2.1-.45.21-.76.33a2.31,2.31,0,0,1-.73.17.67.67,0,0,1-.6-.33,1.32,1.32,0,0,1-.21-.73c0-.16,0-.39,0-.66a5.44,5.44,0,0,0-.09-.71,5.39,5.39,0,0,0-.59.32,5.24,5.24,0,0,0-.65.48c0,.83,0,1.61.05,2.33s.08,1.38.12,1.93.07,1,.11,1.41.06.62.06.75a.73.73,0,0,1-.24.59,1.75,1.75,0,0,1-1,.26l-.35,0H151l-.34,0a1.23,1.23,0,0,1-.93-.33,1.55,1.55,0,0,1-.29-.82c-.12-1.17-.22-2.35-.3-3.56s-.12-2.4-.12-3.6v-.82C149.05,308.26,149.06,308,149.08,307.71Z"
            fill="#fff"
          />
        </g>
      </g>
    </>
  );
};

export default StaticRooms;
